var _metadata, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoolveticaCondensedRgRegular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Thu Apr  4 10:45:55 2019\n By Aleksey,,,\n(c) 1999-2019 Typodermic Fonts Inc.\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "CoolveticaCondensedRg-Regular",
    horizAdvX: 362
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Coolvetica Condensed Rg",
    fontWeight: 400,
    fontStretch: "condensed",
    unitsPerEm: 1000,
    panose1: "2 11 6 6 3 6 2 2 0 4",
    ascent: 767,
    descent: -233,
    xHeight: 480,
    capHeight: 664,
    bbox: "-328 -233 617 956",
    underlineThickness: 20,
    underlinePosition: -163,
    unicodeRange: "U+0017-E006"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 298,
    d: "M93 0q-66 0 -66 60v544q0 60 66 60h112q66 0 66 -60v-544q0 -60 -66 -60h-112zM227 604q0 19 -22 19h-112q-23 0 -23 -19v-544q0 -20 23 -20h112q22 0 22 20v544z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 298,
    d: "M93 0q-66 0 -66 60v544q0 60 66 60h112q66 0 66 -60v-544q0 -60 -66 -60h-112zM227 604q0 19 -22 19h-112q-23 0 -23 -19v-544q0 -20 23 -20h112q22 0 22 20v544z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0017",
    horizAdvX: 118
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 118
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 167,
    d: "M39 0v120h87v-120h-87zM52 194q-7 67 -11.5 136.5t-4.5 142.5v191h95v-162q0 -81 -4 -158t-12 -150h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 241,
    d: "M27 428zM27 428v244h69v-244h-69zM144 428v244h69v-244h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 393,
    d: "M70 0l17 204h-56l5 61h56l11 139h-57l5 61h57l17 199h63l-16 -199h71l17 199h62l-16 -199h58l-6 -61h-57l-12 -139h60l-7 -61h-58l-16 -204h-64l17 204h-71l-16 -204h-64zM155 265h71l12 139h-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 383,
    d: "M155 -60v68q-67 8 -97.5 49t-30.5 120v22h85v-34q0 -41 17.5 -60.5t57.5 -19.5q44 0 59.5 23.5t15.5 61.5v23q0 21 -9.5 38t-26.5 31q-25 21 -61.5 41.5t-70.5 51.5q-26 24 -45 55t-19 70v31q0 130 125 145v74h69v-74q35 -5 58.5 -19.5t37 -37.5t19 -53t5.5 -66v-12h-84 v32q0 36 -16.5 57t-54.5 21q-36 0 -53 -19t-17 -48v-22q0 -19 8 -35t37 -38q37 -29 73.5 -48t67.5 -48q25 -23 38 -50.5t13 -71.5v-29q0 -72 -31.5 -113t-100.5 -49v-67h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 398,
    d: "M14 0zM60 -19l225 702h55l-225 -702h-55zM172 438q0 -54 -20 -79.5t-58 -25.5q-80 0 -80 107v121q0 106 80 106q38 0 58 -26t20 -80v-123zM124 562q0 60 -31 60q-30 0 -30 -60v-124q0 -60 31 -60q30 0 30 60v124zM384 102q0 -54 -20 -79.5t-58 -25.5q-80 0 -80 107v121 q0 106 80 106q38 0 58 -26t20 -80v-123zM336 226q0 60 -31 60q-30 0 -30 -60v-124q0 -60 31 -60q30 0 30 60v124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 360,
    d: "M27 238q0 55 24 81.5t56 32.5v4q-70 12 -70 107v56q0 27 8.5 53t26.5 46.5t46 33t67 12.5h39v-84h-38q-35 0 -50.5 -20.5t-15.5 -49.5v-56q0 -33 13.5 -49.5t54.5 -16.5h34v-75h-37q-39 0 -54 -18t-15 -51v-88q0 -79 73 -79q41 0 55 25t14 74v212h79v-228q0 -84 -39 -125 t-114 -41q-78 0 -117.5 43.5t-39.5 124.5v76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 123,
    d: "M27 428v244h69v-244h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 230,
    d: "M148 -143q-24 42 -43 94t-32 109.5t-20 118t-7 119.5q0 57 6.5 116t19.5 114.5t32 106.5t44 93h64q-44 -94 -66.5 -206.5t-22.5 -224.5t22.5 -227.5t66.5 -212.5h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 230,
    d: "M19 -143q44 97 66.5 212.5t22.5 227.5t-22.5 224.5t-66.5 206.5h63q25 -42 44.5 -93t32.5 -106.5t19.5 -114.5t6.5 -116q0 -59 -7 -119.5t-20 -118t-32 -109.5t-44 -94h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 332,
    d: "M237 377l-72 95l-69 -95l-42 29l70 98l-110 36l15 46l109 -35v121h54v-121l109 35l17 -46l-111 -36l70 -98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 344,
    d: "M137 188v113h-110v68h110v108h68v-108h111v-68h-111v-113h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 142,
    d: "M27 -113q20 12 29.5 31.5t9.5 52.5v29h-39v120h88v-138q0 -65 -22 -100t-66 -47v52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 176,
    d: "M22 265v75h131v-75h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "\xAD",
    horizAdvX: 176,
    d: "M22 265v75h131v-75h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 142,
    d: "M27 0v120h88v-120h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 216,
    d: "M7 0l130 664h72l-130 -664h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 370,
    d: "M342 205q0 -108 -40 -159.5t-115 -51.5q-78 0 -119 54.5t-41 158.5v250q0 104 41 158.5t119 54.5q75 0 115 -52t40 -159v-254zM254 460q0 127 -69 127t-69 -128v-254q0 -128 69 -128t69 127v256z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 198,
    d: "M85 0v525h-66v71q22 0 36 3.5t22.5 11.5t12.5 21t6 32h75v-664h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 357,
    d: "M27 0v107q0 49 10 82t38 65q16 18 36 36t40.5 35t39 33t31.5 31q17 19 22 38t5 48v37q0 38 -14 56t-53 18q-41 0 -54 -20.5t-13 -60.5v-46h-84v38q0 43 5 75t21.5 54t46 33t79.5 11q46 0 75 -9.5t46 -28.5t23.5 -48.5t6.5 -68.5v-44q0 -44 -10.5 -71t-31.5 -51 q-14 -15 -33.5 -32.5t-40 -35t-38.5 -34.5t-30 -30q-23 -26 -28.5 -49t-5.5 -43v-46h219v-79h-308z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 357,
    d: "M337 162q0 -81 -39.5 -124.5t-117.5 -43.5q-75 0 -114 41t-39 125v33h85v-38q0 -78 66 -78q70 0 70 79v88q0 33 -16.5 51t-58.5 18h-42v75h45q41 0 54.5 18.5t13.5 47.5v62q0 29 -15.5 49.5t-50.5 20.5q-32 0 -49 -19.5t-17 -51.5v-39h-85v31q0 75 40 119t112 44 q39 0 67 -12.5t46 -33t26.5 -46.5t8.5 -53v-62q0 -46 -18 -73.5t-52 -33.5v-4q16 -3 30.5 -11t25.5 -21.5t17.5 -33.5t6.5 -48v-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: "\u0417",
    horizAdvX: 357,
    d: "M337 162q0 -81 -39.5 -124.5t-117.5 -43.5q-75 0 -114 41t-39 125v33h85v-38q0 -78 66 -78q70 0 70 79v88q0 33 -16.5 51t-58.5 18h-42v75h45q41 0 54.5 18.5t13.5 47.5v62q0 29 -15.5 49.5t-50.5 20.5q-32 0 -49 -19.5t-17 -51.5v-39h-85v31q0 75 40 119t112 44 q39 0 67 -12.5t46 -33t26.5 -46.5t8.5 -53v-62q0 -46 -18 -73.5t-52 -33.5v-4q16 -3 30.5 -11t25.5 -21.5t17.5 -33.5t6.5 -48v-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 364,
    d: "M214 540h-4l-131 -304h135v304zM212 0v161h-193v73l174 430h105v-428h47v-75h-47v-161h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 363,
    d: "M336 162q0 -81 -39 -124.5t-117 -43.5q-29 0 -56 7t-49 25.5t-35 50.5t-13 81v13h85v-17q0 -44 20 -60.5t47 -16.5q68 0 68 79v122q0 40 -17.5 53.5t-45.5 13.5q-26 0 -41.5 -8.5t-26.5 -22.5h-88l15 350h273v-79h-196l-10 -202h4q14 16 37 27.5t63 11.5q25 0 47.5 -6.5 t39 -22t26 -41.5t9.5 -66v-124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 363,
    d: "M336 160q0 -85 -39 -125.5t-114 -40.5q-78 0 -117 43.5t-39 124.5v337q0 82 39.5 126.5t117.5 44.5q73 0 112.5 -39t39.5 -114v-20h-85v16q0 73 -66 73q-69 0 -69 -80v-144h4q14 26 40 45t66 19q50 0 80 -31.5t30 -88.5v-146zM251 286q0 33 -15.5 49t-42.5 16 q-58 0 -77 -63v-132q0 -79 68 -79q67 0 67 78v131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 301,
    d: "M71 0q1 42 8 92t17.5 104t24 109t28 106t28.5 95t27 77h-185v81h264v-72q-20 -54 -42 -129t-40.5 -156.5t-30.5 -162t-12 -144.5h-87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 356,
    d: "M243 516q0 29 -15.5 49.5t-49.5 20.5t-49.5 -20.5t-15.5 -49.5v-62q0 -29 12.5 -47.5t52.5 -18.5t52.5 18.5t12.5 47.5v62zM248 247q0 32 -15.5 49t-54.5 17t-54.5 -17t-15.5 -49v-91q0 -79 70 -79t70 79v91zM336 162q0 -82 -39.5 -125t-118.5 -43t-118.5 43t-39.5 125 v76q0 54 24 81t56 33v4q-70 12 -70 107v62q0 27 8.5 53t26.5 46.5t46 33t67 12.5t67 -12.5t46 -33t26.5 -46.5t8.5 -53v-62q0 -95 -70 -107v-4q32 -6 56 -33t24 -81v-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 363,
    d: "M247 318h-4q-14 -26 -40 -45t-66 -19q-50 0 -80 31.5t-30 88.5v130q0 85 39 125.5t114 40.5q78 0 117 -43t39 -125v-337q0 -83 -39 -127t-117 -44q-74 0 -112.5 39t-38.5 114v30h83v-26q0 -73 66 -73q69 0 69 80v160zM247 508q0 79 -68 79q-67 0 -67 -78v-115 q0 -65 58 -65t77 62v117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 142,
    d: "M27 5v120h88v-120h-88zM27 367v120h88v-120h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 142,
    d: "M27 367v120h88v-120h-88zM27 -109q20 13 29.5 32.5t9.5 52.5v29h-39v120h88v-138q0 -65 -22 -100t-66 -47v51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 344,
    d: "M27 296v73l289 144v-77l-214 -102v-4l214 -101v-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 344,
    d: "M27 394v68h289v-68h-289zM27 204v68h289v-68h-289z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 344,
    d: "M27 154v75l215 101v4l-215 102v77l289 -144v-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 347,
    d: "M130 0v119h87v-119h-87zM132 193v47q0 26 6 45t15 36t20 31.5t21.5 28t19 26t14.5 26.5q4 9 6.5 21t2.5 29v27q0 38 -12 57t-52 19q-23 0 -37 -6t-21 -17t-9 -26.5t-2 -34.5v-31h-84v25q0 41 4 73t19.5 54.5t46 34.5t84.5 12q48 0 77 -10t45 -30t21 -50.5t5 -71.5v-34 q0 -23 -4 -38.5t-10 -28.5q-16 -34 -39.5 -60t-39.5 -59q-7 -14 -10.5 -29t-3.5 -32v-34h-83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 468,
    d: "M386 -56q-48 -28 -143 -28q-68 0 -110 15t-65.5 44t-32 73t-8.5 102v238q0 59 8.5 103.5t31.5 74t64 44t106 14.5q63 0 103 -14t62 -43t30 -73t8 -103v-198q0 -55 -24.5 -82.5t-70.5 -27.5q-26 0 -40 9.5t-20 27.5h-4q-13 -21 -28.5 -29t-36.5 -8q-45 0 -58 29.5 t-13 89.5v141q0 30 2 53t9.5 38.5t20.5 24t36 8.5q26 0 41.5 -10t23.5 -28h3l4 33h41v-301q0 -13 7 -21.5t21 -8.5q30 0 30 46v213q0 46 -4.5 79.5t-19.5 55.5t-44 33t-78 11q-51 0 -81 -11.5t-46 -34t-20.5 -56.5t-4.5 -79v-238q0 -44 4.5 -76t20.5 -54t47.5 -32.5 t85.5 -10.5q71 0 122 19zM199 176q0 -22 8.5 -31t25.5 -9q19 0 31 13t12 45v164q0 58 -41 58q-36 0 -36 -41v-199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 372,
    d: "M271 0l-26 156h-122l-24 -156h-87l113 664h121l113 -664h-88zM135 233h98l-47 291h-4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "\u0410",
    horizAdvX: 372,
    d: "M271 0l-26 156h-122l-24 -156h-87l113 664h121l113 -664h-88zM135 233h98l-47 291h-4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "\u0391",
    horizAdvX: 372,
    d: "M271 0l-26 156h-122l-24 -156h-87l113 664h121l113 -664h-88zM135 233h98l-47 291h-4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 364,
    d: "M27 0v664h181q69 0 97.5 -35t28.5 -98v-68q0 -93 -67 -109v-4q38 -7 57 -31.5t19 -78.5v-126q0 -57 -27.5 -85.5t-94.5 -28.5h-194zM254 246q0 35 -14.5 50t-48.5 15h-76v-233h79q32 0 46 16t14 48v104zM250 518q0 34 -12.5 51t-46.5 17h-76v-200h77q26 0 42 15t16 53v64 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "\u0412",
    horizAdvX: 364,
    d: "M27 0v664h181q69 0 97.5 -35t28.5 -98v-68q0 -93 -67 -109v-4q38 -7 57 -31.5t19 -78.5v-126q0 -57 -27.5 -85.5t-94.5 -28.5h-194zM254 246q0 35 -14.5 50t-48.5 15h-76v-233h79q32 0 46 16t14 48v104zM250 518q0 34 -12.5 51t-46.5 17h-76v-200h77q26 0 42 15t16 53v64 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "\u0392",
    horizAdvX: 364,
    d: "M27 0v664h181q69 0 97.5 -35t28.5 -98v-68q0 -93 -67 -109v-4q38 -7 57 -31.5t19 -78.5v-126q0 -57 -27.5 -85.5t-94.5 -28.5h-194zM254 246q0 35 -14.5 50t-48.5 15h-76v-233h79q32 0 46 16t14 48v104zM250 518q0 34 -12.5 51t-46.5 17h-76v-200h77q26 0 42 15t16 53v64 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 363,
    d: "M251 271h85v-111q0 -84 -39 -125t-114 -41q-78 0 -117 43.5t-39 124.5v342q0 84 39 125t114 41q76 0 116 -41t40 -124v-79h-85v79q0 39 -17 60t-51 21q-67 0 -67 -80v-351q0 -38 16 -58t51 -20q68 0 68 78v116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "\u0421",
    horizAdvX: 363,
    d: "M251 271h85v-111q0 -84 -39 -125t-114 -41q-78 0 -117 43.5t-39 124.5v342q0 84 39 125t114 41q76 0 116 -41t40 -124v-79h-85v79q0 39 -17 60t-51 21q-67 0 -67 -80v-351q0 -38 16 -58t51 -20q68 0 68 78v116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 370,
    d: "M27 0v664h164q151 0 151 -153v-349q0 -83 -38 -122.5t-113 -39.5h-164zM185 81q41 0 54.5 28t13.5 78v292q0 48 -14.5 76t-58.5 28h-65v-502h70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 292,
    d: "M27 0v664h240v-81h-152v-194h139v-82h-139v-226h160v-81h-248z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "\u0415",
    horizAdvX: 292,
    d: "M27 0v664h240v-81h-152v-194h139v-82h-139v-226h160v-81h-248z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "\u0395",
    horizAdvX: 292,
    d: "M27 0v664h240v-81h-152v-194h139v-82h-139v-226h160v-81h-248z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 291,
    d: "M27 0v664h245v-81h-155v-204h134v-80h-134v-299h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 363,
    d: "M277 0l-4 51h-4q-13 -24 -35 -40.5t-65 -16.5q-68 0 -105 43.5t-37 124.5v337q0 81 39.5 126t114.5 45q76 0 115.5 -46t39.5 -127v-38h-85v46q0 39 -17 60t-51 21q-67 0 -67 -80v-350q0 -79 65 -79q58 0 70 67v131h-75v80h160v-355h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 374,
    d: "M257 0v312h-140v-312h-90v664h90v-272h140v272h89v-664h-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "\u041D",
    horizAdvX: 374,
    d: "M257 0v312h-140v-312h-90v664h90v-272h140v272h89v-664h-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "\u0397",
    horizAdvX: 374,
    d: "M257 0v312h-140v-312h-90v664h90v-272h140v272h89v-664h-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 144,
    d: "M27 0v664h90v-664h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "\u04CF",
    horizAdvX: 144,
    d: "M27 0v664h90v-664h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "\u04C0",
    horizAdvX: 144,
    d: "M27 0v664h90v-664h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "\u0406",
    horizAdvX: 144,
    d: "M27 0v664h90v-664h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "\u0399",
    horizAdvX: 144,
    d: "M27 0v664h90v-664h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 355,
    d: "M240 664h88v-502q0 -81 -39 -124.5t-117 -43.5q-152 0 -152 166v81h84v-86q0 -78 67 -78q69 0 69 79v508z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "\u0408",
    horizAdvX: 355,
    d: "M240 664h88v-502q0 -81 -39 -124.5t-117 -43.5q-152 0 -152 166v81h84v-86q0 -78 67 -78q69 0 69 79v508z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 368,
    d: "M265 0l-95 287h-4l-48 -94v-193h-91v664h91v-298h4l144 298h91l-125 -263l124 -401h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "\u041A",
    horizAdvX: 368,
    d: "M265 0l-95 287h-4l-48 -94v-193h-91v664h91v-298h4l144 298h91l-125 -263l124 -401h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "\u039A",
    horizAdvX: 368,
    d: "M265 0l-95 287h-4l-48 -94v-193h-91v664h91v-298h4l144 298h91l-125 -263l124 -401h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 299,
    d: "M27 0v664h90v-582h164v-82h-254z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 523,
    d: "M416 0v367q0 61 3 144h-4l-112 -511h-83l-112 511h-4q3 -83 3 -144v-367h-80v664h136l98 -487h4l98 487h133v-664h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "\u041C",
    horizAdvX: 523,
    d: "M416 0v367q0 61 3 144h-4l-112 -511h-83l-112 511h-4q3 -83 3 -144v-367h-80v664h136l98 -487h4l98 487h133v-664h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "\u039C",
    horizAdvX: 523,
    d: "M416 0v367q0 61 3 144h-4l-112 -511h-83l-112 511h-4q3 -83 3 -144v-367h-80v664h136l98 -487h4l98 487h133v-664h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 392,
    d: "M259 0l-152 514h-4q3 -74 3 -140v-374h-79v664h118l139 -477h4q-3 94 -3 161v316h79v-664h-105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "\u039D",
    horizAdvX: 392,
    d: "M259 0l-152 514h-4q3 -74 3 -140v-374h-79v664h118l139 -477h4q-3 94 -3 161v316h79v-664h-105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    d: "M338 160q0 -84 -40.5 -125t-115.5 -41q-78 0 -118.5 43.5t-40.5 124.5v337q0 81 41.5 126t116.5 45t116 -46t41 -127v-337zM250 505q0 39 -18 60t-52 21q-32 0 -50 -20.5t-18 -59.5v-350q0 -79 69 -79q33 0 51 19t18 59v350z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "\u041E",
    d: "M338 160q0 -84 -40.5 -125t-115.5 -41q-78 0 -118.5 43.5t-40.5 124.5v337q0 81 41.5 126t116.5 45t116 -46t41 -127v-337zM250 505q0 39 -18 60t-52 21q-32 0 -50 -20.5t-18 -59.5v-350q0 -79 69 -79q33 0 51 19t18 59v350z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "\u039F",
    d: "M338 160q0 -84 -40.5 -125t-115.5 -41q-78 0 -118.5 43.5t-40.5 124.5v337q0 81 41.5 126t116.5 45t116 -46t41 -127v-337zM250 505q0 39 -18 60t-52 21q-32 0 -50 -20.5t-18 -59.5v-350q0 -79 69 -79q33 0 51 19t18 59v350z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 358,
    d: "M117 264v-264h-90v664h185q69 0 97.5 -35t28.5 -98v-134q0 -63 -28.5 -98t-97.5 -35h-95zM117 342h77q32 0 45.5 18t13.5 51v110q0 30 -13.5 46t-45.5 16h-77v-241z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "\u0420",
    horizAdvX: 358,
    d: "M117 264v-264h-90v664h185q69 0 97.5 -35t28.5 -98v-134q0 -63 -28.5 -98t-97.5 -35h-95zM117 342h77q32 0 45.5 18t13.5 51v110q0 30 -13.5 46t-45.5 16h-77v-241z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "\u03A1",
    horizAdvX: 358,
    d: "M117 264v-264h-90v664h185q69 0 97.5 -35t28.5 -98v-134q0 -63 -28.5 -98t-97.5 -35h-95zM117 342h77q32 0 45.5 18t13.5 51v110q0 30 -13.5 46t-45.5 16h-77v-241z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 361,
    d: "M338 162q0 -69 -29 -110t-91 -50v-94q0 -61 51 -61q26 0 36.5 14.5t10.5 43.5v68h80v-64q0 -68 -29 -105t-95 -37q-68 0 -99.5 40t-31.5 105v91q-60 10 -89 50.5t-29 109.5v334q0 83 39 128t120 45t118.5 -45t37.5 -128v-335zM250 504q0 39 -17 60.5t-51 21.5 q-35 0 -52.5 -21.5t-17.5 -59.5v-344q0 -79 69 -79t69 79v343z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 363,
    d: "M27 0v664h185q70 0 98 -35t28 -98v-91q0 -46 -18 -73t-50 -35v-4q35 -7 52.5 -32t17.5 -75v-221h-88v228q0 32 -12 46.5t-44 14.5h-81v-289h-88zM251 521q0 31 -13.5 46.5t-45.5 15.5h-77v-219h78q27 0 42.5 15t15.5 53v89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 375,
    d: "M256 468v38q0 37 -16.5 58.5t-54.5 21.5q-36 0 -53 -20t-17 -49v-26q0 -22 8 -37t31 -34q17 -13 37.5 -26.5t40.5 -26.5t39 -26t33 -25q23 -20 35.5 -47t12.5 -73v-41q0 -78 -38.5 -119.5t-126.5 -41.5t-126 42.5t-38 124.5v38h85v-39q0 -41 18 -62t59 -21q35 0 54 18 t19 58v30q0 15 -2 26.5t-7 21t-13.5 18t-20.5 18.5q-35 29 -71 51t-67 52q-25 26 -38 54t-13 68v29q0 66 37.5 107.5t120.5 41.5q45 0 75 -13t48 -36t25.5 -55t7.5 -69v-29h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "\u0405",
    horizAdvX: 375,
    d: "M256 468v38q0 37 -16.5 58.5t-54.5 21.5q-36 0 -53 -20t-17 -49v-26q0 -22 8 -37t31 -34q17 -13 37.5 -26.5t40.5 -26.5t39 -26t33 -25q23 -20 35.5 -47t12.5 -73v-41q0 -78 -38.5 -119.5t-126.5 -41.5t-126 42.5t-38 124.5v38h85v-39q0 -41 18 -62t59 -21q35 0 54 18 t19 58v30q0 15 -2 26.5t-7 21t-13.5 18t-20.5 18.5q-35 29 -71 51t-67 52q-25 26 -38 54t-13 68v29q0 66 37.5 107.5t120.5 41.5q45 0 75 -13t48 -36t25.5 -55t7.5 -69v-29h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 350,
    d: "M130 0v583h-111v81h313v-81h-113v-583h-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "\u0422",
    horizAdvX: 350,
    d: "M130 0v583h-111v81h313v-81h-113v-583h-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "\u03A4",
    horizAdvX: 350,
    d: "M130 0v583h-111v81h313v-81h-113v-583h-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 368,
    d: "M252 664h88v-502q0 -81 -39 -124.5t-117 -43.5q-75 0 -116 41t-41 125v504h88v-509q0 -78 68 -78q69 0 69 79v508z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 372,
    d: "M125 0l-113 664h89l84 -524h4l83 524h87l-112 -664h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 545,
    d: "M92 0l-80 664h86l58 -505h4l62 505h101l64 -505h4l57 505h85l-80 -664h-113l-66 514h-4l-65 -514h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 389,
    d: "M373 664l-124 -319l128 -345h-92l-89 248h-4l-90 -248h-90l128 336l-124 328h90l87 -236h4l88 236h88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "\u0425",
    horizAdvX: 389,
    d: "M373 664l-124 -319l128 -345h-92l-89 248h-4l-90 -248h-90l128 336l-124 328h90l87 -236h4l88 236h88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "\u03A7",
    horizAdvX: 389,
    d: "M373 664l-124 -319l128 -345h-92l-89 248h-4l-90 -248h-90l128 336l-124 328h90l87 -236h4l88 236h88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 369,
    d: "M141 0v281l-131 383h87l88 -264h4l84 264h85l-127 -384v-280h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "\u04AE",
    horizAdvX: 369,
    d: "M141 0v281l-131 383h87l88 -264h4l84 264h85l-127 -384v-280h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "\u03A5",
    horizAdvX: 369,
    d: "M141 0v281l-131 383h87l88 -264h4l84 264h85l-127 -384v-280h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 337,
    d: "M19 0v83l203 500h-201v81h292v-82l-201 -501h206v-81h-299z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "\u0396",
    horizAdvX: 337,
    d: "M19 0v83l203 500h-201v81h292v-82l-201 -501h206v-81h-299z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 230,
    d: "M49 -130v849h163v-73h-95v-704h95v-72h-163z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 216,
    d: "M137 0l-130 664h72l130 -664h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 230,
    d: "M19 -130v72h95v704h-95v73h163v-849h-163z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 344,
    d: "M136 664h73l125 -256h-78l-82 181h-4l-82 -181h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 249,
    d: "M0 -103v58h251v-58h-251z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 255,
    d: "M30 650l46 52l149 -163l-34 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 355,
    d: "M242 264q-15 -11 -28 -15t-41 -12q-42 -13 -54 -29t-12 -44v-43q0 -51 57 -51q30 0 48.5 14t29.5 43v137zM248 0l-3 61h-4q-16 -28 -41.5 -47.5t-72.5 -19.5q-57 0 -81 29t-24 78v48q0 31 7 53.5t22 38t39.5 27t59.5 21.5q16 5 32.5 9.5t29.5 10t21 13.5t8 20v20 q0 49 -62 49q-68 0 -68 -54v-31h-81v41q0 60 40.5 89.5t113.5 29.5q143 0 143 -112v-374h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "\u0430",
    horizAdvX: 355,
    d: "M242 264q-15 -11 -28 -15t-41 -12q-42 -13 -54 -29t-12 -44v-43q0 -51 57 -51q30 0 48.5 14t29.5 43v137zM248 0l-3 61h-4q-16 -28 -41.5 -47.5t-72.5 -19.5q-57 0 -81 29t-24 78v48q0 31 7 53.5t22 38t39.5 27t59.5 21.5q16 5 32.5 9.5t29.5 10t21 13.5t8 20v20 q0 49 -62 49q-68 0 -68 -54v-31h-81v41q0 60 40.5 89.5t113.5 29.5q143 0 143 -112v-374h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    d: "M246 338q0 38 -16 55t-47 17q-29 0 -44.5 -18t-26.5 -60v-186q9 -39 25.5 -57.5t46.5 -18.5q62 0 62 72v196zM29 0v672h85v-252h4q14 35 39 50.5t62 15.5q33 0 55 -11t35 -31t18.5 -47.5t5.5 -59.5v-195q0 -30 -6.5 -57t-20 -47.5t-35 -32t-52.5 -11.5q-42 0 -67 20 t-39 55h-4l-3 -69h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 354,
    d: "M243 178h82v-34q0 -75 -34.5 -112.5t-112.5 -37.5q-76 0 -112.5 36.5t-36.5 113.5v192q0 76 36.5 113t113.5 37t111.5 -37t34.5 -113v-32h-81v32q0 72 -65 72q-66 0 -66 -72v-192q0 -72 65 -72t65 72v34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "\u0441",
    horizAdvX: 354,
    d: "M243 178h82v-34q0 -75 -34.5 -112.5t-112.5 -37.5q-76 0 -112.5 36.5t-36.5 113.5v192q0 76 36.5 113t113.5 37t111.5 -37t34.5 -113v-32h-81v32q0 72 -65 72q-66 0 -66 -72v-192q0 -72 65 -72t65 72v34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    d: "M116 142q0 -38 16 -55t47 -17t46 17.5t25 62.5v181q-9 45 -23.5 62t-46.5 17q-30 0 -47 -16t-17 -56v-196zM256 0l-3 69h-4q-16 -39 -41 -57t-64 -18q-54 0 -84.5 32.5t-30.5 95.5v236q0 63 30 95.5t84 32.5q36 0 61.5 -15.5t39.5 -50.5h4v252h85v-672h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 359,
    d: "M330 144q0 -150 -152 -150q-76 0 -112.5 36.5t-36.5 113.5v192q0 76 36.5 113t113.5 37q151 0 151 -150v-119h-217v-75q0 -72 65 -72q67 0 67 72v24h85v-22zM245 338q0 72 -66 72t-66 -72v-57h132v57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "\u0435",
    horizAdvX: 359,
    d: "M330 144q0 -150 -152 -150q-76 0 -112.5 36.5t-36.5 113.5v192q0 76 36.5 113t113.5 37q151 0 151 -150v-119h-217v-75q0 -72 65 -72q67 0 67 72v24h85v-22zM245 338q0 72 -66 72t-66 -72v-57h132v57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 278,
    d: "M261 403h-98v-403h-86v403h-60v77h60v52q0 140 147 140h35v-77h-35q-61 0 -61 -63v-52h98v-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    d: "M116 170q0 -47 13.5 -69t45.5 -22q28 0 44.5 16.5t30.5 53.5v185q-8 40 -21.5 58t-48.5 18q-32 0 -48 -16t-16 -56v-168zM333 -83q0 -150 -153 -150q-77 0 -112.5 37.5t-35.5 112.5v53h82v-53q0 -72 66 -72q67 0 67 72v149h-4q-26 -66 -102 -66q-60 0 -86 39t-26 115v204 q0 57 28 92.5t85 35.5q37 0 63 -17.5t44 -57.5h4l3 69h77v-563z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 365,
    d: "M249 0v342q0 35 -16 51.5t-45 16.5q-33 0 -52 -22.5t-21 -76.5v-311h-86v672h86v-252h4q14 34 40 50t63 16q32 0 53.5 -11t35 -29.5t19.5 -42t6 -48.5v-355h-87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "\u04BB",
    horizAdvX: 365,
    d: "M249 0v342q0 35 -16 51.5t-45 16.5q-33 0 -52 -22.5t-21 -76.5v-311h-86v672h86v-252h4q14 34 40 50t63 16q32 0 53.5 -11t35 -29.5t19.5 -42t6 -48.5v-355h-87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 144,
    d: "M29 0v480h86v-480h-86zM29 539v108h86v-108h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "\u0456",
    horizAdvX: 144,
    d: "M29 0v480h86v-480h-86zM29 539v108h86v-108h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 167,
    d: "M-163 -27h82v-56q0 -72 66 -72q67 0 67 72v563h86v-563q0 -150 -152 -150q-77 0 -113 37t-36 113v56zM52 539v108h86v-108h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "\u0458",
    horizAdvX: 167,
    d: "M-163 -27h82v-56q0 -72 66 -72q67 0 67 72v563h86v-563q0 -150 -152 -150q-77 0 -113 37t-36 113v56zM52 539v108h86v-108h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 361,
    d: "M257 0l-91 206h-3l-48 -67v-139h-86v672h86v-396h4l137 204h94l-122 -190l120 -290h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 144,
    d: "M29 0v672h86v-672h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 570,
    d: "M454 0v342q0 68 -59 68q-29 0 -43.5 -16t-25.5 -54v-340h-83v342q0 68 -59 68q-29 0 -43.5 -16t-25.5 -54v-340h-86v480h80l3 -69h4q15 39 39.5 57t60.5 18q38 0 65.5 -20.5t37.5 -60.5q20 47 48 64t62 17q50 0 81 -32.5t31 -95.5v-358h-87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 365,
    d: "M249 0v342q0 68 -62 68q-30 0 -45.5 -16t-26.5 -54v-340h-86v480h80l3 -69h4q16 39 41.5 57t63.5 18q51 0 83 -32.5t32 -95.5v-358h-87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 358,
    d: "M329 144q0 -78 -36.5 -114t-113.5 -36t-113.5 36t-36.5 114v192q0 78 36.5 114t113.5 36t113.5 -36t36.5 -114v-192zM245 336q0 72 -66 72t-66 -72v-192q0 -72 66 -72t66 72v192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "\u043E",
    horizAdvX: 358,
    d: "M329 144q0 -78 -36.5 -114t-113.5 -36t-113.5 36t-36.5 114v192q0 78 36.5 114t113.5 36t113.5 -36t36.5 -114v-192zM245 336q0 72 -66 72t-66 -72v-192q0 -72 66 -72t66 72v192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "\u03BF",
    horizAdvX: 358,
    d: "M329 144q0 -78 -36.5 -114t-113.5 -36t-113.5 36t-36.5 114v192q0 78 36.5 114t113.5 36t113.5 -36t36.5 -114v-192zM245 336q0 72 -66 72t-66 -72v-192q0 -72 66 -72t66 72v192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    d: "M246 338q0 38 -16 55t-47 17q-30 0 -45 -16t-26 -54v-200q11 -38 26 -54t45 -16q31 0 47 17t16 55v196zM29 -233v713h77l3 -69h4q16 39 41 57t64 18q54 0 84.5 -32.5t30.5 -95.5v-236q0 -63 -30 -95.5t-84 -32.5q-36 0 -61.5 15.5t-39.5 50.5h-4v-293h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "\u0440",
    d: "M246 338q0 38 -16 55t-47 17q-30 0 -45 -16t-26 -54v-200q11 -38 26 -54t45 -16q31 0 47 17t16 55v196zM29 -233v713h77l3 -69h4q16 39 41 57t64 18q54 0 84.5 -32.5t30.5 -95.5v-236q0 -63 -30 -95.5t-84 -32.5q-36 0 -61.5 15.5t-39.5 50.5h-4v-293h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    d: "M531 -83q0 -76 -34 -113t-106 -37q-143 0 -143 150v143h-4q-14 -35 -39 -50.5t-63 -15.5q-62 0 -87.5 41t-25.5 114v209q0 63 30.5 95.5t84.5 32.5q39 0 64 -18t41 -57h4l3 69h77v-535q0 -55 11.5 -77.5t45.5 -22.5q31 0 45 17t14 55v56h82v-56zM116 142q0 -38 16 -55 t47 -17q29 0 44.5 16.5t26.5 55.5v196q-11 39 -26.5 55.5t-44.5 16.5q-31 0 -47 -17t-16 -55v-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 277,
    d: "M29 0v480h80l3 -82h4q14 42 40 65t64 23q21 0 40 -10v-79q-15 10 -45 10q-40 0 -64 -24t-36 -88v-295h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 353,
    d: "M242 332v28q0 26 -15 40t-49 14q-66 0 -66 -47v-15q0 -15 6.5 -24.5t28.5 -23.5q34 -21 67 -34t62 -33q25 -17 38.5 -38t13.5 -58v-22q0 -63 -35.5 -94t-112.5 -31q-82 0 -118.5 33.5t-36.5 97.5v29h82v-32q0 -29 15.5 -43t53.5 -14q35 0 51 13t16 40v19q0 15 -7.5 28 t-34.5 28q-2 1 -18.5 9.5t-37 20t-41 23.5t-31.5 20q-24 18 -33.5 39t-9.5 46v24q0 50 37.5 80.5t107.5 30.5q75 0 111.5 -35t36.5 -95v-24h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "\u0455",
    horizAdvX: 353,
    d: "M242 332v28q0 26 -15 40t-49 14q-66 0 -66 -47v-15q0 -15 6.5 -24.5t28.5 -23.5q34 -21 67 -34t62 -33q25 -17 38.5 -38t13.5 -58v-22q0 -63 -35.5 -94t-112.5 -31q-82 0 -118.5 33.5t-36.5 97.5v29h82v-32q0 -29 15.5 -43t53.5 -14q35 0 51 13t16 40v19q0 15 -7.5 28 t-34.5 28q-2 1 -18.5 9.5t-37 20t-41 23.5t-31.5 20q-24 18 -33.5 39t-9.5 46v24q0 50 37.5 80.5t107.5 30.5q75 0 111.5 -35t36.5 -95v-24h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 343,
    d: "M239 274h74v-130q0 -76 -29 -113t-105 -37q-78 0 -114 37t-36 113v469h85v-133h199v-77h-199v-259q0 -72 66 -72q32 0 45.5 17.5t13.5 54.5v130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 363,
    d: "M116 480v-336q0 -41 15 -57.5t47 -16.5t46.5 17t23.5 61v332h86v-480h-81l-2 69h-4q-17 -41 -41.5 -58t-64.5 -17q-62 0 -87 38.5t-25 112.5v335h87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 341,
    d: "M117 0l-106 480h87l74 -371h4l71 371h83l-102 -480h-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "\u03BD",
    horizAdvX: 341,
    d: "M117 0l-106 480h87l74 -371h4l71 371h83l-102 -480h-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 498,
    d: "M82 0l-72 480h80l52 -360h4l56 360h94l58 -360h4l51 360h79l-72 -480h-105l-60 367h-4l-60 -367h-105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 357,
    d: "M343 480l-113 -231l117 -249h-90l-78 168h-4l-76 -168h-89l118 244l-114 236h88l77 -160h4l74 160h86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "\u0445",
    horizAdvX: 357,
    d: "M343 480l-113 -231l117 -249h-90l-78 168h-4l-76 -168h-89l118 244l-114 236h88l77 -160h4l74 160h86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    d: "M116 151q0 -38 16.5 -55t46.5 -17q29 0 45 17t26 59v325h83v-563q0 -150 -152 -150q-77 0 -113 37t-36 113v53h82v-53q0 -72 66 -72q67 0 67 72v149h-4q-16 -37 -41 -51.5t-61 -14.5q-63 0 -87.5 34.5t-24.5 91.5v354h87v-329z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "\u0443",
    d: "M116 151q0 -38 16.5 -55t46.5 -17q29 0 45 17t26 59v325h83v-563q0 -150 -152 -150q-77 0 -113 37t-36 113v53h82v-53q0 -72 66 -72q67 0 67 72v149h-4q-16 -37 -41 -51.5t-61 -14.5q-63 0 -87.5 34.5t-24.5 91.5v354h87v-329z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 307,
    d: "M21 0v81l171 322h-170v77h261v-78l-171 -323h175v-79h-266z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 230,
    d: "M168 -131q-85 0 -85 120v210q0 61 -52 61v71q52 0 52 60v209q0 120 85 120h44v-68h-19q-42 0 -42 -52v-209q0 -74 -50 -94v-4q50 -20 50 -94v-210q0 -52 42 -52h19v-68h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 188,
    d: "M60 -125v861h68v-861h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 230,
    d: "M18 -131v68h19q42 0 42 52v210q0 74 50 94v4q-50 20 -50 94v209q0 52 -42 52h-19v68h44q85 0 85 -120v-209q0 -60 52 -60v-71q-52 0 -52 -61v-210q0 -120 -85 -120h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 344,
    d: "M236 286q-19 0 -35.5 4.5t-32 9.5t-31 9.5t-32.5 4.5q-42 0 -78 -37v73q13 13 31.5 22.5t47.5 9.5q19 0 36 -4.5t33 -9.5t31 -9.5t32 -4.5q21 0 41 8.5t37 27.5v-73q-33 -31 -80 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonbreakingspace",
    unicode: "\xA0",
    horizAdvX: 118
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 167,
    d: "M128 492v-120h-87v120h87zM115 298q7 -67 11.5 -136.5t4.5 -142.5v-191h-95v162q0 81 4 158t12 150h63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 350,
    d: "M143 -6v94q-116 15 -116 148v204q0 132 116 148v82h68v-83q59 -8 85.5 -44t26.5 -103v-32h-81v38q0 72 -65 72q-66 0 -66 -72v-216q0 -72 65 -72t65 72v40h82v-34q0 -66 -26.5 -103t-85.5 -45v-94h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    d: "M335 244h-219v-162h219v-82h-308v502q0 81 39.5 124.5t117.5 43.5q151 0 151 -166v-99h-84v104q0 78 -66 78q-69 0 -69 -79v-183h219v-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 426,
    d: "M303 200q-19 -13 -41.5 -21t-47.5 -8q-24 0 -46.5 8t-42.5 21l-51 -55l-44 44l55 51q-13 19 -21 41.5t-8 48.5q0 24 7.5 46.5t20.5 41.5l-53 51l44 43l49 -52q19 13 41.5 20.5t48.5 7.5q25 0 47.5 -8t42.5 -21l50 53l43 -43l-53 -50q13 -20 21 -42.5t8 -47.5 q0 -26 -8 -48t-21 -41l54 -51l-43 -44zM320 330q0 22 -8.5 41t-23 33t-33.5 22.5t-41 8.5t-41 -8.5t-33.5 -23t-22.5 -33.5t-8 -41t8 -41t22.5 -33.5t33.5 -22.5t41 -8t41 8.5t33.5 22.5t23 33.5t8.5 41.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 369,
    d: "M144 0v106h-98v56h98v78h-98v56h93l-129 368h85l90 -267h4l86 267h83l-125 -368h102v-56h-107v-78h107v-56h-107v-106h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 188,
    d: "M60 -125v384h68v-384h-68zM60 356v380h68v-380h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 307,
    d: "M280 -10q0 -66 -29.5 -98t-94.5 -32q-69 0 -99 34.5t-30 100.5v20h68v-31q0 -30 12.5 -45t44.5 -15q29 0 41.5 13.5t12.5 42.5v38q0 17 -5.5 29.5t-27.5 28.5q-19 13 -44 26t-47 31.5t-37.5 44.5t-15.5 67v84q0 30 12.5 54.5t35.5 38.5v12q-48 37 -48 104v18 q0 51 31 82.5t91 31.5q63 0 91.5 -35.5t28.5 -93.5v-22h-67v29q0 27 -11.5 42t-40.5 15q-28 0 -40.5 -13.5t-12.5 -35.5v-21q0 -18 5.5 -28t22.5 -24q26 -20 53.5 -33.5t49.5 -30t36 -40.5t14 -64v-99q0 -67 -29 -97v-11q29 -30 29 -87v-31zM206 311q0 26 -17 40t-49 33 q-22 -4 -31.5 -17t-9.5 -32v-94q0 -17 8.5 -29.5t22 -22t29.5 -18t30 -16.5q17 11 17 45v111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 285,
    d: "M27 539v108h80v-108h-80zM178 539v108h80v-108h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 370,
    d: "M342 160q0 -85 -40.5 -125.5t-115.5 -40.5q-78 0 -118.5 43.5t-40.5 124.5v337q0 81 41.5 126t116.5 45t116 -46t41 -127v-337zM304 497q0 64 -31 99.5t-88 35.5t-88.5 -35t-31.5 -98v-337q0 -63 30.5 -96.5t90.5 -33.5q57 0 87.5 31.5t30.5 96.5v337zM219 374v36 q0 39 -32 39q-20 0 -26.5 -13.5t-6.5 -38.5v-133q0 -25 6.5 -39t26.5 -14q32 0 32 38v54h38v-51q0 -77 -70 -77q-35 0 -53 20t-18 58v154q0 38 18 58.5t52 20.5q35 0 53 -21t18 -59v-32h-38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 239,
    d: "M154 534q-6 -5 -12 -8t-26 -9q-24 -8 -31 -16t-7 -24v-28q0 -30 32 -30q18 0 27.5 9t16.5 26v80zM158 375l-2 35h-3q-8 -15 -22.5 -27t-43.5 -12q-33 0 -48 17.5t-15 47.5v31q0 18 3.5 31t12.5 22.5t24 16.5t38 14q26 8 39 14t13 19v11q0 27 -36 27q-20 0 -28.5 -7 t-8.5 -23v-19h-52v24q0 37 24 55t69 18q87 0 87 -68v-227h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 286,
    d: "M13 184zM13 318l112 134l34 -37l-84 -97l84 -97l-34 -37zM127 318l112 134l34 -37l-84 -97l84 -97l-34 -37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 344,
    d: "M248 8v380h-221v68h289v-448h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 290,
    d: "M262 409q0 -63 -29.5 -93.5t-86.5 -30.5q-58 0 -88.5 32t-30.5 94v131q0 61 30.5 94.5t87.5 33.5t87 -34t30 -95v-132zM232 541q0 48 -22.5 73t-64.5 25t-64.5 -25t-22.5 -72v-131q0 -96 88 -96q42 0 64 23t22 71v132zM169 384v61q0 21 -21 21h-26v-82h-31v201h65 q24 0 33.5 -12t9.5 -35v-22q0 -32 -22 -35v-3q23 -4 23 -35v-59h-31zM168 535q0 22 -19 22h-27v-64h26q20 0 20 20v22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 289,
    d: "M27 562v55h234v-55h-234z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 177,
    d: "M88 517q-39 0 -55.5 23t-16.5 55q0 33 16.5 55t55.5 22t56 -22t17 -55q0 -32 -17 -55t-56 -23zM88 553q20 0 28.5 12t8.5 30t-8.5 30t-28.5 12t-28 -12t-8 -30t8 -30t28 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 344,
    d: "M27 25zM137 188v113h-110v68h110v108h68v-108h111v-68h-111v-113h-68zM27 25v68h289v-68h-289z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 204,
    d: "M26 336zM26 336v53q0 23 5.5 41t21.5 35q15 17 35 31.5t32 29.5q7 9 10.5 18.5t3.5 26.5v18q0 18 -6 25.5t-23 7.5q-18 0 -24 -8.5t-6 -28.5v-24h-47v21q0 21 2.5 37t11 26.5t23.5 16t40 5.5q46 0 60.5 -18.5t14.5 -58.5v-20q0 -21 -4.5 -37.5t-18.5 -30.5 q-11 -13 -31.5 -29t-33.5 -30q-11 -11 -14 -20.5t-3 -24.5v-19h105v-43h-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 204,
    d: "M26 333zM181 414q0 -81 -77 -81q-78 0 -78 88v12h47v-14q0 -23 6.5 -32t23.5 -9q16 0 23 7.5t7 25.5v39q0 18 -7.5 27.5t-26.5 9.5h-21v41h23q19 0 24.5 9t5.5 26v24q0 18 -6 26t-22 8q-17 0 -23.5 -8.5t-6.5 -28.5v-14h-47v11q0 42 19.5 64t57.5 22t55.5 -22t17.5 -54 v-24q0 -48 -34 -57v-2q15 -4 27 -17t12 -44v-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 255,
    d: "M64 504l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 366,
    d: "M255 -100v693h-91v-693h-72v540q-72 10 -72 78v70q0 76 100 76h234l-28 -72v-692h-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 142,
    d: "M27 273v120h88v-120h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 133,
    d: "M28 -182q19 6 28.5 17.5t9.5 35.5v15h-38v96h77v-90q0 -54 -18 -81.5t-59 -34.5v42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 139,
    d: "M22 336zM65 336v250h-43v39q29 0 37.5 8.5t10.5 30.5h42v-328h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 236,
    d: "M206 463q0 -48 -22 -69.5t-69 -21.5t-68.5 21.5t-21.5 69.5v116q0 48 21.5 69.5t68.5 21.5t69 -21.5t22 -69.5v-116zM152 579q0 23 -9.5 32t-27.5 9q-19 0 -28 -9t-9 -32v-116q0 -23 9 -32.5t28 -9.5q18 0 27.5 9.5t9.5 32.5v116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 286,
    d: "M13 184zM13 221l84 98l-84 96l34 37l112 -133l-112 -135zM127 221l84 98l-84 96l34 37l112 -133l-112 -135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 398,
    d: "M29 0zM47 -19l225 702h55l-225 -702h-55zM72 336v250h-43v39q29 0 37.5 8.5t10.5 30.5h42v-328h-47zM297 258h-2l-56 -148h58v148zM297 0v68h-93v41l82 219h58v-218h24v-42h-24v-68h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 398,
    d: "M18 0zM39 -19l225 702h55l-225 -702h-55zM61 336v250h-43v39q29 0 37.5 8.5t10.5 30.5h42v-328h-47zM225 0v53q0 23 5.5 41t21.5 35q15 17 35 31.5t32 29.5q7 9 10.5 18.5t3.5 26.5v18q0 18 -6 25.5t-23 7.5q-18 0 -24 -8.5t-6 -28.5v-24h-47v21q0 21 2.5 37t11 26.5 t23.5 16t40 5.5q46 0 60.5 -18.5t14.5 -58.5v-20q0 -21 -4.5 -37.5t-18.5 -30.5q-11 -13 -31.5 -29t-33.5 -30q-11 -11 -14 -20.5t-3 -24.5v-19h105v-43h-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 398,
    d: "M18 0zM71 -19l225 702h55l-225 -702h-55zM308 258h-2l-56 -148h58v148zM308 0v68h-93v41l82 219h58v-218h24v-42h-24v-68h-47zM173 414q0 -81 -77 -81q-78 0 -78 88v12h47v-14q0 -23 6.5 -32t23.5 -9q16 0 23 7.5t7 25.5v39q0 18 -7.5 27.5t-26.5 9.5h-21v41h23 q19 0 24.5 9t5.5 26v24q0 18 -6 26t-22 8q-17 0 -23.5 -8.5t-6.5 -28.5v-14h-47v11q0 42 19.5 64t57.5 22t55.5 -22t17.5 -54v-24q0 -48 -34 -57v-2q15 -4 27 -17t12 -44v-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 347,
    d: "M217 492v-119h-88v119h88zM214 299v-47q0 -26 -6 -45t-15 -36t-20 -31.5t-21.5 -28t-19 -26t-14.5 -26.5q-4 -9 -6.5 -21t-2.5 -29v-27q0 -38 12 -57t52 -19q23 0 37 6t21 17t9 26.5t2 34.5v31h84v-25q0 -41 -4 -73t-19.5 -54.5t-46 -34.5t-84.5 -12q-48 0 -77 10t-45 30 t-21 50.5t-5 71.5v34q0 20 4 36.5t10 30.5q7 15 17.5 29.5t21.5 29t21.5 29t18.5 31.5q7 14 10.5 29t3.5 32v34h83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 372,
    d: "M12 0zM271 0l-26 156h-122l-24 -156h-87l113 664h121l113 -664h-88zM135 233h98l-47 291h-4zM67 823l46 52l149 -163l-34 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 372,
    d: "M12 0zM271 0l-26 156h-122l-24 -156h-87l113 664h121l113 -664h-88zM135 233h98l-47 291h-4zM141 677l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 372,
    d: "M12 0zM271 0l-26 156h-122l-24 -156h-87l113 664h121l113 -664h-88zM135 233h98l-47 291h-4zM276 678l-94 108l-94 -108l-38 30l92 129h79l93 -129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 372,
    d: "M12 0zM271 0l-26 156h-122l-24 -156h-87l113 664h121l113 -664h-88zM135 233h98l-47 291h-4zM320 761q-8 -31 -27.5 -45t-45.5 -14q-17 0 -31.5 5t-28.5 11.5t-28.5 11.5t-30.5 5q-14 0 -23.5 -6t-16.5 -23l-39 23q9 31 28 45t45 14q16 0 31 -5t29 -11.5t28.5 -11.5 t30.5 -5q14 0 24 6t16 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 372,
    d: "M12 0zM271 0l-26 156h-122l-24 -156h-87l113 664h121l113 -664h-88zM135 233h98l-47 291h-4zM70 712v108h80v-108h-80zM221 712v108h80v-108h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 372,
    d: "M12 0zM271 0l-26 156h-122l-24 -156h-87l113 664h121l113 -664h-88zM135 233h98l-47 291h-4zM185 715q47 0 47 55q0 27 -12 42t-35 15t-35 -15t-12 -42q0 -55 47 -55zM185 677q-44 0 -65 24.5t-21 68.5q0 45 21 69.5t65 24.5q43 0 64 -24.5t21 -69.5q0 -44 -21 -68.5 t-64 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 499,
    d: "M236 0v156h-113l-24 -156h-87l113 664h349v-81h-150v-194h137v-82h-137v-226h158v-81h-246zM134 233h102v350h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 363,
    d: "M27 0zM251 271h85v-111q0 -84 -39 -125t-114 -41q-78 0 -117 43.5t-39 124.5v342q0 84 39 125t114 41q76 0 116 -41t40 -124v-79h-85v79q0 39 -17 60t-51 21q-67 0 -67 -80v-351q0 -38 16 -58t51 -20q68 0 68 78v116zM140 -182q19 6 28.5 17.5t9.5 35.5v15h-38v96h77v-90 q0 -54 -18 -81.5t-59 -34.5v42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 292,
    d: "M27 0zM27 0v664h240v-81h-152v-194h139v-82h-139v-226h160v-81h-248zM33 823l46 52l149 -163l-34 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\u0400",
    horizAdvX: 292,
    d: "M27 0zM27 0v664h240v-81h-152v-194h139v-82h-139v-226h160v-81h-248zM33 823l46 52l149 -163l-34 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 292,
    d: "M27 0zM27 0v664h240v-81h-152v-194h139v-82h-139v-226h160v-81h-248zM106 677l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 292,
    d: "M17 0zM27 0v664h240v-81h-152v-194h139v-82h-139v-226h160v-81h-248zM243 678l-94 108l-94 -108l-38 30l92 129h79l93 -129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 292,
    d: "M27 0zM27 0v664h240v-81h-152v-194h139v-82h-139v-226h160v-81h-248zM32 712v108h80v-108h-80zM183 712v108h80v-108h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\u0401",
    horizAdvX: 292,
    d: "M27 0zM27 0v664h240v-81h-152v-194h139v-82h-139v-226h160v-81h-248zM32 712v108h80v-108h-80zM183 712v108h80v-108h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 165,
    d: "M0 0zM48 0v664h90v-664h-90zM-39 823l46 52l149 -163l-34 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 170,
    d: "M17 0zM27 0v664h90v-664h-90zM51 677l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 210,
    d: "M0 0zM60 0v664h90v-664h-90zM199 678l-94 108l-94 -108l-38 30l92 129h79l93 -129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 199,
    d: "M0 0zM53 0v664h90v-664h-90zM-16 700v108h80v-108h-80zM135 700v108h80v-108h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\u0407",
    horizAdvX: 199,
    d: "M0 0zM53 0v664h90v-664h-90zM-16 700v108h80v-108h-80zM135 700v108h80v-108h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\u03AA",
    horizAdvX: 199,
    d: "M0 0zM53 0v664h90v-664h-90zM-16 700v108h80v-108h-80zM135 700v108h80v-108h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 384,
    d: "M42 0v307h-35v82h35v275h163q75 0 113.5 -38.5t38.5 -114.5v-349q0 -83 -38.5 -122.5t-113.5 -39.5h-163zM199 81q21 0 34 9t20.5 24t10.5 36t3 45v294q0 46 -15.5 70t-57.5 24h-65v-194h76v-82h-76v-226h70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\u0110",
    horizAdvX: 384,
    d: "M42 0v307h-35v82h35v275h163q75 0 113.5 -38.5t38.5 -114.5v-349q0 -83 -38.5 -122.5t-113.5 -39.5h-163zM199 81q21 0 34 9t20.5 24t10.5 36t3 45v294q0 46 -15.5 70t-57.5 24h-65v-194h76v-82h-76v-226h70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 392,
    d: "M27 0zM259 0l-152 514h-4q3 -74 3 -140v-374h-79v664h118l139 -477h4q-3 94 -3 161v316h79v-664h-105zM331 761q-8 -31 -27.5 -45t-45.5 -14q-17 0 -31.5 5t-28.5 11.5t-28.5 11.5t-30.5 5q-14 0 -23.5 -6t-16.5 -23l-39 23q9 31 28 45t45 14q16 0 31 -5t29 -11.5 t28.5 -11.5t30.5 -5q14 0 24 6t16 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    d: "M23 0zM338 160q0 -84 -40.5 -125t-115.5 -41q-78 0 -118.5 43.5t-40.5 124.5v337q0 81 41.5 126t116.5 45t116 -46t41 -127v-337zM250 505q0 39 -18 60t-52 21q-32 0 -50 -20.5t-18 -59.5v-350q0 -79 69 -79q33 0 51 19t18 59v350zM67 823l46 52l149 -163l-34 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    d: "M23 0zM338 160q0 -84 -40.5 -125t-115.5 -41q-78 0 -118.5 43.5t-40.5 124.5v337q0 81 41.5 126t116.5 45t116 -46t41 -127v-337zM250 505q0 39 -18 60t-52 21q-32 0 -50 -20.5t-18 -59.5v-350q0 -79 69 -79q33 0 51 19t18 59v350zM138 677l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    d: "M23 0zM338 160q0 -84 -40.5 -125t-115.5 -41q-78 0 -118.5 43.5t-40.5 124.5v337q0 81 41.5 126t116.5 45t116 -46t41 -127v-337zM250 505q0 39 -18 60t-52 21q-32 0 -50 -20.5t-18 -59.5v-350q0 -79 69 -79q33 0 51 19t18 59v350zM276 678l-94 108l-94 -108l-38 30 l92 129h79l93 -129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    d: "M23 0zM338 160q0 -84 -40.5 -125t-115.5 -41q-78 0 -118.5 43.5t-40.5 124.5v337q0 81 41.5 126t116.5 45t116 -46t41 -127v-337zM250 505q0 39 -18 60t-52 21q-32 0 -50 -20.5t-18 -59.5v-350q0 -79 69 -79q33 0 51 19t18 59v350zM317 761q-8 -31 -27.5 -45t-45.5 -14 q-17 0 -31.5 5t-28.5 11.5t-28.5 11.5t-30.5 5q-14 0 -23.5 -6t-16.5 -23l-39 23q9 31 28 45t45 14q16 0 31 -5t29 -11.5t28.5 -11.5t30.5 -5q14 0 24 6t16 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    d: "M23 0zM338 160q0 -84 -40.5 -125t-115.5 -41q-78 0 -118.5 43.5t-40.5 124.5v337q0 81 41.5 126t116.5 45t116 -46t41 -127v-337zM250 505q0 39 -18 60t-52 21q-32 0 -50 -20.5t-18 -59.5v-350q0 -79 69 -79q33 0 51 19t18 59v350zM66 712v108h80v-108h-80zM217 712v108 h80v-108h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 344,
    d: "M220 333l86 -85l-49 -48l-85 85l-85 -85l-48 47l85 85l-84 85l48 48l84 -85l85 85l48 -48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    d: "M41 -19l19 60q-37 45 -37 121v337q0 81 41.5 126t116.5 45q41 0 75 -16l10 29h56l-21 -64q37 -46 37 -122v-337q0 -84 -40.5 -125t-115.5 -41q-43 0 -76 14l-9 -27h-56zM112 202h4l113 366q-18 18 -49 18q-32 0 -50 -20.5t-18 -59.5v-304zM250 458h-4l-113 -365 q16 -16 48 -16q33 0 51 19t18 59v303z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 368,
    d: "M27 0zM252 664h88v-502q0 -81 -39 -124.5t-117 -43.5q-75 0 -116 41t-41 125v504h88v-509q0 -78 68 -78q69 0 69 79v508zM69 823l46 52l149 -163l-34 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 368,
    d: "M27 0zM252 664h88v-502q0 -81 -39 -124.5t-117 -43.5q-75 0 -116 41t-41 125v504h88v-509q0 -78 68 -78q69 0 69 79v508zM139 677l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 368,
    d: "M27 0zM252 664h88v-502q0 -81 -39 -124.5t-117 -43.5q-75 0 -116 41t-41 125v504h88v-509q0 -78 68 -78q69 0 69 79v508zM276 678l-94 108l-94 -108l-38 30l92 129h79l93 -129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 368,
    d: "M27 0zM252 664h88v-502q0 -81 -39 -124.5t-117 -43.5q-75 0 -116 41t-41 125v504h88v-509q0 -78 68 -78q69 0 69 79v508zM68 712v108h80v-108h-80zM219 712v108h80v-108h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 369,
    d: "M10 0zM141 0v281l-131 383h87l88 -264h4l84 264h85l-127 -384v-280h-90zM145 677l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 363,
    d: "M27 664h90v-99h95q69 0 97.5 -35t28.5 -98v-165q0 -63 -28.5 -98t-97.5 -35h-95v-134h-90v664zM117 487v-275h77q35 0 47 21.5t12 60.5v124q0 33 -13.5 51t-45.5 18h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 380,
    d: "M271 229q0 47 -16 72t-65 25h-29v72h23q34 0 48.5 16t14.5 45v76q0 35 -17.5 50t-49.5 15q-42 0 -55.5 -25.5t-13.5 -72.5v-502h-84v528q0 78 37.5 114t119.5 36q72 0 112 -29.5t40 -102.5v-74q0 -95 -71 -107v-4q48 -6 69 -41t21 -93v-79q0 -78 -33 -116t-110 -38 q-19 0 -34 2.5t-30 7.5v73q25 -9 51 -9q72 0 72 80v81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 355,
    d: "M22 0zM242 264q-15 -11 -28 -15t-41 -12q-42 -13 -54 -29t-12 -44v-43q0 -51 57 -51q30 0 48.5 14t29.5 43v137zM248 0l-3 61h-4q-16 -28 -41.5 -47.5t-72.5 -19.5q-57 0 -81 29t-24 78v48q0 31 7 53.5t22 38t39.5 27t59.5 21.5q16 5 32.5 9.5t29.5 10t21 13.5t8 20v20 q0 49 -62 49q-68 0 -68 -54v-31h-81v41q0 60 40.5 89.5t113.5 29.5q143 0 143 -112v-374h-79zM63 650l46 52l149 -163l-34 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 355,
    d: "M22 0zM242 264q-15 -11 -28 -15t-41 -12q-42 -13 -54 -29t-12 -44v-43q0 -51 57 -51q30 0 48.5 14t29.5 43v137zM248 0l-3 61h-4q-16 -28 -41.5 -47.5t-72.5 -19.5q-57 0 -81 29t-24 78v48q0 31 7 53.5t22 38t39.5 27t59.5 21.5q16 5 32.5 9.5t29.5 10t21 13.5t8 20v20 q0 49 -62 49q-68 0 -68 -54v-31h-81v41q0 60 40.5 89.5t113.5 29.5q143 0 143 -112v-374h-79zM132 504l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 355,
    d: "M22 0zM242 264q-15 -11 -28 -15t-41 -12q-42 -13 -54 -29t-12 -44v-43q0 -51 57 -51q30 0 48.5 14t29.5 43v137zM248 0l-3 61h-4q-16 -28 -41.5 -47.5t-72.5 -19.5q-57 0 -81 29t-24 78v48q0 31 7 53.5t22 38t39.5 27t59.5 21.5q16 5 32.5 9.5t29.5 10t21 13.5t8 20v20 q0 49 -62 49q-68 0 -68 -54v-31h-81v41q0 60 40.5 89.5t113.5 29.5q143 0 143 -112v-374h-79zM270 505l-94 108l-94 -108l-38 30l92 129h79l93 -129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 355,
    d: "M22 0zM242 264q-15 -11 -28 -15t-41 -12q-42 -13 -54 -29t-12 -44v-43q0 -51 57 -51q30 0 48.5 14t29.5 43v137zM248 0l-3 61h-4q-16 -28 -41.5 -47.5t-72.5 -19.5q-57 0 -81 29t-24 78v48q0 31 7 53.5t22 38t39.5 27t59.5 21.5q16 5 32.5 9.5t29.5 10t21 13.5t8 20v20 q0 49 -62 49q-68 0 -68 -54v-31h-81v41q0 60 40.5 89.5t113.5 29.5q143 0 143 -112v-374h-79zM312 588q-8 -31 -27.5 -45t-45.5 -14q-17 0 -31.5 5t-28.5 11.5t-28.5 11.5t-30.5 5q-14 0 -23.5 -6t-16.5 -23l-39 23q9 31 28 45t45 14q16 0 31 -5t29 -11.5t28.5 -11.5 t30.5 -5q14 0 24 6t16 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 355,
    d: "M22 0zM242 264q-15 -11 -28 -15t-41 -12q-42 -13 -54 -29t-12 -44v-43q0 -51 57 -51q30 0 48.5 14t29.5 43v137zM248 0l-3 61h-4q-16 -28 -41.5 -47.5t-72.5 -19.5q-57 0 -81 29t-24 78v48q0 31 7 53.5t22 38t39.5 27t59.5 21.5q16 5 32.5 9.5t29.5 10t21 13.5t8 20v20 q0 49 -62 49q-68 0 -68 -54v-31h-81v41q0 60 40.5 89.5t113.5 29.5q143 0 143 -112v-374h-79zM62 539v108h80v-108h-80zM213 539v108h80v-108h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 355,
    d: "M22 0zM242 264q-15 -11 -28 -15t-41 -12q-42 -13 -54 -29t-12 -44v-43q0 -51 57 -51q30 0 48.5 14t29.5 43v137zM248 0l-3 61h-4q-16 -28 -41.5 -47.5t-72.5 -19.5q-57 0 -81 29t-24 78v48q0 31 7 53.5t22 38t39.5 27t59.5 21.5q16 5 32.5 9.5t29.5 10t21 13.5t8 20v20 q0 49 -62 49q-68 0 -68 -54v-31h-81v41q0 60 40.5 89.5t113.5 29.5q143 0 143 -112v-374h-79zM180 542q47 0 47 55q0 27 -12 42t-35 15t-35 -15t-12 -42q0 -55 47 -55zM180 504q-44 0 -65 24.5t-21 68.5q0 45 21 69.5t65 24.5q43 0 64 -24.5t21 -69.5q0 -44 -21 -68.5 t-64 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 571,
    d: "M542 144q0 -150 -152 -150q-110 0 -138 83h-4q-17 -39 -45.5 -61t-76.5 -22q-56 0 -80 29t-24 78v48q0 31 7 53.5t22 38t39.5 27t59.5 21.5q16 5 32.5 9.5t29.5 10t21 13.5t8 20v20q0 49 -62 49q-68 0 -68 -54v-31h-81v41q0 60 40.5 89.5t113.5 29.5q71 0 105 -29 q37 29 103 29q150 0 150 -150v-119h-217v-75q0 -72 66 -72t66 72v24h85v-22zM242 264q-15 -11 -28 -15t-41 -12q-42 -13 -54 -29t-12 -44v-43q0 -51 57 -51q30 0 48.5 14t29.5 43v137zM458 338q0 72 -67 72q-66 0 -66 -72v-57h133v57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 354,
    d: "M29 0zM243 178h82v-34q0 -75 -34.5 -112.5t-112.5 -37.5q-76 0 -112.5 36.5t-36.5 113.5v192q0 76 36.5 113t113.5 37t111.5 -37t34.5 -113v-32h-81v32q0 72 -65 72q-66 0 -66 -72v-192q0 -72 65 -72t65 72v34zM138 -182q19 6 28.5 17.5t9.5 35.5v15h-38v96h77v-90 q0 -54 -18 -81.5t-59 -34.5v42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 359,
    d: "M29 0zM330 144q0 -150 -152 -150q-76 0 -112.5 36.5t-36.5 113.5v192q0 76 36.5 113t113.5 37q151 0 151 -150v-119h-217v-75q0 -72 65 -72q67 0 67 72v24h85v-22zM245 338q0 72 -66 72t-66 -72v-57h132v57zM64 650l46 52l149 -163l-34 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\u0450",
    horizAdvX: 359,
    d: "M29 0zM330 144q0 -150 -152 -150q-76 0 -112.5 36.5t-36.5 113.5v192q0 76 36.5 113t113.5 37q151 0 151 -150v-119h-217v-75q0 -72 65 -72q67 0 67 72v24h85v-22zM245 338q0 72 -66 72t-66 -72v-57h132v57zM64 650l46 52l149 -163l-34 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 359,
    d: "M29 0zM330 144q0 -150 -152 -150q-76 0 -112.5 36.5t-36.5 113.5v192q0 76 36.5 113t113.5 37q151 0 151 -150v-119h-217v-75q0 -72 65 -72q67 0 67 72v24h85v-22zM245 338q0 72 -66 72t-66 -72v-57h132v57zM135 504l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 359,
    d: "M29 0zM330 144q0 -150 -152 -150q-76 0 -112.5 36.5t-36.5 113.5v192q0 76 36.5 113t113.5 37q151 0 151 -150v-119h-217v-75q0 -72 65 -72q67 0 67 72v24h85v-22zM245 338q0 72 -66 72t-66 -72v-57h132v57zM273 505l-94 108l-94 -108l-38 30l92 129h79l93 -129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 359,
    d: "M29 0zM330 144q0 -150 -152 -150q-76 0 -112.5 36.5t-36.5 113.5v192q0 76 36.5 113t113.5 37q151 0 151 -150v-119h-217v-75q0 -72 65 -72q67 0 67 72v24h85v-22zM245 338q0 72 -66 72t-66 -72v-57h132v57zM65 539v108h80v-108h-80zM216 539v108h80v-108h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\u0451",
    horizAdvX: 359,
    d: "M29 0zM330 144q0 -150 -152 -150q-76 0 -112.5 36.5t-36.5 113.5v192q0 76 36.5 113t113.5 37q151 0 151 -150v-119h-217v-75q0 -72 65 -72q67 0 67 72v24h85v-22zM245 338q0 72 -66 72t-66 -72v-57h132v57zM65 539v108h80v-108h-80zM216 539v108h80v-108h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 180,
    d: "M0 0zM-11 650l46 52l149 -163l-34 -35zM64 0v480h86v-480h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 188,
    d: "M5 0zM39 504l-34 35l149 163l46 -52zM29 0v480h86v-480h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 242,
    d: "M0 0zM77 0v480h86v-480h-86zM215 505l-94 108l-94 -108l-38 30l92 129h79l93 -129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 202,
    d: "M0 0zM-15 539v108h80v-108h-80zM136 539v108h80v-108h-80zM56 0v480h86v-480h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\u0457",
    horizAdvX: 202,
    d: "M0 0zM-15 539v108h80v-108h-80zM136 539v108h80v-108h-80zM56 0v480h86v-480h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 363,
    d: "M334 620l-59 -25q28 -35 43.5 -82t15.5 -107v-229q0 -48 -7 -82.5t-24 -57t-47 -33t-76 -10.5q-47 0 -76.5 10.5t-46 29.5t-22.5 45.5t-6 59.5v220q0 59 32.5 86t82.5 27q35 0 60.5 -12t42.5 -46h4v34q0 32 -11.5 62.5t-30.5 57.5l-115 -48v43l90 37q-20 22 -43.5 40 t-46.5 32h83q38 -18 69 -46l88 36v-42zM183 70q21 0 34.5 6t20.5 19.5t9.5 34.5t2.5 51v162q-14 32 -29 43t-41 11q-32 0 -48 -16.5t-16 -56.5v-196q0 -58 67 -58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 365,
    d: "M29 0zM249 0v342q0 68 -62 68q-30 0 -45.5 -16t-26.5 -54v-340h-86v480h80l3 -69h4q16 39 41.5 57t63.5 18q51 0 83 -32.5t32 -95.5v-358h-87zM318 588q-8 -31 -27.5 -45t-45.5 -14q-17 0 -31.5 5t-28.5 11.5t-28.5 11.5t-30.5 5q-14 0 -23.5 -6t-16.5 -23l-39 23 q9 31 28 45t45 14q16 0 31 -5t29 -11.5t28.5 -11.5t30.5 -5q14 0 24 6t16 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 358,
    d: "M29 0zM329 144q0 -78 -36.5 -114t-113.5 -36t-113.5 36t-36.5 114v192q0 78 36.5 114t113.5 36t113.5 -36t36.5 -114v-192zM245 336q0 72 -66 72t-66 -72v-192q0 -72 66 -72t66 72v192zM64 650l46 52l149 -163l-34 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 358,
    d: "M29 0zM329 144q0 -78 -36.5 -114t-113.5 -36t-113.5 36t-36.5 114v192q0 78 36.5 114t113.5 36t113.5 -36t36.5 -114v-192zM245 336q0 72 -66 72t-66 -72v-192q0 -72 66 -72t66 72v192zM135 504l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 358,
    d: "M29 0zM329 144q0 -78 -36.5 -114t-113.5 -36t-113.5 36t-36.5 114v192q0 78 36.5 114t113.5 36t113.5 -36t36.5 -114v-192zM245 336q0 72 -66 72t-66 -72v-192q0 -72 66 -72t66 72v192zM274 505l-94 108l-94 -108l-38 30l92 129h79l93 -129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 358,
    d: "M29 0zM329 144q0 -78 -36.5 -114t-113.5 -36t-113.5 36t-36.5 114v192q0 78 36.5 114t113.5 36t113.5 -36t36.5 -114v-192zM245 336q0 72 -66 72t-66 -72v-192q0 -72 66 -72t66 72v192zM314 588q-8 -31 -27.5 -45t-45.5 -14q-17 0 -31.5 5t-28.5 11.5t-28.5 11.5t-30.5 5 q-14 0 -23.5 -6t-16.5 -23l-39 23q9 31 28 45t45 14q16 0 31 -5t29 -11.5t28.5 -11.5t30.5 -5q14 0 24 6t16 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 358,
    d: "M29 0zM329 144q0 -78 -36.5 -114t-113.5 -36t-113.5 36t-36.5 114v192q0 78 36.5 114t113.5 36t113.5 -36t36.5 -114v-192zM245 336q0 72 -66 72t-66 -72v-192q0 -72 66 -72t66 72v192zM65 539v108h80v-108h-80zM216 539v108h80v-108h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 344,
    d: "M27 299v68h289v-68h-289zM127 108v119h88v-119h-88zM127 440v119h88v-119h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 358,
    d: "M42 -16l21 49q-34 35 -34 111v192q0 78 36.5 114t113.5 36q43 0 75 -12l10 23h53l-22 -51q34 -35 34 -110v-192q0 -78 -36.5 -114t-113.5 -36q-44 0 -75 12l-9 -22h-53zM113 148h4l103 249q-16 11 -41 11q-66 0 -66 -72v-188zM245 330h-4l-104 -248q16 -10 42 -10 q66 0 66 72v186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 363,
    d: "M29 0zM116 480v-336q0 -41 15 -57.5t47 -16.5t46.5 17t23.5 61v332h86v-480h-81l-2 69h-4q-17 -41 -41.5 -58t-64.5 -17q-62 0 -87 38.5t-25 112.5v335h87zM68 650l46 52l149 -163l-34 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 363,
    d: "M29 0zM116 480v-336q0 -41 15 -57.5t47 -16.5t46.5 17t23.5 61v332h86v-480h-81l-2 69h-4q-17 -41 -41.5 -58t-64.5 -17q-62 0 -87 38.5t-25 112.5v335h87zM138 504l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 363,
    d: "M29 0zM116 480v-336q0 -41 15 -57.5t47 -16.5t46.5 17t23.5 61v332h86v-480h-81l-2 69h-4q-17 -41 -41.5 -58t-64.5 -17q-62 0 -87 38.5t-25 112.5v335h87zM276 505l-94 108l-94 -108l-38 30l92 129h79l93 -129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 363,
    d: "M29 0zM116 480v-336q0 -41 15 -57.5t47 -16.5t46.5 17t23.5 61v332h86v-480h-81l-2 69h-4q-17 -41 -41.5 -58t-64.5 -17q-62 0 -87 38.5t-25 112.5v335h87zM67 539v108h80v-108h-80zM218 539v108h80v-108h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    d: "M29 0zM116 151q0 -38 16.5 -55t46.5 -17q29 0 45 17t26 59v325h83v-563q0 -150 -152 -150q-77 0 -113 37t-36 113v53h82v-53q0 -72 66 -72q67 0 67 72v149h-4q-16 -37 -41 -51.5t-61 -14.5q-63 0 -87.5 34.5t-24.5 91.5v354h87v-329zM138 504l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    d: "M246 338q0 38 -16 55t-46 17t-45.5 -18t-26.5 -60v-186q9 -39 25.5 -57.5t46.5 -18.5q62 0 62 72v196zM29 -233v905h85v-252h4q15 35 39.5 50.5t62.5 15.5q33 0 55 -12t35 -33.5t18 -52.5t5 -70v-157q0 -40 -5 -71t-18 -52.5t-35 -32.5t-55 -11q-37 0 -61.5 15t-40.5 51 h-4v-293h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    d: "M29 0zM116 151q0 -38 16.5 -55t46.5 -17q29 0 45 17t26 59v325h83v-563q0 -150 -152 -150q-77 0 -113 37t-36 113v53h82v-53q0 -72 66 -72q67 0 67 72v149h-4q-16 -37 -41 -51.5t-61 -14.5q-63 0 -87.5 34.5t-24.5 91.5v354h87v-329zM69 539v108h80v-108h-80zM220 539 v108h80v-108h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 372,
    d: "M12 0zM271 0l-26 156h-122l-24 -156h-87l113 664h121l113 -664h-88zM135 233h98l-47 291h-4zM66 735v55h234v-55h-234z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 355,
    d: "M22 0zM242 264q-15 -11 -28 -15t-41 -12q-42 -13 -54 -29t-12 -44v-43q0 -51 57 -51q30 0 48.5 14t29.5 43v137zM248 0l-3 61h-4q-16 -28 -41.5 -47.5t-72.5 -19.5q-57 0 -81 29t-24 78v48q0 31 7 53.5t22 38t39.5 27t59.5 21.5q16 5 32.5 9.5t29.5 10t21 13.5t8 20v20 q0 49 -62 49q-68 0 -68 -54v-31h-81v41q0 60 40.5 89.5t113.5 29.5q143 0 143 -112v-374h-79zM58 562v55h234v-55h-234z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 372,
    d: "M12 0zM271 0l-26 156h-122l-24 -156h-87l113 664h121l113 -664h-88zM135 233h98l-47 291h-4zM183 677q-60 0 -97.5 39.5t-37.5 119.5h63q2 -53 19.5 -77.5t52.5 -24.5q34 0 52 24.5t19 77.5h65q0 -81 -38 -120t-98 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 355,
    d: "M22 0zM242 264q-15 -11 -28 -15t-41 -12q-42 -13 -54 -29t-12 -44v-43q0 -51 57 -51q30 0 48.5 14t29.5 43v137zM248 0l-3 61h-4q-16 -28 -41.5 -47.5t-72.5 -19.5q-57 0 -81 29t-24 78v48q0 31 7 53.5t22 38t39.5 27t59.5 21.5q16 5 32.5 9.5t29.5 10t21 13.5t8 20v20 q0 49 -62 49q-68 0 -68 -54v-31h-81v41q0 60 40.5 89.5t113.5 29.5q143 0 143 -112v-374h-79zM174 504q-60 0 -97.5 39.5t-37.5 119.5h63q2 -53 19.5 -77.5t52.5 -24.5q34 0 52 24.5t19 77.5h65q0 -81 -38 -120t-98 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 372,
    d: "M357 -211q-12 -7 -28.5 -10t-35.5 -3q-94 0 -94 78v27q0 42 28.5 70t77.5 43v6h-34l-26 156h-122l-24 -156h-87l113 664h121l113 -664q-48 -17 -74 -42t-26 -51v-22q0 -33 51 -33q11 0 24.5 1.5t22.5 6.5v-71zM135 233h98l-47 291h-4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 355,
    d: "M325 -211q-12 -7 -28.5 -10t-36.5 -3q-93 0 -93 78v27q0 42 29 70.5t79 43.5v5h-27l-3 61h-4q-16 -28 -41.5 -47.5t-72.5 -19.5q-57 0 -81 29t-24 78v48q0 31 7 53.5t22 38t39.5 27t59.5 21.5q41 11 66 21t25 32v20q0 49 -63 49q-67 0 -67 -54v-31h-81v41q0 60 40.5 89.5 t113.5 29.5q143 0 143 -112v-374q-48 -17 -74 -42t-26 -51v-22q0 -33 50 -33q12 0 25 1.5t23 6.5v-71zM242 264q-15 -11 -28 -15t-41 -12q-20 -6 -32.5 -12.5t-20 -14.5t-10.5 -19t-3 -27v-43q0 -51 57 -51q30 0 48.5 14t29.5 43v137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 363,
    d: "M27 0zM251 271h85v-111q0 -84 -39 -125t-114 -41q-78 0 -117 43.5t-39 124.5v342q0 84 39 125t114 41q76 0 116 -41t40 -124v-79h-85v79q0 39 -17 60t-51 21q-67 0 -67 -80v-351q0 -38 16 -58t51 -20q68 0 68 78v116zM140 677l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 354,
    d: "M29 0zM243 178h82v-34q0 -75 -34.5 -112.5t-112.5 -37.5q-76 0 -112.5 36.5t-36.5 113.5v192q0 76 36.5 113t113.5 37t111.5 -37t34.5 -113v-32h-81v32q0 72 -65 72q-66 0 -66 -72v-192q0 -72 65 -72t65 72v34zM134 504l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 363,
    d: "M27 0zM251 271h85v-111q0 -84 -39 -125t-114 -41q-78 0 -117 43.5t-39 124.5v342q0 84 39 125t114 41q76 0 116 -41t40 -124v-79h-85v79q0 39 -17 60t-51 21q-67 0 -67 -80v-351q0 -38 16 -58t51 -20q68 0 68 78v116zM138 712v108h86v-108h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 354,
    d: "M29 0zM243 178h82v-34q0 -75 -34.5 -112.5t-112.5 -37.5q-76 0 -112.5 36.5t-36.5 113.5v192q0 76 36.5 113t113.5 37t111.5 -37t34.5 -113v-32h-81v32q0 72 -65 72q-66 0 -66 -72v-192q0 -72 65 -72t65 72v34zM136 539v108h86v-108h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 363,
    d: "M27 0zM251 271h85v-111q0 -84 -39 -125t-114 -41q-78 0 -117 43.5t-39 124.5v342q0 84 39 125t114 41q76 0 116 -41t40 -124v-79h-85v79q0 39 -17 60t-51 21q-67 0 -67 -80v-351q0 -38 16 -58t51 -20q68 0 68 78v116zM144 695l-93 130l38 30l94 -108l94 108l38 -30 l-92 -130h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 354,
    d: "M29 0zM243 178h82v-34q0 -75 -34.5 -112.5t-112.5 -37.5q-76 0 -112.5 36.5t-36.5 113.5v192q0 76 36.5 113t113.5 37t111.5 -37t34.5 -113v-32h-81v32q0 72 -65 72q-66 0 -66 -72v-192q0 -72 65 -72t65 72v34zM140 522l-93 130l38 30l94 -108l94 108l38 -30l-92 -130 h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 370,
    d: "M27 0zM27 0v664h164q151 0 151 -153v-349q0 -83 -38 -122.5t-113 -39.5h-164zM185 81q41 0 54.5 28t13.5 78v292q0 48 -14.5 76t-58.5 28h-65v-502h70zM144 695l-93 130l38 30l94 -108l94 108l38 -30l-92 -130h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 466,
    d: "M29 0zM116 142q0 -38 16 -55t47 -17t46 17.5t25 62.5v181q-9 45 -23.5 62t-46.5 17q-30 0 -47 -16t-17 -56v-196zM256 0l-3 69h-4q-16 -39 -41 -57t-64 -18q-54 0 -84.5 32.5t-30.5 95.5v236q0 63 30 95.5t84 32.5q36 0 61.5 -15.5t39.5 -50.5h4v252h85v-672h-77z M362 439q20 12 29.5 31.5t9.5 52.5v29h-39v120h88v-138q0 -65 -22 -100t-66 -47v52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    d: "M256 0l-3 69h-4q-16 -39 -41 -57t-64 -18q-54 0 -84.5 32.5t-30.5 95.5v236q0 63 30 95.5t84 32.5q36 0 61.5 -15.5t39.5 -50.5h4v142h-120v55h120v55h85v-55h29v-55h-29v-562h-77zM116 142q0 -38 16 -55t47 -17t46 17.5t25 62.5v181q-9 45 -23.5 62t-46.5 17 q-30 0 -47 -16t-17 -56v-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 292,
    d: "M27 0zM27 0v664h240v-81h-152v-194h139v-82h-139v-226h160v-81h-248zM33 735v55h234v-55h-234z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 359,
    d: "M29 0zM330 144q0 -150 -152 -150q-76 0 -112.5 36.5t-36.5 113.5v192q0 76 36.5 113t113.5 37q151 0 151 -150v-119h-217v-75q0 -72 65 -72q67 0 67 72v24h85v-22zM245 338q0 72 -66 72t-66 -72v-57h132v57zM62 562v55h234v-55h-234z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 292,
    d: "M21 0zM27 0v664h240v-81h-152v-194h139v-82h-139v-226h160v-81h-248zM156 677q-60 0 -97.5 39.5t-37.5 119.5h63q2 -53 19.5 -77.5t52.5 -24.5q34 0 52 24.5t19 77.5h65q0 -81 -38 -120t-98 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    horizAdvX: 359,
    d: "M29 0zM330 144q0 -150 -152 -150q-76 0 -112.5 36.5t-36.5 113.5v192q0 76 36.5 113t113.5 37q151 0 151 -150v-119h-217v-75q0 -72 65 -72q67 0 67 72v24h85v-22zM245 338q0 72 -66 72t-66 -72v-57h132v57zM179 504q-60 0 -97.5 39.5t-37.5 119.5h63q2 -53 19.5 -77.5 t52.5 -24.5q34 0 52 24.5t19 77.5h65q0 -81 -38 -120t-98 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 292,
    d: "M27 0zM27 0v664h240v-81h-152v-194h139v-82h-139v-226h160v-81h-248zM111 712v108h86v-108h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 359,
    d: "M29 0zM330 144q0 -150 -152 -150q-76 0 -112.5 36.5t-36.5 113.5v192q0 76 36.5 113t113.5 37q151 0 151 -150v-119h-217v-75q0 -72 65 -72q67 0 67 72v24h85v-22zM245 338q0 72 -66 72t-66 -72v-57h132v57zM135 539v108h86v-108h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 292,
    d: "M273 -211q-12 -7 -28.5 -10t-36.5 -3q-93 0 -93 78v27q0 42 28.5 70t76.5 43v6h-193v664h240v-81h-152v-194h139v-82h-139v-226h160v-81q-48 -17 -74 -42t-26 -51v-22q0 -33 50 -33q12 0 25 1.5t23 6.5v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 359,
    d: "M241 -211q-12 -7 -28.5 -10t-35.5 -3q-94 0 -94 78v27q0 35 20.5 62t55.5 44v8q-67 5 -98.5 41t-31.5 108v192q0 76 36.5 113t113.5 37q151 0 151 -150v-119h-217v-75q0 -72 65 -72q67 0 67 72v24h85v-22q0 -122 -99 -144q-43 -18 -65.5 -43t-22.5 -50v-22q0 -33 51 -33 q11 0 24.5 1.5t22.5 6.5v-71zM245 338q0 72 -66 72t-66 -72v-57h132v57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 292,
    d: "M17 0zM27 0v664h240v-81h-152v-194h139v-82h-139v-226h160v-81h-248zM110 695l-93 130l38 30l94 -108l94 108l38 -30l-92 -130h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 359,
    d: "M29 0zM330 144q0 -150 -152 -150q-76 0 -112.5 36.5t-36.5 113.5v192q0 76 36.5 113t113.5 37q151 0 151 -150v-119h-217v-75q0 -72 65 -72q67 0 67 72v24h85v-22zM245 338q0 72 -66 72t-66 -72v-57h132v57zM141 522l-93 130l38 30l94 -108l94 108l38 -30l-92 -130h-79z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 363,
    d: "M27 0zM277 0l-4 51h-4q-13 -24 -35 -40.5t-65 -16.5q-68 0 -105 43.5t-37 124.5v337q0 81 39.5 126t114.5 45q76 0 115.5 -46t39.5 -127v-38h-85v46q0 39 -17 60t-51 21q-67 0 -67 -80v-350q0 -79 65 -79q58 0 70 67v131h-75v80h160v-355h-59zM185 677q-60 0 -97.5 39.5 t-37.5 119.5h63q2 -53 19.5 -77.5t52.5 -24.5q34 0 52 24.5t19 77.5h65q0 -81 -38 -120t-98 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    d: "M29 0zM116 170q0 -47 13.5 -69t45.5 -22q28 0 44.5 16.5t30.5 53.5v185q-8 40 -21.5 58t-48.5 18q-32 0 -48 -16t-16 -56v-168zM333 -83q0 -150 -153 -150q-77 0 -112.5 37.5t-35.5 112.5v53h82v-53q0 -72 66 -72q67 0 67 72v149h-4q-26 -66 -102 -66q-60 0 -86 39 t-26 115v204q0 57 28 92.5t85 35.5q37 0 63 -17.5t44 -57.5h4l3 69h77v-563zM184 504q-60 0 -97.5 39.5t-37.5 119.5h63q2 -53 19.5 -77.5t52.5 -24.5q34 0 52 24.5t19 77.5h65q0 -81 -38 -120t-98 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 363,
    d: "M27 0zM277 0l-4 51h-4q-13 -24 -35 -40.5t-65 -16.5q-68 0 -105 43.5t-37 124.5v337q0 81 39.5 126t114.5 45q76 0 115.5 -46t39.5 -127v-38h-85v46q0 39 -17 60t-51 21q-67 0 -67 -80v-350q0 -79 65 -79q58 0 70 67v131h-75v80h160v-355h-59zM140 712v108h86v-108h-86z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    d: "M29 0zM116 170q0 -47 13.5 -69t45.5 -22q28 0 44.5 16.5t30.5 53.5v185q-8 40 -21.5 58t-48.5 18q-32 0 -48 -16t-16 -56v-168zM333 -83q0 -150 -153 -150q-77 0 -112.5 37.5t-35.5 112.5v53h82v-53q0 -72 66 -72q67 0 67 72v149h-4q-26 -66 -102 -66q-60 0 -86 39 t-26 115v204q0 57 28 92.5t85 35.5q37 0 63 -17.5t44 -57.5h4l3 69h77v-563zM137 539v108h86v-108h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcommaaccent",
    unicode: "\u0122",
    horizAdvX: 363,
    d: "M27 0zM277 0l-4 51h-4q-13 -24 -35 -40.5t-65 -16.5q-68 0 -105 43.5t-37 124.5v337q0 81 39.5 126t114.5 45q76 0 115.5 -46t39.5 -127v-38h-85v46q0 39 -17 60t-51 21q-67 0 -67 -80v-350q0 -79 65 -79q58 0 70 67v131h-75v80h160v-355h-59zM143 -182q19 6 28.5 17.5 t9.5 35.5v15h-38v96h77v-90q0 -54 -18 -81.5t-59 -34.5v42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcommaaccent",
    unicode: "\u0123",
    d: "M29 0zM116 170q0 -47 13.5 -69t45.5 -22q28 0 44.5 16.5t30.5 53.5v185q-8 40 -21.5 58t-48.5 18q-32 0 -48 -16t-16 -56v-168zM333 -83q0 -150 -153 -150q-77 0 -112.5 37.5t-35.5 112.5v53h82v-53q0 -72 66 -72q67 0 67 72v149h-4q-26 -66 -102 -66q-60 0 -86 39 t-26 115v204q0 57 28 92.5t85 35.5q37 0 63 -17.5t44 -57.5h4l3 69h77v-563zM220.002 696.989q-18.999 -6 -28.498 -17.499q-9.5 -11.5 -9.5 -35.498v-14.999h37.998v-95.9941h-76.9951v89.9941q0 53.9971 17.998 81.4951q17.999 27.498 58.9971 34.498v-41.9971z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 374,
    d: "M257 0v312h-140v-312h-90v494h-27v56h27v114h90v-114h140v114h89v-114h28v-56h-28v-494h-89zM257 392v102h-140v-102h140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 365,
    d: "M115 562v-142h4q14 34 40 50t63 16q32 0 53.5 -11t35 -29.5t19.5 -42t6 -48.5v-355h-87v342q0 35 -16 51.5t-45 16.5q-33 0 -52 -22.5t-21 -76.5v-311h-86v562h-29v55h29v55h86v-55h119v-55h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u045B",
    horizAdvX: 365,
    d: "M115 562v-142h4q14 34 40 50t63 16q32 0 53.5 -11t35 -29.5t19.5 -42t6 -48.5v-355h-87v342q0 35 -16 51.5t-45 16.5q-33 0 -52 -22.5t-21 -76.5v-311h-86v562h-29v55h29v55h86v-55h119v-55h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 202,
    d: "M0 0zM56 0v664h90v-664h-90zM237 749q-8 -31 -27.5 -45t-45.5 -14q-17 0 -31.5 5t-28.5 11.5t-28.5 11.5t-30.5 5q-14 0 -23.5 -6t-16.5 -23l-39 23q9 31 28 45t45 14q16 0 31 -5t29 -11.5t28.5 -11.5t30.5 -5q14 0 24 6t16 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 239,
    d: "M0 0zM255 588q-8 -31 -27.5 -45t-45.5 -14q-17 0 -31.5 5t-28.5 11.5t-28.5 11.5t-30.5 5q-14 0 -23.5 -6t-16.5 -23l-39 23q9 31 28 45t45 14q16 0 31 -5t29 -11.5t28.5 -11.5t30.5 -5q14 0 24 6t16 23zM75 0v480h86v-480h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 202,
    d: "M0 0zM56 0v664h90v-664h-90zM-16 723v55h234v-55h-234z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 197,
    d: "M0 0zM-19 562v55h234v-55h-234zM54 0v480h86v-480h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 209,
    d: "M0 0zM59 0v664h90v-664h-90zM104 677q-60 0 -97.5 39.5t-37.5 119.5h63q2 -53 19.5 -77.5t52.5 -24.5q34 0 52 24.5t19 77.5h65q0 -81 -38 -120t-98 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 231,
    d: "M0 0zM115 504q-60 0 -97.5 39.5t-37.5 119.5h63q2 -53 19.5 -77.5t52.5 -24.5q34 0 52 24.5t19 77.5h65q0 -81 -38 -120t-98 -39zM72 0v480h86v-480h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 157,
    d: "M127 -211q-12 -7 -28.5 -10t-35.5 -3q-94 0 -94 78v27q0 42 28 70t76 43v6h-33v664h89v-664q-48 -17 -74 -42t-26 -51v-22q0 -33 51 -33q11 0 24.5 1.5t22.5 6.5v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 158,
    d: "M126 -211q-12 -7 -28.5 -10t-35.5 -3q-94 0 -94 78v27q0 42 28.5 70t77.5 43v6h-32v480h86v-480q-48 -17 -74 -42t-26 -51v-22q0 -33 51 -33q11 0 24.5 1.5t22.5 6.5v-71zM42 539v108h86v-108h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 144,
    d: "M27 0zM27 0v664h90v-664h-90zM29 700v108h86v-108h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 144,
    d: "M29 0v480h86v-480h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 489,
    d: "M27 0zM27 0v664h90v-664h-90zM374 664h88v-502q0 -81 -39 -124.5t-117 -43.5q-152 0 -152 166v81h84v-86q0 -78 67 -78q69 0 69 79v508z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 331,
    d: "M30 0v480h86v-480h-86zM30 539v108h86v-108h-86zM31 -58h86v-34q0 -35 11.5 -49t37.5 -14q25 0 37.5 14t12.5 49v572h86v-572q0 -71 -33 -106t-104 -35t-102.5 35t-31.5 106v34zM216 539v108h86v-108h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Kcommaaccent",
    unicode: "\u0136",
    horizAdvX: 368,
    d: "M27 0zM265 0l-95 287h-4l-48 -94v-193h-91v664h91v-298h4l144 298h91l-125 -263l124 -401h-91zM137 -182q19 6 28.5 17.5t9.5 35.5v15h-38v96h77v-90q0 -54 -18 -81.5t-59 -34.5v42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kcommaaccent",
    unicode: "\u0137",
    horizAdvX: 361,
    d: "M29 0zM257 0l-91 206h-3l-48 -67v-139h-86v672h86v-396h4l137 204h94l-122 -190l120 -290h-91zM136 -182q19 6 28.5 17.5t9.5 35.5v15h-38v96h77v-90q0 -54 -18 -81.5t-59 -34.5v42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 299,
    d: "M21 0zM27 0v664h90v-582h164v-82h-254zM55 677l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 161,
    d: "M10 0zM29 0v672h86v-672h-86zM44 677l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcommaaccent",
    unicode: "\u013B",
    horizAdvX: 299,
    d: "M27 0zM27 0v664h90v-582h164v-82h-254zM112 -182q19 6 28.5 17.5t9.5 35.5v15h-38v96h77v-90q0 -54 -18 -81.5t-59 -34.5v42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcommaaccent",
    unicode: "\u013C",
    horizAdvX: 145,
    d: "M29 0zM29 0v672h86v-672h-86zM34 -182q19 6 28.5 17.5t9.5 35.5v15h-38v96h77v-90q0 -54 -18 -81.5t-59 -34.5v42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 310,
    d: "M27 0zM27 0v664h90v-582h164v-82h-254zM176 439q20 12 29.5 31.5t9.5 52.5v29h-39v120h88v-138q0 -65 -22 -100t-66 -47v52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 248,
    d: "M29 0zM29 0v672h86v-672h-86zM145 439q20 12 29.5 31.5t9.5 52.5v29h-39v120h88v-138q0 -65 -22 -100t-66 -47v52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 299,
    d: "M27 0v664h90v-170l129 56v-77l-129 -56v-335h164v-82h-254z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 200,
    d: "M57 0v286l-50 -19v66l50 19v320h86v-286l50 20v-66l-50 -20v-320h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 392,
    d: "M27 0zM259 0l-152 514h-4q3 -74 3 -140v-374h-79v664h118l139 -477h4q-3 94 -3 161v316h79v-664h-105zM153 677l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 365,
    d: "M29 0zM249 0v342q0 68 -62 68q-30 0 -45.5 -16t-26.5 -54v-340h-86v480h80l3 -69h4q16 39 41.5 57t63.5 18q51 0 83 -32.5t32 -95.5v-358h-87zM138 504l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncommaaccent",
    unicode: "\u0145",
    horizAdvX: 392,
    d: "M27 0zM259 0l-152 514h-4q3 -74 3 -140v-374h-79v664h118l139 -477h4q-3 94 -3 161v316h79v-664h-105zM153 -182q19 6 28.5 17.5t9.5 35.5v15h-38v96h77v-90q0 -54 -18 -81.5t-59 -34.5v42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncommaaccent",
    unicode: "\u0146",
    horizAdvX: 365,
    d: "M29 0zM249 0v342q0 68 -62 68q-30 0 -45.5 -16t-26.5 -54v-340h-86v480h80l3 -69h4q16 39 41.5 57t63.5 18q51 0 83 -32.5t32 -95.5v-358h-87zM144 -182q19 6 28.5 17.5t9.5 35.5v15h-38v96h77v-90q0 -54 -18 -81.5t-59 -34.5v42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 392,
    d: "M27 0zM259 0l-152 514h-4q3 -74 3 -140v-374h-79v664h118l139 -477h4q-3 94 -3 161v316h79v-664h-105zM158 695l-93 130l38 30l94 -108l94 108l38 -30l-92 -130h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 365,
    d: "M29 0zM249 0v342q0 68 -62 68q-30 0 -45.5 -16t-26.5 -54v-340h-86v480h80l3 -69h4q16 39 41.5 57t63.5 18q51 0 83 -32.5t32 -95.5v-358h-87zM143 522l-93 130l38 30l94 -108l94 108l38 -30l-92 -130h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 392,
    d: "M364 -83q0 -76 -40 -113t-110 -37q-15 0 -24.5 1t-15.5 3v77q5 -2 13 -2.5t15 -0.5q63 0 63 72v62l-158 535h-4q3 -74 3 -140v-374h-79v664h118l139 -477h4q-3 94 -3 161v316h79v-747v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 365,
    d: "M163 -152q5 -2 12.5 -2.5t13.5 -0.5q31 0 45.5 17t14.5 55v425q0 68 -62 68q-30 0 -45.5 -16t-26.5 -54v-340h-86v480h80l3 -69h4q16 39 41.5 57t63.5 18q51 0 83 -32.5t32 -95.5v-441q0 -76 -37 -113t-100 -37q-13 0 -21.5 1t-14.5 3v77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    d: "M23 0zM338 160q0 -84 -40.5 -125t-115.5 -41q-78 0 -118.5 43.5t-40.5 124.5v337q0 81 41.5 126t116.5 45t116 -46t41 -127v-337zM250 505q0 39 -18 60t-52 21q-32 0 -50 -20.5t-18 -59.5v-350q0 -79 69 -79q33 0 51 19t18 59v350zM64 735v55h234v-55h-234z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 358,
    d: "M29 0zM329 144q0 -78 -36.5 -114t-113.5 -36t-113.5 36t-36.5 114v192q0 78 36.5 114t113.5 36t113.5 -36t36.5 -114v-192zM245 336q0 72 -66 72t-66 -72v-192q0 -72 66 -72t66 72v192zM62 562v55h234v-55h-234z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    d: "M23 0zM338 160q0 -84 -40.5 -125t-115.5 -41q-78 0 -118.5 43.5t-40.5 124.5v337q0 81 41.5 126t116.5 45t116 -46t41 -127v-337zM250 505q0 39 -18 60t-52 21q-32 0 -50 -20.5t-18 -59.5v-350q0 -79 69 -79q33 0 51 19t18 59v350zM181 677q-60 0 -97.5 39.5t-37.5 119.5 h63q2 -53 19.5 -77.5t52.5 -24.5q34 0 52 24.5t19 77.5h65q0 -81 -38 -120t-98 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 358,
    d: "M29 0zM329 144q0 -78 -36.5 -114t-113.5 -36t-113.5 36t-36.5 114v192q0 78 36.5 114t113.5 36t113.5 -36t36.5 -114v-192zM245 336q0 72 -66 72t-66 -72v-192q0 -72 66 -72t66 72v192zM179 504q-60 0 -97.5 39.5t-37.5 119.5h63q2 -53 19.5 -77.5t52.5 -24.5 q34 0 52 24.5t19 77.5h65q0 -81 -38 -120t-98 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    d: "M23 0zM338 160q0 -84 -40.5 -125t-115.5 -41q-78 0 -118.5 43.5t-40.5 124.5v337q0 81 41.5 126t116.5 45t116 -46t41 -127v-337zM250 505q0 39 -18 60t-52 21q-32 0 -50 -20.5t-18 -59.5v-350q0 -79 69 -79q33 0 51 19t18 59v350zM67 697l93 178l56 -32l-109 -166z M185 697l93 178l56 -32l-109 -166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 358,
    d: "M29 0zM329 144q0 -78 -36.5 -114t-113.5 -36t-113.5 36t-36.5 114v192q0 78 36.5 114t113.5 36t113.5 -36t36.5 -114v-192zM245 336q0 72 -66 72t-66 -72v-192q0 -72 66 -72t66 72v192zM65 524l93 178l56 -32l-109 -166zM183 524l93 178l56 -32l-109 -166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 486,
    d: "M233 0q-24 -6 -51 -6q-78 0 -118.5 43.5t-40.5 124.5v337q0 81 41.5 126t116.5 45q26 0 47 -6h234v-81h-150q26 -32 26 -86v-108h110v-82h-110v-147q0 -52 -24 -79h155v-81h-236zM250 505q0 39 -18 60t-52 21q-32 0 -50 -20.5t-18 -59.5v-350q0 -79 69 -79q33 0 51 19 t18 59v350z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 567,
    d: "M539 144q0 -150 -151 -150q-72 0 -104 32q-33 -32 -105 -32q-77 0 -113.5 36t-36.5 114v192q0 78 36.5 114t113.5 36q70 0 105 -33q34 33 105 33q150 0 150 -150v-119h-216v-75q0 -72 65 -72q66 0 66 72v24h85v-22zM245 336q0 72 -66 72t-66 -72v-192q0 -72 66 -72t66 72 v192zM455 338q0 72 -66 72t-66 -72v-57h132v57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 363,
    d: "M27 0zM27 0v664h185q70 0 98 -35t28 -98v-91q0 -46 -18 -73t-50 -35v-4q35 -7 52.5 -32t17.5 -75v-221h-88v228q0 32 -12 46.5t-44 14.5h-81v-289h-88zM251 521q0 31 -13.5 46.5t-45.5 15.5h-77v-219h78q27 0 42.5 15t15.5 53v89zM129 677l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 277,
    d: "M29 0zM29 0v480h80l3 -82h4q14 42 40 65t64 23q21 0 40 -10v-79q-15 10 -45 10q-40 0 -64 -24t-36 -88v-295h-86zM99 504l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcommaaccent",
    unicode: "\u0156",
    horizAdvX: 363,
    d: "M27 0zM27 0v664h185q70 0 98 -35t28 -98v-91q0 -46 -18 -73t-50 -35v-4q35 -7 52.5 -32t17.5 -75v-221h-88v228q0 32 -12 46.5t-44 14.5h-81v-289h-88zM251 521q0 31 -13.5 46.5t-45.5 15.5h-77v-219h78q27 0 42.5 15t15.5 53v89zM141 -182q19 6 28.5 17.5t9.5 35.5v15 h-38v96h77v-90q0 -54 -18 -81.5t-59 -34.5v42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcommaaccent",
    unicode: "\u0157",
    horizAdvX: 277,
    d: "M29 0zM29 0v480h80l3 -82h4q14 42 40 65t64 23q21 0 40 -10v-79q-15 10 -45 10q-40 0 -64 -24t-36 -88v-295h-86zM33 -182q19 6 28.5 17.5t9.5 35.5v15h-38v96h77v-90q0 -54 -18 -81.5t-59 -34.5v42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 363,
    d: "M27 0zM27 0v664h185q70 0 98 -35t28 -98v-91q0 -46 -18 -73t-50 -35v-4q35 -7 52.5 -32t17.5 -75v-221h-88v228q0 32 -12 46.5t-44 14.5h-81v-289h-88zM251 521q0 31 -13.5 46.5t-45.5 15.5h-77v-219h78q27 0 42.5 15t15.5 53v89zM138 695l-93 130l38 30l94 -108l94 108 l38 -30l-92 -130h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 277,
    d: "M12 0zM29 0v480h80l3 -82h4q14 42 40 65t64 23q21 0 40 -10v-79q-15 10 -45 10q-40 0 -64 -24t-36 -88v-295h-86zM105 522l-93 130l38 30l94 -108l94 108l38 -30l-92 -130h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 375,
    d: "M23 0zM256 468v38q0 37 -16.5 58.5t-54.5 21.5q-36 0 -53 -20t-17 -49v-26q0 -22 8 -37t31 -34q17 -13 37.5 -26.5t40.5 -26.5t39 -26t33 -25q23 -20 35.5 -47t12.5 -73v-41q0 -78 -38.5 -119.5t-126.5 -41.5t-126 42.5t-38 124.5v38h85v-39q0 -41 18 -62t59 -21 q35 0 54 18t19 58v30q0 15 -2 26.5t-7 21t-13.5 18t-20.5 18.5q-35 29 -71 51t-67 52q-25 26 -38 54t-13 68v29q0 66 37.5 107.5t120.5 41.5q45 0 75 -13t48 -36t25.5 -55t7.5 -69v-29h-84zM141 677l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 353,
    d: "M25 0zM242 332v28q0 26 -15 40t-49 14q-66 0 -66 -47v-15q0 -15 6.5 -24.5t28.5 -23.5q34 -21 67 -34t62 -33q25 -17 38.5 -38t13.5 -58v-22q0 -63 -35.5 -94t-112.5 -31q-82 0 -118.5 33.5t-36.5 97.5v29h82v-32q0 -29 15.5 -43t53.5 -14q35 0 51 13t16 40v19 q0 15 -7.5 28t-34.5 28q-2 1 -18.5 9.5t-37 20t-41 23.5t-31.5 20q-24 18 -33.5 39t-9.5 46v24q0 50 37.5 80.5t107.5 30.5q75 0 111.5 -35t36.5 -95v-24h-81zM132 504l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scedilla",
    unicode: "\u015E",
    horizAdvX: 375,
    d: "M23 0zM256 468v38q0 37 -16.5 58.5t-54.5 21.5q-36 0 -53 -20t-17 -49v-26q0 -22 8 -37t31 -34q17 -13 37.5 -26.5t40.5 -26.5t39 -26t33 -25q23 -20 35.5 -47t12.5 -73v-41q0 -78 -38.5 -119.5t-126.5 -41.5t-126 42.5t-38 124.5v38h85v-39q0 -41 18 -62t59 -21 q35 0 54 18t19 58v30q0 15 -2 26.5t-7 21t-13.5 18t-20.5 18.5q-35 29 -71 51t-67 52q-25 26 -38 54t-13 68v29q0 66 37.5 107.5t120.5 41.5q45 0 75 -13t48 -36t25.5 -55t7.5 -69v-29h-84zM147 -182q19 6 28.5 17.5t9.5 35.5v15h-38v96h77v-90q0 -54 -18 -81.5t-59 -34.5 v42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scedilla",
    unicode: "\u0218",
    horizAdvX: 375,
    d: "M23 0zM256 468v38q0 37 -16.5 58.5t-54.5 21.5q-36 0 -53 -20t-17 -49v-26q0 -22 8 -37t31 -34q17 -13 37.5 -26.5t40.5 -26.5t39 -26t33 -25q23 -20 35.5 -47t12.5 -73v-41q0 -78 -38.5 -119.5t-126.5 -41.5t-126 42.5t-38 124.5v38h85v-39q0 -41 18 -62t59 -21 q35 0 54 18t19 58v30q0 15 -2 26.5t-7 21t-13.5 18t-20.5 18.5q-35 29 -71 51t-67 52q-25 26 -38 54t-13 68v29q0 66 37.5 107.5t120.5 41.5q45 0 75 -13t48 -36t25.5 -55t7.5 -69v-29h-84zM147 -182q19 6 28.5 17.5t9.5 35.5v15h-38v96h77v-90q0 -54 -18 -81.5t-59 -34.5 v42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scedilla",
    unicode: "\u015F",
    horizAdvX: 353,
    d: "M25 0zM242 332v28q0 26 -15 40t-49 14q-66 0 -66 -47v-15q0 -15 6.5 -24.5t28.5 -23.5q34 -21 67 -34t62 -33q25 -17 38.5 -38t13.5 -58v-22q0 -63 -35.5 -94t-112.5 -31q-82 0 -118.5 33.5t-36.5 97.5v29h82v-32q0 -29 15.5 -43t53.5 -14q35 0 51 13t16 40v19 q0 15 -7.5 28t-34.5 28q-2 1 -18.5 9.5t-37 20t-41 23.5t-31.5 20q-24 18 -33.5 39t-9.5 46v24q0 50 37.5 80.5t107.5 30.5q75 0 111.5 -35t36.5 -95v-24h-81zM138 -182q19 6 28.5 17.5t9.5 35.5v15h-38v96h77v-90q0 -54 -18 -81.5t-59 -34.5v42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scedilla",
    unicode: "\u0219",
    horizAdvX: 353,
    d: "M25 0zM242 332v28q0 26 -15 40t-49 14q-66 0 -66 -47v-15q0 -15 6.5 -24.5t28.5 -23.5q34 -21 67 -34t62 -33q25 -17 38.5 -38t13.5 -58v-22q0 -63 -35.5 -94t-112.5 -31q-82 0 -118.5 33.5t-36.5 97.5v29h82v-32q0 -29 15.5 -43t53.5 -14q35 0 51 13t16 40v19 q0 15 -7.5 28t-34.5 28q-2 1 -18.5 9.5t-37 20t-41 23.5t-31.5 20q-24 18 -33.5 39t-9.5 46v24q0 50 37.5 80.5t107.5 30.5q75 0 111.5 -35t36.5 -95v-24h-81zM138 -182q19 6 28.5 17.5t9.5 35.5v15h-38v96h77v-90q0 -54 -18 -81.5t-59 -34.5v42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 375,
    d: "M23 0zM256 468v38q0 37 -16.5 58.5t-54.5 21.5q-36 0 -53 -20t-17 -49v-26q0 -22 8 -37t31 -34q17 -13 37.5 -26.5t40.5 -26.5t39 -26t33 -25q23 -20 35.5 -47t12.5 -73v-41q0 -78 -38.5 -119.5t-126.5 -41.5t-126 42.5t-38 124.5v38h85v-39q0 -41 18 -62t59 -21 q35 0 54 18t19 58v30q0 15 -2 26.5t-7 21t-13.5 18t-20.5 18.5q-35 29 -71 51t-67 52q-25 26 -38 54t-13 68v29q0 66 37.5 107.5t120.5 41.5q45 0 75 -13t48 -36t25.5 -55t7.5 -69v-29h-84zM150 695l-93 130l38 30l94 -108l94 108l38 -30l-92 -130h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 353,
    d: "M25 0zM242 332v28q0 26 -15 40t-49 14q-66 0 -66 -47v-15q0 -15 6.5 -24.5t28.5 -23.5q34 -21 67 -34t62 -33q25 -17 38.5 -38t13.5 -58v-22q0 -63 -35.5 -94t-112.5 -31q-82 0 -118.5 33.5t-36.5 97.5v29h82v-32q0 -29 15.5 -43t53.5 -14q35 0 51 13t16 40v19 q0 15 -7.5 28t-34.5 28q-2 1 -18.5 9.5t-37 20t-41 23.5t-31.5 20q-24 18 -33.5 39t-9.5 46v24q0 50 37.5 80.5t107.5 30.5q75 0 111.5 -35t36.5 -95v-24h-81zM136 522l-93 130l38 30l94 -108l94 108l38 -30l-92 -130h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcommaaccent",
    unicode: "\u0162",
    horizAdvX: 350,
    d: "M19 0zM130 0v583h-111v81h313v-81h-113v-583h-89zM136 -182q19 6 28.5 17.5t9.5 35.5v15h-38v96h77v-90q0 -54 -18 -81.5t-59 -34.5v42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcommaaccent",
    unicode: "\u021A",
    horizAdvX: 350,
    d: "M19 0zM130 0v583h-111v81h313v-81h-113v-583h-89zM136 -182q19 6 28.5 17.5t9.5 35.5v15h-38v96h77v-90q0 -54 -18 -81.5t-59 -34.5v42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcommaaccent",
    unicode: "\u0163",
    horizAdvX: 343,
    d: "M29 0zM239 274h74v-130q0 -76 -29 -113t-105 -37q-78 0 -114 37t-36 113v469h85v-133h199v-77h-199v-259q0 -72 66 -72q32 0 45.5 17.5t13.5 54.5v130zM135 -182q19 6 28.5 17.5t9.5 35.5v15h-38v96h77v-90q0 -54 -18 -81.5t-59 -34.5v42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcommaaccent",
    unicode: "\u021B",
    horizAdvX: 343,
    d: "M29 0zM239 274h74v-130q0 -76 -29 -113t-105 -37q-78 0 -114 37t-36 113v469h85v-133h199v-77h-199v-259q0 -72 66 -72q32 0 45.5 17.5t13.5 54.5v130zM135 -182q19 6 28.5 17.5t9.5 35.5v15h-38v96h77v-90q0 -54 -18 -81.5t-59 -34.5v42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 350,
    d: "M19 0zM130 0v583h-111v81h313v-81h-113v-583h-89zM137 687l-93 130l38 30l94 -108l94 108l38 -30l-92 -130h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 433,
    d: "M29 0zM239 274h74v-130q0 -76 -29 -113t-105 -37q-78 0 -114 37t-36 113v469h85v-133h199v-77h-199v-259q0 -72 66 -72q32 0 45.5 17.5t13.5 54.5v130zM330 439q20 12 29.5 31.5t9.5 52.5v29h-39v120h88v-138q0 -65 -22 -100t-66 -47v52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 350,
    d: "M130 0v291h-72v56h72v236h-111v81h313v-81h-113v-236h73v-56h-73v-291h-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 343,
    d: "M114 301v-157q0 -72 66 -72q32 0 45.5 17.5t13.5 54.5v113h74v-113q0 -76 -29 -113t-105 -37q-78 0 -114 37t-36 113v469h85v-133h199v-77h-199v-54h186v-48h-186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 368,
    d: "M27 0zM252 664h88v-502q0 -81 -39 -124.5t-117 -43.5q-75 0 -116 41t-41 125v504h88v-509q0 -78 68 -78q69 0 69 79v508zM319 761q-8 -31 -27.5 -45t-45.5 -14q-17 0 -31.5 5t-28.5 11.5t-28.5 11.5t-30.5 5q-14 0 -23.5 -6t-16.5 -23l-39 23q9 31 28 45t45 14 q16 0 31 -5t29 -11.5t28.5 -11.5t30.5 -5q14 0 24 6t16 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 363,
    d: "M29 0zM116 480v-336q0 -41 15 -57.5t47 -16.5t46.5 17t23.5 61v332h86v-480h-81l-2 69h-4q-17 -41 -41.5 -58t-64.5 -17q-62 0 -87 38.5t-25 112.5v335h87zM318 588q-8 -31 -27.5 -45t-45.5 -14q-17 0 -31.5 5t-28.5 11.5t-28.5 11.5t-30.5 5q-14 0 -23.5 -6t-16.5 -23 l-39 23q9 31 28 45t45 14q16 0 31 -5t29 -11.5t28.5 -11.5t30.5 -5q14 0 24 6t16 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 368,
    d: "M27 0zM252 664h88v-502q0 -81 -39 -124.5t-117 -43.5q-75 0 -116 41t-41 125v504h88v-509q0 -78 68 -78q69 0 69 79v508zM67 735v55h234v-55h-234z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 363,
    d: "M29 0zM116 480v-336q0 -41 15 -57.5t47 -16.5t46.5 17t23.5 61v332h86v-480h-81l-2 69h-4q-17 -41 -41.5 -58t-64.5 -17q-62 0 -87 38.5t-25 112.5v335h87zM65 562v55h234v-55h-234z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 368,
    d: "M27 0zM252 664h88v-502q0 -81 -39 -124.5t-117 -43.5q-75 0 -116 41t-41 125v504h88v-509q0 -78 68 -78q69 0 69 79v508zM182 677q-60 0 -97.5 39.5t-37.5 119.5h63q2 -53 19.5 -77.5t52.5 -24.5q34 0 52 24.5t19 77.5h65q0 -81 -38 -120t-98 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 363,
    d: "M29 0zM116 480v-336q0 -41 15 -57.5t47 -16.5t46.5 17t23.5 61v332h86v-480h-81l-2 69h-4q-17 -41 -41.5 -58t-64.5 -17q-62 0 -87 38.5t-25 112.5v335h87zM181 504q-60 0 -97.5 39.5t-37.5 119.5h63q2 -53 19.5 -77.5t52.5 -24.5q34 0 52 24.5t19 77.5h65 q0 -81 -38 -120t-98 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 368,
    d: "M27 0zM252 664h88v-502q0 -81 -39 -124.5t-117 -43.5q-75 0 -116 41t-41 125v504h88v-509q0 -78 68 -78q69 0 69 79v508zM185 715q47 0 47 55q0 27 -12 42t-35 15t-35 -15t-12 -42q0 -55 47 -55zM185 677q-44 0 -65 24.5t-21 68.5q0 45 21 69.5t65 24.5q43 0 64 -24.5 t21 -69.5q0 -44 -21 -68.5t-64 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 363,
    d: "M29 0zM116 480v-336q0 -41 15 -57.5t47 -16.5t46.5 17t23.5 61v332h86v-480h-81l-2 69h-4q-17 -41 -41.5 -58t-64.5 -17q-62 0 -87 38.5t-25 112.5v335h87zM183 542q47 0 47 55q0 27 -12 42t-35 15t-35 -15t-12 -42q0 -55 47 -55zM183 504q-44 0 -65 24.5t-21 68.5 q0 45 21 69.5t65 24.5q43 0 64 -24.5t21 -69.5q0 -44 -21 -68.5t-64 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 368,
    d: "M27 0zM252 664h88v-502q0 -81 -39 -124.5t-117 -43.5q-75 0 -116 41t-41 125v504h88v-509q0 -78 68 -78q69 0 69 79v508zM70 697l93 178l56 -32l-109 -166zM188 697l93 178l56 -32l-109 -166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 363,
    d: "M29 0zM116 480v-336q0 -41 15 -57.5t47 -16.5t46.5 17t23.5 61v332h86v-480h-81l-2 69h-4q-17 -41 -41.5 -58t-64.5 -17q-62 0 -87 38.5t-25 112.5v335h87zM68 524l93 178l56 -32l-109 -166zM186 524l93 178l56 -32l-109 -166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 368,
    d: "M229 -211q-12 -7 -28.5 -10t-36.5 -3q-93 0 -93 78v27q0 38 23 65t64 43v6q-64 7 -97.5 47.5t-33.5 117.5v504h88v-509q0 -78 68 -78q69 0 69 79v508h88v-502q0 -70 -29 -112t-87 -52q-45 -17 -69 -41t-24 -50v-22q0 -33 50 -33q12 0 25 1.5t23 6.5v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 363,
    d: "M332 -211q-25 -13 -65 -13q-94 0 -94 78v27q0 42 28.5 70t77.5 43v6h-26l-2 69h-4q-17 -41 -41.5 -58t-64.5 -17q-62 0 -87 38.5t-25 112.5v335h87v-336q0 -41 15 -57.5t47 -16.5t46.5 17t23.5 61v332h86v-480q-49 -17 -74.5 -42t-25.5 -51v-22q0 -33 50 -33 q11 0 24.5 1.5t23.5 6.5v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 545,
    d: "M12 0zM92 0l-80 664h86l58 -505h4l62 505h101l64 -505h4l57 505h85l-80 -664h-113l-66 514h-4l-65 -514h-113zM366 678l-94 108l-94 -108l-38 30l92 129h79l93 -129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 498,
    d: "M10 0zM82 0l-72 480h80l52 -360h4l56 360h94l58 -360h4l51 360h79l-72 -480h-105l-60 367h-4l-60 -367h-105zM343 505l-94 108l-94 -108l-38 30l92 129h79l93 -129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 369,
    d: "M10 0zM141 0v281l-131 383h87l88 -264h4l84 264h85l-127 -384v-280h-90zM283 678l-94 108l-94 -108l-38 30l92 129h79l93 -129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    d: "M29 0zM116 151q0 -38 16.5 -55t46.5 -17q29 0 45 17t26 59v325h83v-563q0 -150 -152 -150q-77 0 -113 37t-36 113v53h82v-53q0 -72 66 -72q67 0 67 72v149h-4q-16 -37 -41 -51.5t-61 -14.5q-63 0 -87.5 34.5t-24.5 91.5v354h87v-329zM281 505l-94 108l-94 -108l-38 30 l92 129h79l93 -129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 369,
    d: "M10 0zM141 0v281l-131 383h87l88 -264h4l84 264h85l-127 -384v-280h-90zM71 700v108h80v-108h-80zM222 700v108h80v-108h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u03AB",
    horizAdvX: 369,
    d: "M10 0zM141 0v281l-131 383h87l88 -264h4l84 264h85l-127 -384v-280h-90zM71 700v108h80v-108h-80zM222 700v108h80v-108h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 337,
    d: "M19 0zM19 0v83l203 500h-201v81h292v-82l-201 -501h206v-81h-299zM126 677l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 307,
    d: "M21 0zM21 0v81l171 322h-170v77h261v-78l-171 -323h175v-79h-266zM111 504l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 337,
    d: "M19 0zM19 0v83l203 500h-201v81h292v-82l-201 -501h206v-81h-299zM121 712v108h86v-108h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 307,
    d: "M21 0zM21 0v81l171 322h-170v77h261v-78l-171 -323h175v-79h-266zM105 539v108h86v-108h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 337,
    d: "M19 0zM19 0v83l203 500h-201v81h292v-82l-201 -501h206v-81h-299zM131 688l-93 130l38 30l94 -108l94 108l38 -30l-92 -130h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 307,
    d: "M21 0zM21 0v81l171 322h-170v77h261v-78l-171 -323h175v-79h-266zM115 522l-93 130l38 30l94 -108l94 108l38 -30l-92 -130h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni018E",
    unicode: "\u018E",
    horizAdvX: 292,
    d: "M264 664v-664h-240v81h152v194h-139v82h139v226h-160v81h248z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni018F",
    unicode: "\u018F",
    horizAdvX: 359,
    d: "M29 336q0 150 152 150q76 0 112.5 -36.5t36.5 -113.5v-192q0 -76 -36.5 -113t-113.5 -37q-151 0 -151 150v119h217v75q0 72 -65 72q-67 0 -67 -72v-24h-85v22zM114 142q0 -72 66 -72t66 72v57h-132v-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni018F",
    unicode: "\u04D8",
    horizAdvX: 359,
    d: "M29 336q0 150 152 150q76 0 112.5 -36.5t36.5 -113.5v-192q0 -76 -36.5 -113t-113.5 -37q-151 0 -151 150v119h217v75q0 72 -65 72q-67 0 -67 -72v-24h-85v22zM114 142q0 -72 66 -72t66 72v57h-132v-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    horizAdvX: 313,
    d: "M211 395l-59 -465q-4 -30 -12 -50t-21.5 -31.5t-33 -16.5t-46.5 -5h-32v79h17q40 0 44 38l57 451h-67v56h74l16 118q7 59 33 81t79 22h36v-79h-21q-21 0 -31 -9t-13 -29l-13 -104h78v-56h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0194",
    unicode: "\u0194",
    horizAdvX: 412,
    d: "M206 -233q-59 0 -83.5 31.5t-24.5 90.5q0 16 2.5 35.5t9.5 52t20 82t34 126.5l-141 479h90l86 -318h12l87 318h90l-141 -479q21 -76 34 -125.5t20 -81.5t9.5 -51.5t2.5 -36.5q0 -60 -24 -91.5t-83 -31.5zM199 33q-17 -52 -24 -84t-7 -62q0 -34 9 -47t29 -13q21 0 29 14 t8 44t-7.5 63t-24.5 85h-12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni019D",
    unicode: "\u019D",
    horizAdvX: 392,
    d: "M259 0l-152 514h-4q3 -74 3 -140v-457q0 -76 -33.5 -113t-90.5 -37q-11 0 -19.5 1t-13.5 3v77q5 -2 11.5 -2.5t12.5 -0.5q27 0 40.5 17t13.5 55v747h118l139 -477h4q-3 94 -3 161v316h79v-664h-105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohorn",
    unicode: "\u01A0",
    horizAdvX: 420,
    d: "M338 160q0 -85 -40.5 -125.5t-115.5 -40.5q-78 0 -118.5 43.5t-40.5 124.5v337q0 82 41 126.5t115 44.5q32 0 64 -5.5t64 -5.5q30 0 41.5 9.5t11.5 35.5q0 9 -1 24t-4 24h49q5 -8 6.5 -23t1.5 -32q0 -49 -15 -70t-50 -21q-7 0 -18.5 1t-24.5 3q34 -42 34 -113v-337z M250 505q0 39 -18 60t-51 21t-51 -20.5t-18 -59.5v-350q0 -79 69 -79q33 0 51 19t18 59v350z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohorn",
    unicode: "\u01A1",
    horizAdvX: 404,
    d: "M329 144q0 -78 -36.5 -114t-113.5 -36t-113.5 36t-36.5 114v192q0 150 145 150q35 0 63 -5.5t57 -5.5t39.5 9.5t10.5 35.5q0 9 -1 24t-4 24h49q5 -8 7 -23t2 -32q0 -49 -15 -70t-49 -21h-13.5t-13.5 1q23 -34 23 -87v-192zM245 336q0 72 -66 72t-66 -72v-192 q0 -72 66 -72t66 72v192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhorn",
    unicode: "\u01AF",
    horizAdvX: 455,
    d: "M252 664h102q22 0 31.5 9t9.5 33q0 8 -1 22t-4 24h49q5 -8 7 -23t2 -32q0 -49 -15 -68.5t-49 -19.5q-11 0 -21.5 1t-22.5 4v-452q0 -83 -39 -125.5t-117 -42.5q-76 0 -116.5 40.5t-40.5 125.5v504h88v-509q0 -78 68 -78q69 0 69 79v508z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhorn",
    unicode: "\u01B0",
    horizAdvX: 444,
    d: "M116 480v-342q0 -36 16 -52t45 -16t44.5 16t26.5 54v340h98q20 0 29.5 8.5t9.5 33.5q0 8 -1.5 22t-3.5 24h49q5 -8 6.5 -23t1.5 -32q0 -48 -14.5 -68t-49.5 -20q-9 0 -19 1t-20 4v-430h-80l-3 69h-4q-15 -36 -40 -55.5t-63 -19.5q-33 0 -55 11.5t-35.5 31.5t-19 48.5 t-5.5 61.5v333h87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01DD",
    unicode: "\u01DD",
    horizAdvX: 359,
    d: "M29 336q0 150 152 150q76 0 112.5 -36.5t36.5 -113.5v-192q0 -76 -36.5 -113t-113.5 -37q-151 0 -151 150v119h217v75q0 72 -65 72q-67 0 -67 -72v-24h-85v22zM114 142q0 -72 66 -72t66 72v57h-132v-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01DD",
    unicode: "\u04D9",
    horizAdvX: 359,
    d: "M29 336q0 150 152 150q76 0 112.5 -36.5t36.5 -113.5v-192q0 -76 -36.5 -113t-113.5 -37q-151 0 -151 150v119h217v75q0 72 -65 72q-67 0 -67 -72v-24h-85v22zM114 142q0 -72 66 -72t66 72v57h-132v-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01E6",
    unicode: "\u01E6",
    horizAdvX: 363,
    d: "M27 0zM277 0l-4 51h-4q-13 -24 -35 -40.5t-65 -16.5q-68 0 -105 43.5t-37 124.5v337q0 81 39.5 126t114.5 45q76 0 115.5 -46t39.5 -127v-38h-85v46q0 39 -17 60t-51 21q-67 0 -67 -80v-350q0 -79 65 -79q58 0 70 67v131h-75v80h160v-355h-59zM147 695l-93 130l38 30 l94 -108l94 108l38 -30l-92 -130h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01E7",
    unicode: "\u01E7",
    d: "M29 0zM116 170q0 -47 13.5 -69t45.5 -22q28 0 44.5 16.5t30.5 53.5v185q-8 40 -21.5 58t-48.5 18q-32 0 -48 -16t-16 -56v-168zM333 -83q0 -150 -153 -150q-77 0 -112.5 37.5t-35.5 112.5v53h82v-53q0 -72 66 -72q67 0 67 72v149h-4q-26 -66 -102 -66q-60 0 -86 39 t-26 115v204q0 57 28 92.5t85 35.5q37 0 63 -17.5t44 -57.5h4l3 69h77v-563zM143 522l-93 130l38 30l94 -108l94 108l38 -30l-92 -130h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F4",
    unicode: "\u01F4",
    horizAdvX: 363,
    d: "M27 0zM277 0l-4 51h-4q-13 -24 -35 -40.5t-65 -16.5q-68 0 -105 43.5t-37 124.5v337q0 81 39.5 126t114.5 45q76 0 115.5 -46t39.5 -127v-38h-85v46q0 39 -17 60t-51 21q-67 0 -67 -80v-350q0 -79 65 -79q58 0 70 67v131h-75v80h160v-355h-59zM141 677l-34 35l149 163 l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F5",
    unicode: "\u01F5",
    d: "M29 0zM116 170q0 -47 13.5 -69t45.5 -22q28 0 44.5 16.5t30.5 53.5v185q-8 40 -21.5 58t-48.5 18q-32 0 -48 -16t-16 -56v-168zM333 -83q0 -150 -153 -150q-77 0 -112.5 37.5t-35.5 112.5v53h82v-53q0 -72 66 -72q67 0 67 72v149h-4q-26 -66 -102 -66q-60 0 -86 39 t-26 115v204q0 57 28 92.5t85 35.5q37 0 63 -17.5t44 -57.5h4l3 69h77v-563zM141 504l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F8",
    unicode: "\u01F8",
    horizAdvX: 392,
    d: "M27 0zM259 0l-152 514h-4q3 -74 3 -140v-374h-79v664h118l139 -477h4q-3 94 -3 161v316h79v-664h-105zM83 823l46 52l149 -163l-34 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F9",
    unicode: "\u01F9",
    horizAdvX: 365,
    d: "M29 0zM249 0v342q0 68 -62 68q-30 0 -45.5 -16t-26.5 -54v-340h-86v480h80l3 -69h4q16 39 41.5 57t63.5 18q51 0 83 -32.5t32 -95.5v-358h-87zM68 650l46 52l149 -163l-34 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessj",
    unicode: "\u0237",
    horizAdvX: 167,
    d: "M-163 -27h82v-56q0 -72 66 -72q67 0 67 72v563h86v-563q0 -150 -152 -150q-77 0 -113 37t-36 113v56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0241",
    unicode: "\u0241",
    horizAdvX: 343,
    d: "M124 0v183q0 42 5 67.5t16 47.5q16 33 39.5 62t39.5 61q6 12 8.5 24.5t2.5 38.5v28q0 39 -13 56.5t-51 17.5q-45 0 -57 -23t-12 -70v-22h-84v17q0 45 4.5 79t20.5 57t46 34.5t81 11.5q48 0 77 -10t45.5 -30.5t22 -50.5t5.5 -70v-29q0 -27 -4 -45.5t-13 -35.5 q-15 -29 -39.5 -58t-38.5 -61q-3 -8 -5.5 -15t-3.5 -17.5t-1.5 -25t-0.5 -36.5v-186h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0242",
    unicode: "\u0242",
    horizAdvX: 358,
    d: "M135 0v73q0 20 4.5 37.5t12.5 32.5q17 34 40 58t38 51q7 12 11 25t4 27v43q0 38 -13 55.5t-51 17.5q-41 0 -54.5 -20t-13.5 -61v-38h-83v26q0 45 7.5 77t24.5 53t46 31t71 10q82 0 116 -37t34 -116v-42q0 -17 -4 -32t-10 -29q-8 -17 -19.5 -31t-23.5 -28t-22.5 -28.5 t-17.5 -30.5q-4 -9 -7.5 -22.5t-3.5 -29.5v-72h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni024C",
    unicode: "\u024C",
    horizAdvX: 398,
    d: "M63 0v289h-57v75h57v300h184q70 0 98 -35t28 -98v-91q0 -91 -67 -108v-4q35 -7 52.5 -32t17.5 -75v-221h-88v228q0 32 -12.5 46.5t-44.5 14.5h-80v-289h-88zM287 521q0 31 -13.5 46.5t-45.5 15.5h-77v-219h78q26 0 42 15t16 53v89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni024D",
    unicode: "\u024D",
    horizAdvX: 297,
    d: "M50 0v184h-43v56h43v240h79l3 -82h4q14 42 40 65t64 23q21 0 40 -10v-79q-15 10 -45 10q-39 0 -63 -24t-36 -88v-55h105v-56h-105v-184h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0263",
    unicode: "\u0263",
    horizAdvX: 354,
    d: "M214 111q19 -60 30.5 -99t18 -64t8.5 -41t2 -30q0 -110 -96 -110q-95 0 -95 112q0 13 2 28.5t8 40.5t17.5 64t30.5 99l-130 369h88l75 -244h8l76 244h87zM172 0q-17 -51 -22.5 -80t-5.5 -48q0 -24 7 -35t26 -11q17 0 25.5 10t8.5 34q0 17 -5.5 47t-24.5 83h-9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0272",
    unicode: "\u0272",
    horizAdvX: 365,
    d: "M249 0v342q0 68 -62 68q-30 0 -45.5 -16t-26.5 -54v-423q0 -76 -36 -113t-99 -37q-13 0 -21.5 1t-14.5 3v77q5 -2 12 -2.5t13 -0.5q31 0 45.5 17t14.5 55v563h80l3 -69h4q16 39 41.5 57t63.5 18q51 0 83 -32.5t32 -95.5v-358h-87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 326,
    d: "M257 505l-94 108l-94 -108l-38 30l92 129h79l93 -129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 324,
    d: "M124 522l-93 130l38 30l94 -108l94 108l38 -30l-92 -130h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni02C9",
    unicode: "\u02C9",
    horizAdvX: 0,
    d: "M-65 562zM-299 562v55h234v-55h-234z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 331,
    d: "M165 504q-60 0 -97.5 39.5t-37.5 119.5h63q2 -53 19.5 -77.5t52.5 -24.5q34 0 52 24.5t19 77.5h65q0 -81 -38 -120t-98 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 141,
    d: "M27 539v108h86v-108h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 227,
    d: "M113 542q47 0 47 55q0 27 -12 42t-35 15t-35 -15t-12 -42q0 -55 47 -55zM113 504q-44 0 -65 24.5t-21 68.5q0 45 21 69.5t65 24.5q43 0 64 -24.5t21 -69.5q0 -44 -21 -68.5t-64 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 207,
    d: "M178 -211q-12 -7 -28.5 -10t-36.5 -3q-93 0 -93 78v27q0 47 35 76t92 43h33q-48 -17 -74 -42t-26 -51v-22q0 -33 50 -33q12 0 25 1.5t23 6.5v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 326,
    d: "M298 588q-8 -31 -27.5 -45t-45.5 -14q-17 0 -31.5 5t-28.5 11.5t-28.5 11.5t-30.5 5q-14 0 -23.5 -6t-16.5 -23l-39 23q9 31 28 45t45 14q16 0 31 -5t29 -11.5t28.5 -11.5t30.5 -5q14 0 24 6t16 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 323,
    d: "M28 524l93 178l56 -32l-109 -166zM146 524l93 178l56 -32l-109 -166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gravecomb",
    unicode: "\u0300",
    horizAdvX: 0,
    d: "M-104 504zM-299 650l46 52l149 -163l-34 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acutecomb",
    unicode: "\u0301",
    horizAdvX: 0,
    d: "M-77 504zM-238 504l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0302",
    unicode: "\u0302",
    horizAdvX: 0,
    d: "M-50 505zM-88 505l-94 108l-94 -108l-38 30l92 129h79l93 -129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tildecomb",
    unicode: "\u0303",
    horizAdvX: 0,
    d: "M-46 529zM-46 588q-8 -31 -27.5 -45t-45.5 -14q-17 0 -31.5 5t-28.5 11.5t-28.5 11.5t-30.5 5q-14 0 -23.5 -6t-16.5 -23l-39 23q9 31 28 45t45 14q16 0 31 -5t29 -11.5t28.5 -11.5t30.5 -5q14 0 24 6t16 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0304",
    unicode: "\u0304",
    horizAdvX: 0,
    d: "M-65 562zM-299 562v55h234v-55h-234z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0306",
    unicode: "\u0306",
    horizAdvX: 0,
    d: "M-46 504zM-182 504q-60 0 -97.5 39.5t-37.5 119.5h63q2 -53 19.5 -77.5t52.5 -24.5q34 0 52 24.5t19 77.5h65q0 -81 -38 -120t-98 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0307",
    unicode: "\u0307",
    horizAdvX: 0,
    d: "M-138 539zM-224 539v108h86v-108h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0308",
    unicode: "\u0308",
    horizAdvX: 0,
    d: "M-67 539zM-298 539v108h80v-108h-80zM-147 539v108h80v-108h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hookabovecomb",
    unicode: "\u0309",
    horizAdvX: 0,
    d: "M-215 517q0 21 9.5 32.5t20.5 20t20.5 16.5t9.5 23q0 12 -8 20t-25 8q-16 0 -28.5 -5.5t-26.5 -15.5l-15 47q15 14 37.5 20.5t40.5 6.5q32 0 53.5 -20t21.5 -53q0 -24 -10.5 -37.5t-23 -22.5t-23 -17.5t-10.5 -22.5h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030A",
    unicode: "\u030A",
    horizAdvX: 0,
    d: "M-96 504zM-181 542q47 0 47 55q0 27 -12 42t-35 15t-35 -15t-12 -42q0 -55 47 -55zM-181 504q-44 0 -65 24.5t-21 68.5q0 45 21 69.5t65 24.5q43 0 64 -24.5t21 -69.5q0 -44 -21 -68.5t-64 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030B",
    unicode: "\u030B",
    horizAdvX: 0,
    d: "M-40 504zM-307 524l93 178l56 -32l-109 -166zM-189 524l93 178l56 -32l-109 -166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030C",
    unicode: "\u030C",
    horizAdvX: 0,
    d: "M-49 522zM-220 522l-93 130l38 30l94 -108l94 108l38 -30l-92 -130h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0313",
    unicode: "\u0313",
    horizAdvX: 0,
    d: "M-144 522zM-143.998 686.989q-18.999 -6 -28.498 -17.499q-9.5 -11.5 -9.5 -35.498v-14.999h37.998v-95.9941h-76.9951v89.9941q0 53.9971 17.998 81.4951q17.999 27.498 58.9971 34.498v-41.9971z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni031B",
    unicode: "\u031B",
    horizAdvX: 68,
    d: "M-110 480q22 -2 41 -3.5t33 -1.5q28 0 36.5 8.5t8.5 33.5q0 29 -5 51h49q8 -18 8 -57q0 -48 -15.5 -68.5t-49.5 -20.5q-23 0 -51.5 7.5t-54.5 18.5v32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotbelowcomb",
    unicode: "\u0323",
    horizAdvX: 0,
    d: "M-224 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0326",
    unicode: "\u0326",
    horizAdvX: 0,
    d: "M-143 -18zM-220 -182q19 6 28.5 17.5t9.5 35.5v15h-38v96h77v-90q0 -54 -18 -81.5t-59 -34.5v42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0328",
    unicode: "\u0328",
    horizAdvX: 0,
    d: "M-102 0zM-104 -211q-12 -7 -28.5 -10t-36.5 -3q-93 0 -93 78v27q0 47 35 76t92 43h33q-48 -17 -74 -42t-26 -51v-22q0 -33 50 -33q12 0 25 1.5t23 6.5v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni032D",
    unicode: "\u032D",
    horizAdvX: 0,
    d: "M-50 -56zM-88 -215l-94 108l-94 -108l-38 30l92 129h79l93 -129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tonos",
    unicode: "\u0384",
    horizAdvX: 96,
    d: "M18 527v201h71l-17 -201h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresistonos",
    unicode: "\u0385",
    horizAdvX: 0,
    d: "M-29 527zM-208 527v201h71l-17 -201h-54zM-328 539v108h86v-108h-86zM-115 539v108h86v-108h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Alphatonos",
    unicode: "\u0386",
    horizAdvX: 401,
    d: "M18 0zM300 0l-26 156h-122l-24 -156h-87l113 664h121l113 -664h-88zM164 233h98l-47 291h-4zM18 527v201h71l-17 -201h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "anoteleia",
    unicode: "\u0387",
    horizAdvX: 142,
    d: "M27 326zM27 326v120h88v-120h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Epsilontonos",
    unicode: "\u0388",
    horizAdvX: 373,
    d: "M18 0zM108 0v664h240v-81h-152v-194h139v-82h-139v-226h160v-81h-248zM18 527v201h71l-17 -201h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Etatonos",
    unicode: "\u0389",
    horizAdvX: 453,
    d: "M18 0zM336 0v312h-140v-312h-90v664h90v-272h140v272h89v-664h-89zM18 527v201h71l-17 -201h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iotatonos",
    unicode: "\u038A",
    horizAdvX: 223,
    d: "M18 0zM106 0v664h90v-664h-90zM18 527v201h71l-17 -201h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omicrontonos",
    unicode: "\u038C",
    horizAdvX: 436,
    d: "M18 0zM412 160q0 -84 -40.5 -125t-115.5 -41q-78 0 -118.5 43.5t-40.5 124.5v337q0 81 41.5 126t116.5 45t116 -46t41 -127v-337zM324 505q0 39 -18 60t-52 21q-32 0 -50 -20.5t-18 -59.5v-350q0 -79 69 -79q33 0 51 19t18 59v350zM18 527v201h71l-17 -201h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Upsilontonos",
    unicode: "\u038E",
    horizAdvX: 462,
    d: "M18 0zM235 0v281l-131 383h87l88 -264h4l84 264h85l-127 -384v-280h-90zM18 527v201h71l-17 -201h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omegatonos",
    unicode: "\u038F",
    horizAdvX: 463,
    d: "M18 0zM293 0v73q52 20 52 153v287q0 73 -75 73q-76 0 -76 -73v-287q0 -134 52 -153v-73h-153v78h71v4q-61 45 -61 145v296q0 72 44 109.5t122 37.5t122 -37.5t44 -109.5v-296q0 -100 -60 -145v-4h71v-78h-153zM18 527v201h71l-17 -201h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iotadieresistonos",
    unicode: "\u0390",
    horizAdvX: 285,
    d: "M0 0zM207 0q-112 0 -112 116v364h86v-364q0 -39 27 -39h16v-77h-17zM113 527v201h71l-17 -201h-54zM-8 539v108h86v-108h-86zM205 539v108h86v-108h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0413",
    unicode: "\u0393",
    horizAdvX: 299,
    d: "M27 0v664h254v-82h-164v-582h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0413",
    unicode: "\u0413",
    horizAdvX: 299,
    d: "M27 0v664h254v-82h-164v-582h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Delta",
    unicode: "\u0394",
    horizAdvX: 372,
    d: "M12 0l113 664h121l113 -664h-347zM186 524h-4l-74 -442h153z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Theta",
    unicode: "\u0398",
    d: "M338 160q0 -85 -40.5 -125.5t-115.5 -40.5q-78 0 -118.5 43.5t-40.5 124.5v337q0 81 41.5 126t116.5 45t116 -46t41 -127v-337zM128 307v82h106v-82h-106zM256 505q0 39 -19.5 60t-56.5 21q-74 0 -74 -80v-350q0 -79 75 -79t75 78v350z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lambda",
    unicode: "\u039B",
    horizAdvX: 372,
    d: "M246 664l113 -664h-88l-85 524h-4l-83 -524h-87l113 664h121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Xi",
    unicode: "\u039E",
    horizAdvX: 292,
    d: "M17 0v81h258v-81h-258zM38 307v82h216v-82h-216zM24 583v81h243v-81h-243z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041F",
    unicode: "\u03A0",
    horizAdvX: 374,
    d: "M257 0v583h-140v-583h-90v664h319v-664h-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041F",
    unicode: "\u041F",
    horizAdvX: 374,
    d: "M257 0v583h-140v-583h-90v664h319v-664h-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sigma",
    unicode: "\u03A3",
    horizAdvX: 292,
    d: "M19 0v81l102 254l-103 252v77h249v-81h-160l100 -247l-101 -255h168v-81h-255z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0424",
    unicode: "\u03A6",
    horizAdvX: 511,
    d: "M212 0v134h-66q-69 0 -97 35t-28 98v165q0 63 28 98t97 35h66v99h87v-99h65q69 0 97.5 -35t28.5 -98v-165q0 -63 -28.5 -98t-97.5 -35h-65v-134h-87zM411 418q0 33 -14 51t-45 18h-53v-275h53q31 0 45 18t14 51v137zM212 487h-53q-32 0 -45.5 -18t-13.5 -51v-137 q0 -33 13.5 -51t45.5 -18h53v275z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0424",
    unicode: "\u0424",
    horizAdvX: 511,
    d: "M212 0v134h-66q-69 0 -97 35t-28 98v165q0 63 28 98t97 35h66v99h87v-99h65q69 0 97.5 -35t28.5 -98v-165q0 -63 -28.5 -98t-97.5 -35h-65v-134h-87zM411 418q0 33 -14 51t-45 18h-53v-275h53q31 0 45 18t14 51v137zM212 487h-53q-32 0 -45.5 -18t-13.5 -51v-137 q0 -33 13.5 -51t45.5 -18h53v275z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Psi",
    unicode: "\u03A8",
    horizAdvX: 518,
    d: "M216 0v148h-66q-69 0 -97.5 35t-28.5 98v383h80v-370q0 -33 13.5 -50.5t45.5 -17.5h53v438h86v-438h53q32 0 45.5 17.5t13.5 50.5v370h80v-383q0 -63 -28.5 -98t-97.5 -35h-66v-148h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\u03A9",
    horizAdvX: 387,
    d: "M217 0v73q52 20 52 153v287q0 73 -75 73q-76 0 -76 -73v-287q0 -134 52 -153v-73h-153v78h71v4q-61 45 -61 145v296q0 72 44 109.5t122 37.5t122 -37.5t44 -109.5v-296q0 -100 -60 -145v-4h71v-78h-153z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "alphatonos",
    unicode: "\u03AC",
    horizAdvX: 389,
    d: "M29 0zM356 0q-45 0 -67.5 16t-29.5 53h-4q-15 -36 -42.5 -55.5t-69.5 -19.5q-62 0 -88 38.5t-26 108.5v217q0 63 30.5 95.5t84.5 32.5q39 0 64 -18t41 -57h4l3 69h77v-362q0 -41 24 -41h15v-77h-16zM116 142q0 -38 16 -55t47 -17t45.5 17.5t25.5 58.5v188 q-11 43 -26 59.5t-45 16.5q-31 0 -47 -17t-16 -55v-196zM150 527v201h71l-17 -201h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "epsilontonos",
    unicode: "\u03AD",
    horizAdvX: 352,
    d: "M27 0zM148 527v201h71l-17 -201h-54zM324 125q0 -131 -148 -131q-78 0 -113.5 32.5t-35.5 90.5v35q0 50 23 72t53 28v4q-66 13 -66 84v27q0 58 34 88.5t106 30.5q74 0 110.5 -33t36.5 -94v-28h-81v21q0 59 -65 59q-33 0 -47.5 -15t-14.5 -45v-18q0 -26 14 -38.5t51 -12.5 h38v-58h-36q-36 0 -54 -16.5t-18 -45.5v-35q0 -58 64 -58q35 0 51 17t16 53v34h82v-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "etatonos",
    unicode: "\u03AE",
    horizAdvX: 365,
    d: "M29 0zM249 -233v575q0 68 -62 68q-30 0 -45.5 -16t-26.5 -54v-340h-86v480h80l3 -69h4q16 39 41.5 57t63.5 18q51 0 83 -32.5t32 -95.5v-591h-87zM153 527v201h71l-17 -201h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iotatonos",
    unicode: "\u03AF",
    horizAdvX: 174,
    d: "M29 0zM141 0q-112 0 -112 116v364h86v-364q0 -39 27 -39h16v-77h-17zM47 527v201h71l-17 -201h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "upsilondieresistonos",
    unicode: "\u03B0",
    horizAdvX: 354,
    d: "M25 0zM146 527v201h71l-17 -201h-54zM244 480h81v-336q0 -78 -35.5 -114t-112.5 -36t-112.5 36t-35.5 114v336h84v-336q0 -72 65 -72q66 0 66 72v336zM25 539v108h86v-108h-86zM238 539v108h86v-108h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "alpha",
    unicode: "\u03B1",
    horizAdvX: 389,
    d: "M356 0q-45 0 -67.5 16t-29.5 53h-4q-15 -36 -42.5 -55.5t-69.5 -19.5q-62 0 -88 38.5t-26 108.5v217q0 63 30.5 95.5t84.5 32.5q39 0 64 -18t41 -57h4l3 69h77v-362q0 -41 24 -41h15v-77h-16zM116 142q0 -38 16 -55t47 -17t45.5 17.5t25.5 58.5v188q-11 43 -26 59.5 t-45 16.5q-31 0 -47 -17t-16 -55v-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "beta",
    unicode: "\u03B2",
    horizAdvX: 363,
    d: "M29 -233v789q0 64 34.5 93t117.5 29q78 0 112.5 -26.5t34.5 -94.5v-96q0 -39 -18 -63t-51 -32v-4q34 -9 54.5 -36.5t20.5 -79.5v-102q0 -44 -10.5 -72.5t-28.5 -46t-41 -24.5t-48 -7q-35 0 -55 11t-37 26v-264h-85zM248 245q0 39 -12 60t-56 21h-17v68h17q24 0 37 6 t19.5 16t8 23.5t1.5 28.5v59q0 38 -13.5 55.5t-51.5 17.5q-41 0 -54 -18.5t-13 -54.5v-416q16 -19 32.5 -30t41.5 -11t42.5 15t17.5 56v104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AF",
    unicode: "\u03B3",
    horizAdvX: 341,
    d: "M130 -233v208l-119 505h87l74 -368h4l71 368h83l-115 -505v-208h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AF",
    unicode: "\u04AF",
    horizAdvX: 341,
    d: "M130 -233v208l-119 505h87l74 -368h4l71 368h83l-115 -505v-208h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "delta",
    unicode: "\u03B4",
    horizAdvX: 358,
    d: "M29 313q0 39 19 68.5t45 46.5v8q-21 15 -32 34.5t-11 51.5v30q0 126 159 126q17 0 40.5 -1.5t41.5 -4.5v-77q-17 5 -39 7t-39 2q-44 0 -62.5 -14t-18.5 -39v-25q0 -19 10 -31t26 -22q21 -13 53 -27t58 -34q25 -19 37.5 -48.5t12.5 -87.5v-132q0 -78 -36 -114t-114 -36 t-114 36t-36 114v169zM245 281q0 30 -6 47.5t-17 29t-28 20.5t-38 21q-20 -13 -31.5 -34.5t-11.5 -52.5v-168q0 -37 15.5 -54.5t50.5 -17.5t50.5 17.5t15.5 54.5v137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "epsilon",
    unicode: "\u03B5",
    horizAdvX: 352,
    d: "M324 125q0 -131 -148 -131q-78 0 -113.5 32.5t-35.5 90.5v35q0 50 23 72t53 28v4q-66 13 -66 84v27q0 58 34 88.5t106 30.5q74 0 110.5 -33t36.5 -94v-28h-81v21q0 59 -65 59q-33 0 -47.5 -15t-14.5 -45v-18q0 -26 14 -38.5t51 -12.5h38v-58h-36q-36 0 -54 -16.5 t-18 -45.5v-35q0 -58 64 -58q35 0 51 17t16 53v34h82v-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeta",
    unicode: "\u03B6",
    horizAdvX: 325,
    d: "M209 -191v173q0 18 -16 18h-73q-91 0 -91 97v130q0 25 2 44t6.5 35t11.5 30.5t18 31.5l153 227h-179v77h265v-77l-170 -263q-14 -21 -17.5 -40t-3.5 -55v-120q0 -40 37 -40h82q61 0 61 -70v-198h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eta",
    unicode: "\u03B7",
    horizAdvX: 365,
    d: "M249 -233v575q0 68 -62 68q-30 0 -45.5 -16t-26.5 -54v-340h-86v480h80l3 -69h4q16 39 41.5 57t63.5 18q51 0 83 -32.5t32 -95.5v-591h-87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "theta",
    unicode: "\u03B8",
    horizAdvX: 358,
    d: "M29 527q0 78 36.5 114t113.5 36t113.5 -36t36.5 -114v-383q0 -78 -36.5 -114t-113.5 -36t-113.5 36t-36.5 114v383zM245 314h-132v-170q0 -72 66 -72t66 72v170zM245 527q0 73 -66 73t-66 -73v-147h132v147z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iota",
    unicode: "\u03B9",
    horizAdvX: 174,
    d: "M141 0q-112 0 -112 116v364h86v-364q0 -39 27 -39h16v-77h-17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043A",
    unicode: "\u03BA",
    horizAdvX: 361,
    d: "M257 0l-91 206h-3l-48 -67v-139h-86v480h86v-204h4l137 204h94l-122 -190l120 -290h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043A",
    unicode: "\u043A",
    horizAdvX: 361,
    d: "M257 0l-91 206h-3l-48 -67v-139h-86v480h86v-204h4l137 204h94l-122 -190l120 -290h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lambda",
    unicode: "\u03BB",
    horizAdvX: 356,
    d: "M339 0h-32q-38 0 -53.5 15.5t-21.5 43.5l-56 253h-4l-76 -312h-86l127 484l-18 85q-6 27 -32 27h-21v76h46q40 0 59 -14.5t28 -56.5l104 -503q4 -22 25 -22h11v-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\u03BC",
    horizAdvX: 363,
    d: "M29 -233v713h87v-342q0 -68 61 -68q29 0 44.5 16t26.5 54v340h86v-480h-80l-3 69h-4q-26 -67 -84 -73q-18 0 -31 3.5t-22 12.5h-5l12 -245h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "xi",
    unicode: "\u03BE",
    horizAdvX: 345,
    d: "M222 -191v173q0 18 -16 18h-86q-91 0 -91 97v185q0 50 23 72.5t53 27.5v4q-34 8 -50 28t-16 56v89q0 58 33.5 88.5t105.5 30.5q75 0 111 -33t36 -94v-42h-81v35q0 59 -64 59q-33 0 -47.5 -15.5t-14.5 -44.5v-80q0 -25 14 -38t51 -13h37v-58h-34q-35 0 -53 -16.5 t-18 -45.5v-175q0 -40 37 -40h94q62 0 62 -70v-198h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 444,
    d: "M389 0q-112 0 -112 116v287h-114v-403h-86v403h-60v77h411v-77h-65v-287q0 -39 27 -39h15v-77h-16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rho",
    unicode: "\u03C1",
    horizAdvX: 358,
    d: "M244 336q0 72 -66 72t-66 -72v-196q11 -38 25.5 -54t44.5 -16q31 0 46.5 17t15.5 55v194zM29 -233v569q0 78 36.5 114t113.5 36t113.5 -36t36.5 -114v-214q0 -63 -28.5 -95.5t-82.5 -32.5q-36 0 -61 15.5t-39 50.5h-4v-293h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sigma1",
    unicode: "\u03C2",
    horizAdvX: 354,
    d: "M239 -191v173q0 18 -16 18h-103q-91 0 -91 97v239q0 76 36.5 113t113.5 37t111.5 -37t34.5 -113v-32h-81v32q0 72 -65 72q-66 0 -66 -72v-219q0 -40 37 -40h114q61 0 61 -70v-198h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sigma",
    unicode: "\u03C3",
    horizAdvX: 378,
    d: "M361 403h-49q12 -27 12 -68v-191q0 -76 -33.5 -113t-111.5 -37t-114 37t-36 113v186q0 78 36 114t114 36h182v-77zM243 335q0 44 -15 68h-21q-20 0 -37.5 -2.5t-30 -10t-19.5 -21.5t-7 -38v-187q0 -35 15.5 -53.5t50.5 -18.5t49.5 18.5t14.5 53.5v191z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tau",
    unicode: "\u03C4",
    horizAdvX: 286,
    d: "M213 0q-112 0 -112 116v287h-84v77h252v-77h-83v-287q0 -39 28 -39h15v-77h-16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "upsilon",
    unicode: "\u03C5",
    horizAdvX: 354,
    d: "M244 480h81v-336q0 -78 -35.5 -114t-112.5 -36t-112.5 36t-35.5 114v336h84v-336q0 -72 65 -72q66 0 66 72v336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0444",
    unicode: "\u03C6",
    horizAdvX: 507,
    d: "M212 -233v233h-84q-45 0 -72 30.5t-27 82.5v254q0 52 27 82.5t72 30.5h84v192h82v-192h85q45 0 72 -30.5t27 -82.5v-254q0 -52 -27 -82.5t-72 -30.5h-85v-233h-82zM212 408h-56q-22 0 -34.5 -15t-12.5 -43v-220q0 -28 12.5 -43t34.5 -15h56v336zM398 330q0 38 -10 58 t-38 20h-56v-336h56q23 0 35.5 15t12.5 43v200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0444",
    unicode: "\u0444",
    horizAdvX: 507,
    d: "M212 -233v233h-84q-45 0 -72 30.5t-27 82.5v254q0 52 27 82.5t72 30.5h84v192h82v-192h85q45 0 72 -30.5t27 -82.5v-254q0 -52 -27 -82.5t-72 -30.5h-85v-233h-82zM212 408h-56q-22 0 -34.5 -15t-12.5 -43v-220q0 -28 12.5 -43t34.5 -15h56v336zM398 330q0 38 -10 58 t-38 20h-56v-336h56q23 0 35.5 15t12.5 43v200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "chi",
    unicode: "\u03C7",
    horizAdvX: 357,
    d: "M256 -233l-77 256h-4l-75 -256h-90l116 361l-112 352h89l76 -243h4l73 243h87l-111 -343l115 -370h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omega",
    unicode: "\u03C9",
    horizAdvX: 521,
    d: "M409 365q0 72 -25 115h83q25 -35 25 -114v-218q0 -81 -28.5 -117.5t-87.5 -36.5q-36 0 -63.5 13.5t-49.5 45.5h-4q-22 -32 -50 -45.5t-63 -13.5q-59 0 -88 36.5t-29 117.5v218q0 76 25 114h83q-24 -44 -24 -115v-219q0 -74 54 -74q57 0 57 73v192h74v-192q0 -73 56 -73 q55 0 55 74v219z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iotadieresis",
    unicode: "\u03CA",
    horizAdvX: 228,
    d: "M0 0zM178 0q-112 0 -112 116v364h86v-364q0 -39 27 -39h16v-77h-17zM-5 539v108h80v-108h-80zM146 539v108h80v-108h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "upsilondieresis",
    unicode: "\u03CB",
    horizAdvX: 354,
    d: "M29 0zM244 480h81v-336q0 -78 -35.5 -114t-112.5 -36t-112.5 36t-35.5 114v336h84v-336q0 -72 65 -72q66 0 66 72v336zM62 539v108h80v-108h-80zM213 539v108h80v-108h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omicrontonos",
    unicode: "\u03CC",
    horizAdvX: 358,
    d: "M29 0zM329 144q0 -78 -36.5 -114t-113.5 -36t-113.5 36t-36.5 114v192q0 78 36.5 114t113.5 36t113.5 -36t36.5 -114v-192zM245 336q0 72 -66 72t-66 -72v-192q0 -72 66 -72t66 72v192zM149 527v201h71l-17 -201h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "upsilontonos",
    unicode: "\u03CD",
    horizAdvX: 354,
    d: "M29 0zM146 527v201h71l-17 -201h-54zM244 480h81v-336q0 -78 -35.5 -114t-112.5 -36t-112.5 36t-35.5 114v336h84v-336q0 -72 65 -72q66 0 66 72v336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omegatonos",
    unicode: "\u03CE",
    horizAdvX: 521,
    d: "M29 0zM409 365q0 72 -25 115h83q25 -35 25 -114v-218q0 -81 -28.5 -117.5t-87.5 -36.5q-36 0 -63.5 13.5t-49.5 45.5h-4q-22 -32 -50 -45.5t-63 -13.5q-59 0 -88 36.5t-29 117.5v218q0 76 25 114h83q-24 -44 -24 -115v-219q0 -74 54 -74q57 0 57 73v192h74v-192 q0 -73 56 -73q55 0 55 74v219zM226 527v201h71l-17 -201h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0402",
    unicode: "\u0402",
    horizAdvX: 434,
    d: "M107 583h-88v81h272v-81h-95v-193h4q20 33 43 48t61 15q52 0 77 -29.5t25 -92.5v-414q0 -76 -38 -113t-112 -37q-73 0 -111 37t-38 113v43h89v-43q0 -72 60 -72t60 72v390q0 35 -14.5 50.5t-41.5 15.5q-29 0 -41.5 -17.5t-22.5 -58.5v-297h-89v583z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0403",
    unicode: "\u0403",
    horizAdvX: 299,
    d: "M27 0zM109 677l-34 35l149 163l46 -52zM27 0v664h254v-82h-164v-582h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0404",
    unicode: "\u0404",
    horizAdvX: 363,
    d: "M336 160q0 -84 -39 -125t-114 -41q-78 0 -117 43.5t-39 124.5v337q0 81 39.5 126t114.5 45q76 0 115.5 -46t39.5 -127v-21h-85v29q0 39 -17 60t-51 21q-67 0 -67 -80v-120h117v-75h-117v-155q0 -79 68 -79q67 0 67 78v38h85v-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0409",
    unicode: "\u0409",
    horizAdvX: 627,
    d: "M386 390h95q71 0 98.5 -31t27.5 -100v-126q0 -60 -28 -96.5t-98 -36.5h-184v583h-120l-7 -199q-5 -135 -15.5 -214t-27.5 -115q-16 -35 -39 -45t-55 -10h-14v82h9q14 0 23 4.5t16 22.5q8 23 15.5 86.5t12.5 188.5l10 280h281v-274zM464 81q36 0 47.5 18t11.5 50v91 q0 41 -11.5 56.5t-47.5 15.5h-78v-231h78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040A",
    unicode: "\u040A",
    horizAdvX: 587,
    d: "M346 390h95q71 0 98.5 -31t27.5 -100v-126q0 -60 -28 -96.5t-98 -36.5h-184v312h-140v-312h-90v664h90v-274h140v274h89v-274zM424 81q36 0 47.5 18t11.5 50v91q0 41 -11.5 56.5t-47.5 15.5h-78v-231h78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040B",
    unicode: "\u040B",
    horizAdvX: 434,
    d: "M107 583h-88v81h272v-81h-95v-193h4q20 33 43 48t61 15q52 0 77 -29.5t25 -92.5v-331h-90v307q0 35 -14.5 50.5t-40.5 15.5t-40 -16t-25 -54v-303h-89v583z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040C",
    unicode: "\u040C",
    horizAdvX: 368,
    d: "M27 0zM265 0l-95 287h-4l-48 -94v-193h-91v664h91v-298h4l144 298h91l-125 -263l124 -401h-91zM132 677l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040D",
    unicode: "\u040D",
    horizAdvX: 392,
    d: "M27 0zM83 823l46 52l149 -163l-34 -35zM278 0v479h-4l-154 -479h-93v664h87v-448h4l150 448h96v-664h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040E",
    unicode: "\u040E",
    horizAdvX: 368,
    d: "M27 0zM183 677q-60 0 -97.5 39.5t-37.5 119.5h63q2 -53 19.5 -77.5t52.5 -24.5q34 0 52 24.5t19 77.5h65q0 -81 -38 -120t-98 -39zM252 312h-4q-14 -28 -42 -44t-65 -16q-114 0 -114 166v246h88v-251q0 -38 14 -58.5t47 -20.5q32 0 50 18t26 51v261h88v-502 q0 -81 -39 -124.5t-117 -43.5q-75 0 -116 40.5t-41 125.5v61h88v-66q0 -78 68 -78q69 0 69 79v156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040F",
    unicode: "\u040F",
    horizAdvX: 374,
    d: "M153 -167v167h-126v664h90v-582h140v582h89v-664h-125v-167h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0411",
    unicode: "\u0411",
    horizAdvX: 358,
    d: "M117 582v-192h95q71 0 98.5 -34t27.5 -101v-122q0 -60 -28 -96.5t-98 -36.5h-185v664h254v-82h-164zM194 81q36 0 47.5 18t11.5 50v91q0 41 -11 56.5t-48 15.5h-77v-231h77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0414",
    unicode: "\u0414",
    horizAdvX: 445,
    d: "M361 -167v167h-276v-167h-68v249h12q16 0 24 5q9 7 16 22t12.5 47.5t9 87t6.5 140.5l10 280h281v-582h41v-249h-68zM299 583h-120l-7 -199q-2 -40 -4 -84.5t-6 -86t-10 -76t-15 -55.5h162v501z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0416",
    unicode: "\u0416",
    horizAdvX: 580,
    d: "M10 0l167 338l-161 326h92l134 -262h4v262h87v-262h4l135 262h92l-162 -326l168 -338h-94l-139 285h-4v-285h-87v285h-4l-138 -285h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0418",
    unicode: "\u0418",
    horizAdvX: 392,
    d: "M278 0v479h-4l-154 -479h-93v664h87v-448h4l150 448h96v-664h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0419",
    unicode: "\u0419",
    horizAdvX: 392,
    d: "M27 0zM198 677q-60 0 -97.5 39.5t-37.5 119.5h63q2 -53 19.5 -77.5t52.5 -24.5q34 0 52 24.5t19 77.5h65q0 -81 -38 -120t-98 -39zM278 0v479h-4l-154 -479h-93v664h87v-448h4l150 448h96v-664h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041B",
    unicode: "\u041B",
    horizAdvX: 414,
    d: "M297 0v583h-120l-7 -199q-9 -252 -43 -329q-16 -35 -39 -45t-55 -10h-14v82h9q14 0 23 4.5t16 22.5q8 22 15.5 86t12.5 189l10 280h281v-664h-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0423",
    unicode: "\u0423",
    horizAdvX: 368,
    d: "M252 312h-4q-14 -28 -42 -44t-65 -16q-114 0 -114 166v246h88v-251q0 -38 14 -58.5t47 -20.5q32 0 50 18t26 51v261h88v-502q0 -81 -39 -124.5t-117 -43.5q-75 0 -116 40.5t-41 125.5v61h88v-66q0 -78 68 -78q69 0 69 79v156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0426",
    unicode: "\u0426",
    horizAdvX: 403,
    d: "M318 -167v167h-291v664h90v-582h140v582h89v-582h40v-249h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0427",
    unicode: "\u0427",
    horizAdvX: 368,
    d: "M252 0v294h-4q-19 -12 -45.5 -20t-57.5 -8q-65 0 -91.5 34.5t-26.5 115.5v248h88v-243q0 -39 13.5 -55.5t47.5 -16.5q20 0 41 6t35 22v287h88v-664h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0428",
    unicode: "\u0428",
    horizAdvX: 552,
    d: "M27 0v664h90v-582h117v582h84v-582h117v582h90v-664h-498z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0429",
    unicode: "\u0429",
    horizAdvX: 582,
    d: "M497 -167v167h-470v664h90v-582h117v582h84v-582h117v582h90v-582h40v-249h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042A",
    unicode: "\u042A",
    horizAdvX: 472,
    d: "M142 582h-123v82h212v-274h95q38 0 62.5 -10t38.5 -29.5t19.5 -48.5t5.5 -66v-103q0 -60 -28 -96.5t-98 -36.5h-184v582zM309 81q35 0 47 15.5t12 50.5v101q0 32 -11.5 48t-47.5 16h-78v-231h78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042B",
    unicode: "\u042B",
    horizAdvX: 495,
    d: "M27 0zM377 0v664h90v-664h-90zM117 390h95q71 0 98.5 -31t27.5 -100v-126q0 -60 -28 -96.5t-98 -36.5h-185v664h90v-274zM194 81q36 0 47.5 18t11.5 50v91q0 41 -11 56.5t-48 15.5h-77v-231h77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042C",
    unicode: "\u042C",
    horizAdvX: 358,
    d: "M117 390h95q71 0 98.5 -31t27.5 -100v-126q0 -60 -28 -96.5t-98 -36.5h-185v664h90v-274zM194 81q36 0 47.5 18t11.5 50v91q0 41 -11 56.5t-48 15.5h-77v-231h77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042D",
    unicode: "\u042D",
    horizAdvX: 363,
    d: "M27 193h85v-38q0 -78 67 -78q68 0 68 79v155h-117v75h117v120q0 80 -67 80q-34 0 -51 -21t-17 -60v-29h-85v21q0 81 39.5 127t115.5 46q75 0 114.5 -45t39.5 -126v-337q0 -81 -39 -124.5t-117 -43.5q-75 0 -114 41t-39 125v33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042E",
    unicode: "\u042E",
    horizAdvX: 539,
    d: "M27 0v664h90v-272h80v107q0 81 41 126t116 45t116 -46t41 -127v-337q0 -84 -40.5 -125t-115.5 -41q-78 0 -118 43.5t-40 124.5v150h-80v-312h-90zM423 505q0 39 -18 60t-51 21t-51 -20.5t-18 -59.5v-350q0 -79 70 -79q68 0 68 78v350z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042F",
    unicode: "\u042F",
    horizAdvX: 358,
    d: "M10 0l78 280q-21 7 -34.5 20.5t-20.5 32t-9.5 41.5t-2.5 50v80q0 37 4.5 66.5t17.5 50.5t37.5 32t65.5 11h185v-664h-90v272h-69l-71 -272h-91zM105 415q0 -39 15.5 -53.5t43.5 -14.5h77v236h-77q-35 0 -47 -20.5t-12 -58.5v-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0431",
    unicode: "\u0431",
    horizAdvX: 361,
    d: "M245 338q0 38 -16 55t-46 17q-31 0 -45.5 -16.5t-24.5 -53.5v-198q0 -38 16.5 -55t49.5 -17t49.5 17t16.5 55v196zM332 121q0 -61 -37 -94t-114 -33q-78 0 -115 36t-37 114v347q0 47 5 81t17 56.5t33.5 33t54.5 10.5h73q43 0 50 49h53q-2 -126 -73 -126h-71 q-34 0 -47 -25.5t-13 -78.5v-71h4q30 66 103 66q54 0 84 -32.5t30 -95.5v-237z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0432",
    unicode: "\u0432",
    horizAdvX: 356,
    d: "M323 342q0 -35 -17 -57t-49 -28v-4q36 -6 56 -29t20 -67v-37q0 -57 -34 -88.5t-111 -31.5h-159v480h161q133 0 133 -103v-35zM115 224v-153h74q32 0 46 16t14 44v34q0 28 -16 43.5t-48 15.5h-70zM244 364q0 21 -13 32.5t-43 11.5h-73v-126h72q57 0 57 44v38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0433",
    unicode: "\u0433",
    horizAdvX: 245,
    d: "M29 0v480h199v-77h-113v-403h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0434",
    unicode: "\u0434",
    horizAdvX: 421,
    d: "M336 -150v150h-251v-150h-68v227h14q31 0 43.5 45t17.5 146l9 212h262v-403h41v-227h-68zM277 403h-110l-7 -104q-5 -78 -10 -135.5t-19 -86.5h146v326z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0436",
    unicode: "\u0436",
    horizAdvX: 535,
    d: "M434 0l-121 207h-4v-207h-83v207h-4l-121 -207h-91l148 247l-142 233h89l117 -185h4v185h83v-185h4l117 185h89l-143 -233l149 -247h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0437",
    unicode: "\u0437",
    horizAdvX: 352,
    d: "M325 117q0 -58 -35.5 -90.5t-113.5 -32.5q-75 0 -111 32t-36 99v48h81v-34q0 -36 16 -53t51 -17q64 0 64 58v35q0 29 -18 45.5t-53 16.5h-37v58h38q37 0 51.5 12.5t14.5 38.5v18q0 30 -15 45t-48 15q-64 0 -64 -59v-21h-81v28q0 61 36 94t111 33q71 0 105 -30.5t34 -88.5 v-27q0 -71 -66 -84v-4q30 -6 53 -28t23 -72v-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0438",
    unicode: "\u0438",
    horizAdvX: 377,
    d: "M262 0v330h-4l-139 -330h-90v480h86v-330h4l138 330h91v-480h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0439",
    unicode: "\u0439",
    horizAdvX: 377,
    d: "M29 0zM189 504q-60 0 -97.5 39.5t-37.5 119.5h63q2 -53 19.5 -77.5t52.5 -24.5q34 0 52 24.5t19 77.5h65q0 -81 -38 -120t-98 -39zM262 0v330h-4l-139 -330h-90v480h86v-330h4l138 330h91v-480h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043B",
    unicode: "\u043B",
    horizAdvX: 387,
    d: "M271 0v403h-110l-7 -104q-4 -56 -8 -98.5t-9 -74t-11 -53t-15 -35.5q-13 -22 -32.5 -30t-48.5 -8h-13v77h8q22 0 34 20q6 10 10.5 26.5t8 40.5t5.5 57.5t4 77.5l8 181h262v-480h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043C",
    unicode: "\u043C",
    horizAdvX: 474,
    d: "M369 0v261q0 23 1 48.5t3 55.5h-4l-94 -365h-76l-94 365h-4q3 -60 3 -104v-261h-75v480h127l81 -347h3l81 347h124v-480h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043D",
    unicode: "\u043D",
    horizAdvX: 366,
    d: "M251 0v213h-136v-213h-86v480h86v-190h136v190h86v-480h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043F",
    unicode: "\u043F",
    horizAdvX: 366,
    d: "M251 0v403h-136v-403h-86v480h308v-480h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0442",
    unicode: "\u0442",
    horizAdvX: 307,
    d: "M111 0v403h-92v77h270v-77h-92v-403h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0446",
    unicode: "\u0446",
    horizAdvX: 393,
    d: "M309 -148v148h-280v480h86v-403h136v403h86v-403h40v-225h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0447",
    unicode: "\u0447",
    horizAdvX: 364,
    d: "M249 0v202h-4q-16 -9 -40.5 -15t-60.5 -6q-63 0 -90 23t-27 77v199h86v-179q0 -24 13.5 -35t51.5 -11q48 0 71 15v210h86v-480h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0448",
    unicode: "\u0448",
    horizAdvX: 534,
    d: "M29 0v480h86v-403h112v403h78v-403h113v403h86v-480h-475z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0449",
    unicode: "\u0449",
    horizAdvX: 562,
    d: "M477 -148v148h-448v480h86v-403h112v403h78v-403h113v403h86v-403h41v-225h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044A",
    unicode: "\u044A",
    horizAdvX: 437,
    d: "M203 308h90q67 0 94.5 -26.5t27.5 -77.5v-105q0 -48 -27.5 -73.5t-94.5 -25.5h-176v403h-106v77h192v-172zM277 75q34 0 45 13t11 39v60q0 24 -13 36.5t-43 12.5h-74v-161h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044B",
    unicode: "\u044B",
    horizAdvX: 480,
    d: "M29 0zM115 308h91q67 0 94 -27.5t27 -78.5v-103q0 -48 -27.5 -73.5t-93.5 -25.5h-177v480h86v-172zM189 75q30 0 43.5 12.5t13.5 36.5v63q0 24 -13.5 36.5t-43.5 12.5h-74v-161h74zM365 0v480h86v-480h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044C",
    unicode: "\u044C",
    horizAdvX: 349,
    d: "M115 308h91q67 0 94 -27.5t27 -78.5v-103q0 -48 -27.5 -73.5t-93.5 -25.5h-177v480h86v-172zM189 75q30 0 43.5 12.5t13.5 36.5v63q0 24 -13.5 36.5t-43.5 12.5h-74v-161h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044D",
    unicode: "\u044D",
    horizAdvX: 354,
    d: "M130 221v63h111v55q0 72 -66 72q-33 0 -47.5 -17t-14.5 -44v-15h-82v17q0 63 33.5 98.5t110.5 35.5q150 0 150 -150v-192q0 -150 -149 -150q-78 0 -112.5 37t-34.5 111v27h82v-30q0 -70 65 -70t65 72v80h-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044E",
    unicode: "\u044E",
    horizAdvX: 521,
    d: "M491 144q0 -78 -36 -114t-113 -36t-112 36t-35 114v69h-82v-213h-84v480h84v-190h82v46q0 78 35 114t112 36t113 -36t36 -114v-192zM408 336q0 72 -66 72t-66 -72v-192q0 -72 66 -72t66 72v192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044F",
    unicode: "\u044F",
    horizAdvX: 356,
    d: "M10 0l84 185q-41 10 -53 39.5t-12 70.5v86q0 48 27.5 73.5t93.5 25.5h177v-480h-86v179h-65l-76 -179h-90zM111 297q0 -29 14.5 -39t41.5 -10h74v157h-74q-35 0 -45.5 -14t-10.5 -41v-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0452",
    unicode: "\u0452",
    horizAdvX: 365,
    d: "M115 562v-142h4q14 34 40 50t63 16q32 0 53.5 -11t35 -29.5t19.5 -42t6 -48.5v-438q0 -150 -154 -150q-77 0 -113 37t-36 113v56h83v-56q0 -72 66 -72q67 0 67 72v425q0 35 -16 51.5t-45 16.5q-33 0 -52 -22.5t-21 -76.5v-311h-86v562h-29v55h29v55h86v-55h119v-55h-119z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0453",
    unicode: "\u0453",
    horizAdvX: 245,
    d: "M29 0zM79 504l-34 35l149 163l46 -52zM29 0v480h199v-77h-113v-403h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0454",
    unicode: "\u0454",
    horizAdvX: 354,
    d: "M113 221v-80q0 -72 65 -72t65 70v30h82v-27q0 -74 -34.5 -111t-112.5 -37q-149 0 -149 150v192q0 150 150 150q77 0 110.5 -35.5t33.5 -98.5v-17h-81v15q0 27 -15 44t-48 17q-66 0 -66 -72v-55h111v-63h-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0459",
    unicode: "\u0459",
    horizAdvX: 591,
    d: "M357 308h91q67 0 94 -27.5t27 -78.5v-103q0 -48 -27.5 -73.5t-93.5 -25.5h-177v403h-110l-7 -104q-4 -56 -8 -98.5t-9 -74t-11 -53t-15 -35.5q-13 -22 -32.5 -30t-48.5 -8h-13v77h8q22 0 34 20q6 10 10.5 26.5t8 40.5t5.5 57.5t4 77.5l8 181h262v-172zM431 75 q30 0 43.5 12.5t13.5 36.5v63q0 24 -13.5 36.5t-43.5 12.5h-74v-161h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045A",
    unicode: "\u045A",
    horizAdvX: 571,
    d: "M337 308h90q67 0 94 -27.5t27 -78.5v-103q0 -48 -27.5 -73.5t-93.5 -25.5h-176v236h-136v-236h-86v480h86v-172h136v172h86v-172zM410 75q31 0 44 12.5t13 36.5v63q0 24 -13 36.5t-44 12.5h-73v-161h73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045C",
    unicode: "\u045C",
    horizAdvX: 361,
    d: "M29 0zM142 504l-34 35l149 163l46 -52zM257 0l-91 206h-3l-48 -67v-139h-86v480h86v-204h4l137 204h94l-122 -190l120 -290h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045D",
    unicode: "\u045D",
    horizAdvX: 377,
    d: "M29 0zM74 650l46 52l149 -163l-34 -35zM262 0v330h-4l-139 -330h-90v480h86v-330h4l138 330h91v-480h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045E",
    unicode: "\u045E",
    d: "M29 0zM116 151q0 -38 16.5 -55t46.5 -17q29 0 45 17t26 59v325h83v-563q0 -150 -152 -150q-77 0 -113 37t-36 113v53h82v-53q0 -72 66 -72q67 0 67 72v149h-4q-16 -37 -41 -51.5t-61 -14.5q-63 0 -87.5 34.5t-24.5 91.5v354h87v-329zM184 504q-60 0 -97.5 39.5 t-37.5 119.5h63q2 -53 19.5 -77.5t52.5 -24.5q34 0 52 24.5t19 77.5h65q0 -81 -38 -120t-98 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045F",
    unicode: "\u045F",
    horizAdvX: 366,
    d: "M148 -148v148h-119v480h86v-403h136v403h86v-480h-121v-148h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0490",
    unicode: "\u0490",
    horizAdvX: 297,
    d: "M27 0v664h186v165h68v-247h-164v-582h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0491",
    unicode: "\u0491",
    horizAdvX: 245,
    d: "M29 0v480h131v146h68v-223h-113v-403h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0492",
    unicode: "\u0492",
    horizAdvX: 316,
    d: "M44 0v287h-37v70h37v307h253v-82h-164v-225h109v-70h-109v-287h-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0493",
    unicode: "\u0493",
    horizAdvX: 259,
    d: "M43 0v188h-36v56h36v236h199v-77h-113v-159h113v-56h-113v-188h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0496",
    unicode: "\u0496",
    horizAdvX: 627,
    d: "M10 0l167 338l-161 326h92l134 -262h4v262h87v-262h4l135 262h92l-162 -326l127 -256h81v-245h-68v163h-66l-139 285h-4v-285h-87v285h-4l-138 -285h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0497",
    unicode: "\u0497",
    horizAdvX: 587,
    d: "M502 -163v163h-68l-121 207h-4v-207h-83v207h-4l-121 -207h-91l148 247l-142 233h89l117 -185h4v185h83v-185h4l117 185h89l-143 -233l99 -165h95v-245h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0498",
    unicode: "\u0498",
    horizAdvX: 357,
    d: "M105 -140q10 -5 23 -6.5t25 -1.5q50 0 50 33v22q0 20 -10.5 44t-36.5 44q-63 6 -96 47t-33 118v33h85v-38q0 -78 66 -78q70 0 70 79v88q0 33 -16.5 51t-58.5 18h-42v75h45q41 0 54.5 18.5t13.5 47.5v62q0 29 -15.5 49.5t-50.5 20.5q-32 0 -49 -19.5t-17 -51.5v-39h-85v31 q0 75 40 119t112 44q39 0 67 -12.5t46 -33t26.5 -46.5t8.5 -53v-62q0 -46 -18 -73.5t-52 -33.5v-4q16 -3 30.5 -11t25.5 -21.5t17.5 -33.5t6.5 -48v-76q0 -72 -30.5 -114t-90.5 -51v-14q23 -20 35 -46t12 -56v-27q0 -78 -93 -78q-19 0 -36 3t-29 10v71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0499",
    unicode: "\u0499",
    horizAdvX: 352,
    d: "M325 117q0 -54 -30 -85.5t-96 -36.5v-10q29 -18 45 -44.5t16 -59.5v-27q0 -78 -94 -78q-19 0 -35.5 3t-28.5 10v71q9 -5 22.5 -6.5t24.5 -1.5q51 0 51 33v22q0 23 -17 48t-53 43q-101 16 -101 127v48h81v-34q0 -36 16 -53t51 -17q64 0 64 58v35q0 29 -18 45.5t-53 16.5 h-37v58h38q37 0 51.5 12.5t14.5 38.5v18q0 30 -15 45t-48 15q-64 0 -64 -59v-21h-81v28q0 61 36 94t111 33q71 0 105 -30.5t34 -88.5v-27q0 -71 -66 -84v-4q30 -6 53 -28t23 -72v-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049A",
    unicode: "\u049A",
    horizAdvX: 429,
    d: "M344 -163v163h-79l-95 287h-4l-48 -94v-193h-91v664h91v-298h4l144 298h91l-125 -263l98 -319h82v-245h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049B",
    unicode: "\u049B",
    horizAdvX: 406,
    d: "M321 -163v163h-64l-91 206h-3l-48 -67v-139h-86v480h86v-204h4l137 204h94l-122 -190l86 -208h75v-245h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A0",
    unicode: "\u04A0",
    horizAdvX: 523,
    d: "M420 0l-95 287h-4l-48 -94v-193h-91v582h-163v82h254v-298h4l144 298h91l-125 -263l124 -401h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A1",
    unicode: "\u04A1",
    horizAdvX: 463,
    d: "M359 0l-91 206h-3l-48 -67v-139h-86v403h-112v77h198v-204h4l137 204h94l-122 -190l120 -290h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A2",
    unicode: "\u04A2",
    horizAdvX: 403,
    d: "M318 -163v163h-61v312h-140v-312h-90v664h90v-272h140v272h89v-582h40v-245h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A3",
    unicode: "\u04A3",
    horizAdvX: 406,
    d: "M321 -163v163h-70v213h-136v-213h-86v480h86v-190h136v190h86v-398h52v-245h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AA",
    unicode: "\u04AA",
    horizAdvX: 363,
    d: "M111 -140q9 -5 22.5 -6.5t24.5 -1.5q51 0 51 33v22q0 23 -17.5 48.5t-54.5 43.5q-55 11 -82.5 52.5t-27.5 110.5v342q0 84 39 125t114 41q76 0 116 -41t40 -124v-79h-85v79q0 39 -17 60t-51 21q-67 0 -67 -80v-351q0 -38 16 -58t51 -20q68 0 68 78v116h85v-111 q0 -154 -133 -165v-8q32 -17 49 -44.5t17 -61.5v-27q0 -78 -94 -78q-19 0 -35.5 3t-28.5 10v71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AB",
    unicode: "\u04AB",
    horizAdvX: 354,
    d: "M99 -140q10 -5 23.5 -6.5t24.5 -1.5q50 0 50 33v22q0 24 -18 49.5t-56 43.5q-94 22 -94 144v192q0 76 36.5 113t113.5 37t111.5 -37t34.5 -113v-32h-81v32q0 72 -65 72q-66 0 -66 -72v-192q0 -72 65 -72t65 72v34h82v-34q0 -72 -32 -109t-103 -40v-7q32 -17 50 -44.5 t18 -62.5v-27q0 -78 -94 -78q-40 0 -65 13v71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B2",
    unicode: "\u04B2",
    horizAdvX: 434,
    d: "M373 664l-123 -319l97 -263h70v-245h-68v163h-64l-89 246h-4l-90 -246h-90l127 336l-123 328h90l87 -234h4l88 234h88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B3",
    unicode: "\u04B3",
    horizAdvX: 405,
    d: "M343 480l-112 -231l78 -167h79v-245h-68v163h-63l-78 166h-4l-76 -166h-89l117 244l-113 236h88l77 -158h4l74 158h86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B6",
    unicode: "\u04B6",
    horizAdvX: 403,
    d: "M318 -163v163h-66v294h-4q-19 -12 -45.5 -20t-57.5 -8q-65 0 -91.5 34.5t-26.5 115.5v248h88v-243q0 -39 13.5 -55.5t47.5 -16.5q20 0 41 6t35 22v287h88v-582h46v-245h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B7",
    unicode: "\u04B7",
    horizAdvX: 397,
    d: "M313 -163v163h-64v202h-4q-16 -9 -40.5 -15t-60.5 -6q-63 0 -90 23t-27 77v199h86v-179q0 -24 13.5 -35t51.5 -11q48 0 71 15v210h86v-398h46v-245h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04BA",
    unicode: "\u04BA",
    horizAdvX: 368,
    d: "M117 664v-294h4q19 12 45 20t58 8q64 0 90.5 -34.5t26.5 -115.5v-248h-87v243q0 39 -13.5 55.5t-47.5 16.5q-21 0 -42 -6t-34 -22v-287h-89v664h89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C3",
    unicode: "\u04C3",
    horizAdvX: 368,
    d: "M203 -155q64 0 64 72v83l-97 287h-4l-48 -94v-193h-91v664h91v-298h4l144 298h91l-125 -263l124 -401v-83q0 -150 -153 -150v78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C4",
    unicode: "\u04C4",
    horizAdvX: 361,
    d: "M195 -155q67 0 67 72v64l-96 225h-3l-48 -67v-139h-86v480h86v-204h4l137 204h94l-122 -190l120 -290v-83q0 -150 -152 -150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C7",
    unicode: "\u04C7",
    horizAdvX: 374,
    d: "M189 -155q68 0 68 72v395h-140v-312h-90v664h90v-272h140v272h89v-747q0 -76 -40 -113t-117 -37v78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C8",
    unicode: "\u04C8",
    horizAdvX: 366,
    d: "M183 -155q68 0 68 72v296h-136v-213h-86v480h86v-190h136v190h86v-563q0 -150 -153 -150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E8",
    unicode: "\u04E8",
    d: "M338 160q0 -84 -40.5 -125t-115.5 -41q-78 0 -118.5 43.5t-40.5 124.5v337q0 81 41.5 126t116.5 45t116 -46t41 -127v-337zM250 299h-138v-143q0 -79 69 -79q33 0 51 19t18 59v144zM112 378h138v127q0 39 -18 60t-52 21q-32 0 -50 -20.5t-18 -59.5v-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E9",
    unicode: "\u04E9",
    horizAdvX: 358,
    d: "M329 144q0 -78 -36.5 -114t-113.5 -36t-113.5 36t-36.5 114v192q0 78 36.5 114t113.5 36t113.5 -36t36.5 -114v-192zM245 216h-132v-72q0 -72 66 -72t66 72v72zM113 272h132v64q0 72 -66 72t-66 -72v-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EE",
    unicode: "\u04EE",
    horizAdvX: 368,
    d: "M27 0zM67 735v55h234v-55h-234zM252 312h-4q-14 -28 -42 -44t-65 -16q-114 0 -114 166v246h88v-251q0 -38 14 -58.5t47 -20.5q32 0 50 18t26 51v261h88v-502q0 -81 -39 -124.5t-117 -43.5q-75 0 -116 40.5t-41 125.5v61h88v-66q0 -78 68 -78q69 0 69 79v156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EF",
    unicode: "\u04EF",
    d: "M29 0zM116 151q0 -38 16.5 -55t46.5 -17q29 0 45 17t26 59v325h83v-563q0 -150 -152 -150q-77 0 -113 37t-36 113v53h82v-53q0 -72 66 -72q67 0 67 72v149h-4q-16 -37 -41 -51.5t-61 -14.5q-63 0 -87.5 34.5t-24.5 91.5v354h87v-329zM67 562v55h234v-55h-234z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0512",
    unicode: "\u0512",
    horizAdvX: 414,
    d: "M229 -155q68 0 68 72v666h-120l-7 -199q-5 -135 -15.5 -214t-27.5 -115q-16 -35 -39 -45t-55 -10h-14v82h9q14 0 23 4.5t16 22.5q8 23 15.5 86.5t12.5 188.5l10 280h281v-747q0 -76 -40.5 -113t-116.5 -37v78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0513",
    unicode: "\u0513",
    horizAdvX: 387,
    d: "M204 -155q67 0 67 72v486h-110l-7 -104q-4 -56 -8 -98.5t-9 -73.5t-11 -52.5t-15 -36.5q-13 -22 -32.5 -30t-48.5 -8h-13v77h8q23 0 34 20q6 10 10.5 26.5t8 40.5t5.5 57.5t4 77.5l8 181h262v-563q0 -150 -153 -150v78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni058F",
    unicode: "\u058F",
    horizAdvX: 391,
    d: "M240 0v150h-156v56h156v82h-156v56h156v164q0 79 -69 79q-67 0 -67 -78v-96h-84v91q0 166 152 166q78 0 117 -43.5t39 -124.5v-158h45v-56h-45v-82h45v-56h-45v-150h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E0C",
    unicode: "\u1E0C",
    horizAdvX: 370,
    d: "M27 0zM27 0v664h164q151 0 151 -153v-349q0 -83 -38 -122.5t-113 -39.5h-164zM185 81q41 0 54.5 28t13.5 78v292q0 48 -14.5 76t-58.5 28h-65v-502h70zM132 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E0D",
    unicode: "\u1E0D",
    d: "M29 0zM116 142q0 -38 16 -55t47 -17t46 17.5t25 62.5v181q-9 45 -23.5 62t-46.5 17q-30 0 -47 -16t-17 -56v-196zM256 0l-3 69h-4q-16 -39 -41 -57t-64 -18q-54 0 -84.5 32.5t-30.5 95.5v236q0 63 30 95.5t84 32.5q36 0 61.5 -15.5t39.5 -50.5h4v252h85v-672h-77z M141 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E12",
    unicode: "\u1E12",
    horizAdvX: 370,
    d: "M27 0zM27 0v664h164q151 0 151 -153v-349q0 -83 -38 -122.5t-113 -39.5h-164zM185 81q41 0 54.5 28t13.5 78v292q0 48 -14.5 76t-58.5 28h-65v-502h70zM253 -215l-94 108l-94 -108l-38 30l92 129h79l93 -129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E13",
    unicode: "\u1E13",
    d: "M29 0zM116 142q0 -38 16 -55t47 -17t46 17.5t25 62.5v181q-9 45 -23.5 62t-46.5 17q-30 0 -47 -16t-17 -56v-196zM256 0l-3 69h-4q-16 -39 -41 -57t-64 -18q-54 0 -84.5 32.5t-30.5 95.5v236q0 63 30 95.5t84 32.5q36 0 61.5 -15.5t39.5 -50.5h4v252h85v-672h-77z M271 -215l-94 108l-94 -108l-38 30l92 129h79l93 -129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E24",
    unicode: "\u1E24",
    horizAdvX: 374,
    d: "M27 0zM257 0v312h-140v-312h-90v664h90v-272h140v272h89v-664h-89zM144 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E25",
    unicode: "\u1E25",
    horizAdvX: 365,
    d: "M29 0zM249 0v342q0 35 -16 51.5t-45 16.5q-33 0 -52 -22.5t-21 -76.5v-311h-86v672h86v-252h4q14 34 40 50t63 16q32 0 53.5 -11t35 -29.5t19.5 -42t6 -48.5v-355h-87zM138 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E3C",
    unicode: "\u1E3C",
    horizAdvX: 299,
    d: "M22 0zM27 0v664h90v-582h164v-82h-254zM248 -215l-94 108l-94 -108l-38 30l92 129h79l93 -129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E3D",
    unicode: "\u1E3D",
    horizAdvX: 146,
    d: "M0 0zM29 0v672h86v-672h-86zM164 -215l-94 108l-94 -108l-38 30l92 129h79l93 -129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E44",
    unicode: "\u1E44",
    horizAdvX: 392,
    d: "M27 0zM259 0l-152 514h-4q3 -74 3 -140v-374h-79v664h118l139 -477h4q-3 94 -3 161v316h79v-664h-105zM149 700v108h86v-108h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E45",
    unicode: "\u1E45",
    horizAdvX: 365,
    d: "M29 0zM249 0v342q0 68 -62 68q-30 0 -45.5 -16t-26.5 -54v-340h-86v480h80l3 -69h4q16 39 41.5 57t63.5 18q51 0 83 -32.5t32 -95.5v-358h-87zM137 539v108h86v-108h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E4A",
    unicode: "\u1E4A",
    horizAdvX: 392,
    d: "M27 0zM259 0l-152 514h-4q3 -74 3 -140v-374h-79v664h118l139 -477h4q-3 94 -3 161v316h79v-664h-105zM283 -215l-94 108l-94 -108l-38 30l92 129h79l93 -129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E4B",
    unicode: "\u1E4B",
    horizAdvX: 365,
    d: "M29 0zM249 0v342q0 68 -62 68q-30 0 -45.5 -16t-26.5 -54v-340h-86v480h80l3 -69h4q16 39 41.5 57t63.5 18q51 0 83 -32.5t32 -95.5v-358h-87zM275 -215l-94 108l-94 -108l-38 30l92 129h79l93 -129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E5A",
    unicode: "\u1E5A",
    horizAdvX: 363,
    d: "M27 0zM27 0v664h185q70 0 98 -35t28 -98v-91q0 -46 -18 -73t-50 -35v-4q35 -7 52.5 -32t17.5 -75v-221h-88v228q0 32 -12 46.5t-44 14.5h-81v-289h-88zM251 521q0 31 -13.5 46.5t-45.5 15.5h-77v-219h78q27 0 42.5 15t15.5 53v89zM137 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E5B",
    unicode: "\u1E5B",
    horizAdvX: 277,
    d: "M26 0zM29 0v480h80l3 -82h4q14 42 40 65t64 23q21 0 40 -10v-79q-15 10 -45 10q-40 0 -64 -24t-36 -88v-295h-86zM26 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E62",
    unicode: "\u1E62",
    horizAdvX: 375,
    d: "M23 0zM256 468v38q0 37 -16.5 58.5t-54.5 21.5q-36 0 -53 -20t-17 -49v-26q0 -22 8 -37t31 -34q17 -13 37.5 -26.5t40.5 -26.5t39 -26t33 -25q23 -20 35.5 -47t12.5 -73v-41q0 -78 -38.5 -119.5t-126.5 -41.5t-126 42.5t-38 124.5v38h85v-39q0 -41 18 -62t59 -21 q35 0 54 18t19 58v30q0 15 -2 26.5t-7 21t-13.5 18t-20.5 18.5q-35 29 -71 51t-67 52q-25 26 -38 54t-13 68v29q0 66 37.5 107.5t120.5 41.5q45 0 75 -13t48 -36t25.5 -55t7.5 -69v-29h-84zM142 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E63",
    unicode: "\u1E63",
    horizAdvX: 353,
    d: "M25 0zM242 332v28q0 26 -15 40t-49 14q-66 0 -66 -47v-15q0 -15 6.5 -24.5t28.5 -23.5q34 -21 67 -34t62 -33q25 -17 38.5 -38t13.5 -58v-22q0 -63 -35.5 -94t-112.5 -31q-82 0 -118.5 33.5t-36.5 97.5v29h82v-32q0 -29 15.5 -43t53.5 -14q35 0 51 13t16 40v19 q0 15 -7.5 28t-34.5 28q-2 1 -18.5 9.5t-37 20t-41 23.5t-31.5 20q-24 18 -33.5 39t-9.5 46v24q0 50 37.5 80.5t107.5 30.5q75 0 111.5 -35t36.5 -95v-24h-81zM137 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E6C",
    unicode: "\u1E6C",
    horizAdvX: 350,
    d: "M19 0zM130 0v583h-111v81h313v-81h-113v-583h-89zM132 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E6D",
    unicode: "\u1E6D",
    horizAdvX: 343,
    d: "M29 0zM239 274h74v-130q0 -76 -29 -113t-105 -37q-78 0 -114 37t-36 113v469h85v-133h199v-77h-199v-259q0 -72 66 -72q32 0 45.5 17.5t13.5 54.5v130zM135 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 545,
    d: "M12 0zM92 0l-80 664h86l58 -505h4l62 505h101l64 -505h4l57 505h85l-80 -664h-113l-66 514h-4l-65 -514h-113zM157 823l46 52l149 -163l-34 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 498,
    d: "M10 0zM82 0l-72 480h80l52 -360h4l56 360h94l58 -360h4l51 360h79l-72 -480h-105l-60 367h-4l-60 -367h-105zM135 650l46 52l149 -163l-34 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 545,
    d: "M12 0zM92 0l-80 664h86l58 -505h4l62 505h101l64 -505h4l57 505h85l-80 -664h-113l-66 514h-4l-65 -514h-113zM231 677l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 498,
    d: "M10 0zM82 0l-72 480h80l52 -360h4l56 360h94l58 -360h4l51 360h79l-72 -480h-105l-60 367h-4l-60 -367h-105zM205 504l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 545,
    d: "M12 0zM92 0l-80 664h86l58 -505h4l62 505h101l64 -505h4l57 505h85l-80 -664h-113l-66 514h-4l-65 -514h-113zM156 712v108h80v-108h-80zM307 712v108h80v-108h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 498,
    d: "M10 0zM82 0l-72 480h80l52 -360h4l56 360h94l58 -360h4l51 360h79l-72 -480h-105l-60 367h-4l-60 -367h-105zM133 539v108h80v-108h-80zM284 539v108h80v-108h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E92",
    unicode: "\u1E92",
    horizAdvX: 337,
    d: "M19 0zM19 0v83l203 500h-201v81h292v-82l-201 -501h206v-81h-299zM125 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E93",
    unicode: "\u1E93",
    horizAdvX: 307,
    d: "M21 0zM21 0v81l171 322h-170v77h261v-78l-171 -323h175v-79h-266zM111 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E9E",
    unicode: "\u1E9E",
    horizAdvX: 410,
    d: "M161 84q14 -6 31 -8.5t32 -2.5q36 0 53.5 15.5t17.5 57.5v146q0 29 -16 42.5t-40 13.5q-23 0 -51 -12v79l88 168h-79q-80 0 -80 -85v-498h-90v499q0 81 40 123t118 42h177v-76l-91 -172q24 0 44.5 -6t35.5 -20t23.5 -36.5t8.5 -55.5v-149q0 -86 -34.5 -120.5 t-104.5 -34.5q-27 0 -49.5 3.5t-33.5 7.5v79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA0",
    unicode: "\u1EA0",
    horizAdvX: 372,
    d: "M12 0zM271 0l-26 156h-122l-24 -156h-87l113 664h121l113 -664h-88zM135 233h98l-47 291h-4zM141 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA1",
    unicode: "\u1EA1",
    horizAdvX: 355,
    d: "M22 0zM242 264q-15 -11 -28 -15t-41 -12q-42 -13 -54 -29t-12 -44v-43q0 -51 57 -51q30 0 48.5 14t29.5 43v137zM248 0l-3 61h-4q-16 -28 -41.5 -47.5t-72.5 -19.5q-57 0 -81 29t-24 78v48q0 31 7 53.5t22 38t39.5 27t59.5 21.5q16 5 32.5 9.5t29.5 10t21 13.5t8 20v20 q0 49 -62 49q-68 0 -68 -54v-31h-81v41q0 60 40.5 89.5t113.5 29.5q143 0 143 -112v-374h-79zM134 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA2",
    unicode: "\u1EA2",
    horizAdvX: 372,
    d: "M12 0zM271 0l-26 156h-122l-24 -156h-87l113 664h121l113 -664h-88zM135 233h98l-47 291h-4zM161 690q0 21 9.5 32.5t20.5 20t20.5 16.5t9.5 23q0 12 -8 20t-25 8q-16 0 -28.5 -5.5t-26.5 -15.5l-15 47q15 14 37.5 20.5t40.5 6.5q32 0 53.5 -20t21.5 -53 q0 -24 -10.5 -37.5t-23 -22.5t-23 -17.5t-10.5 -22.5h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA3",
    unicode: "\u1EA3",
    horizAdvX: 355,
    d: "M22 0zM242 264q-15 -11 -28 -15t-41 -12q-42 -13 -54 -29t-12 -44v-43q0 -51 57 -51q30 0 48.5 14t29.5 43v137zM248 0l-3 61h-4q-16 -28 -41.5 -47.5t-72.5 -19.5q-57 0 -81 29t-24 78v48q0 31 7 53.5t22 38t39.5 27t59.5 21.5q16 5 32.5 9.5t29.5 10t21 13.5t8 20v20 q0 49 -62 49q-68 0 -68 -54v-31h-81v41q0 60 40.5 89.5t113.5 29.5q143 0 143 -112v-374h-79zM150 517q0 21 9.5 32.5t20.5 20t20.5 16.5t9.5 23q0 12 -8 20t-25 8q-16 0 -28.5 -5.5t-26.5 -15.5l-15 47q15 14 37.5 20.5t40.5 6.5q32 0 53.5 -20t21.5 -53q0 -24 -10.5 -37.5 t-23 -22.5t-23 -17.5t-10.5 -22.5h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA4",
    unicode: "\u1EA4",
    horizAdvX: 372,
    d: "M12 0zM271 0l-26 156h-122l-24 -156h-87l113 664h121l113 -664h-88zM135 233h98l-47 291h-4zM278 677l-94 107l-94 -107l-38 30l92 128h79l93 -128zM296 787l-33 34l123 135l45 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA5",
    unicode: "\u1EA5",
    horizAdvX: 355,
    d: "M22 0zM242 264q-15 -11 -28 -15t-41 -12q-42 -13 -54 -29t-12 -44v-43q0 -51 57 -51q30 0 48.5 14t29.5 43v137zM248 0l-3 61h-4q-16 -28 -41.5 -47.5t-72.5 -19.5q-57 0 -81 29t-24 78v48q0 31 7 53.5t22 38t39.5 27t59.5 21.5q16 5 32.5 9.5t29.5 10t21 13.5t8 20v20 q0 49 -62 49q-68 0 -68 -54v-31h-81v41q0 60 40.5 89.5t113.5 29.5q143 0 143 -112v-374h-79zM276 504l-94 107l-94 -107l-38 30l92 128h79l93 -128zM294 614l-33 34l123 135l45 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA6",
    unicode: "\u1EA6",
    horizAdvX: 372,
    d: "M12 0zM271 0l-26 156h-122l-24 -156h-87l113 664h121l113 -664h-88zM135 233h98l-47 291h-4zM276 677l-94 107l-94 -107l-38 30l92 128h79l93 -128zM211 905l46 51l123 -135l-33 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA7",
    unicode: "\u1EA7",
    horizAdvX: 355,
    d: "M22 0zM242 264q-15 -11 -28 -15t-41 -12q-42 -13 -54 -29t-12 -44v-43q0 -51 57 -51q30 0 48.5 14t29.5 43v137zM248 0l-3 61h-4q-16 -28 -41.5 -47.5t-72.5 -19.5q-57 0 -81 29t-24 78v48q0 31 7 53.5t22 38t39.5 27t59.5 21.5q16 5 32.5 9.5t29.5 10t21 13.5t8 20v20 q0 49 -62 49q-68 0 -68 -54v-31h-81v41q0 60 40.5 89.5t113.5 29.5q143 0 143 -112v-374h-79zM269 504l-94 107l-94 -107l-38 30l92 128h79l93 -128zM204 732l46 51l123 -135l-33 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA8",
    unicode: "\u1EA8",
    horizAdvX: 372,
    d: "M12 0zM271 0l-26 156h-122l-24 -156h-87l113 664h121l113 -664h-88zM135 233h98l-47 291h-4zM281 677l-94 107l-94 -107l-38 30l92 128h79l93 -128zM301 783q0 21 9.5 32.5t20.5 20t20.5 16.5t9.5 23q0 12 -7.5 20t-25.5 8q-15 0 -28 -5.5t-26 -15.5l-15 47 q15 14 37.5 20.5t39.5 6.5q33 0 54 -20t21 -53q0 -24 -10.5 -37.5t-23 -22.5t-23 -17.5t-10.5 -22.5h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA9",
    unicode: "\u1EA9",
    horizAdvX: 355,
    d: "M22 0zM242 264q-15 -11 -28 -15t-41 -12q-42 -13 -54 -29t-12 -44v-43q0 -51 57 -51q30 0 48.5 14t29.5 43v137zM248 0l-3 61h-4q-16 -28 -41.5 -47.5t-72.5 -19.5q-57 0 -81 29t-24 78v48q0 31 7 53.5t22 38t39.5 27t59.5 21.5q16 5 32.5 9.5t29.5 10t21 13.5t8 20v20 q0 49 -62 49q-68 0 -68 -54v-31h-81v41q0 60 40.5 89.5t113.5 29.5q143 0 143 -112v-374h-79zM264 504l-94 107l-94 -107l-38 30l92 128h79l93 -128zM284 610q0 21 9.5 32.5t20.5 20t20.5 16.5t9.5 23q0 12 -7.5 20t-25.5 8q-15 0 -28 -5.5t-26 -15.5l-15 47 q15 14 37.5 20.5t39.5 6.5q33 0 54 -20t21 -53q0 -24 -10.5 -37.5t-23 -22.5t-23 -17.5t-10.5 -22.5h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAA",
    unicode: "\u1EAA",
    horizAdvX: 372,
    d: "M12 0zM271 0l-26 156h-122l-24 -156h-87l113 664h121l113 -664h-88zM135 233h98l-47 291h-4zM277 677l-94 107l-94 -107l-38 30l92 128h79l93 -128zM321 921q-9 -32 -28 -46t-45 -14q-17 0 -31.5 5.5t-29 11.5t-28.5 11.5t-30 5.5q-14 0 -24 -6t-16 -24l-39 23 q8 31 27.5 45.5t44.5 14.5q17 0 31.5 -5.5t29 -11.5t29 -11.5t30.5 -5.5q14 0 23.5 6t16.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAB",
    unicode: "\u1EAB",
    horizAdvX: 355,
    d: "M22 0zM242 264q-15 -11 -28 -15t-41 -12q-42 -13 -54 -29t-12 -44v-43q0 -51 57 -51q30 0 48.5 14t29.5 43v137zM248 0l-3 61h-4q-16 -28 -41.5 -47.5t-72.5 -19.5q-57 0 -81 29t-24 78v48q0 31 7 53.5t22 38t39.5 27t59.5 21.5q16 5 32.5 9.5t29.5 10t21 13.5t8 20v20 q0 49 -62 49q-68 0 -68 -54v-31h-81v41q0 60 40.5 89.5t113.5 29.5q143 0 143 -112v-374h-79zM268 504l-94 107l-94 -107l-38 30l92 128h79l93 -128zM312 748q-9 -32 -28 -46t-45 -14q-17 0 -31.5 5.5t-29 11.5t-28.5 11.5t-30 5.5q-14 0 -24 -6t-16 -24l-39 23 q8 31 27.5 45.5t44.5 14.5q17 0 31.5 -5.5t29 -11.5t29 -11.5t30.5 -5.5q14 0 23.5 6t16.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAC",
    unicode: "\u1EAC",
    horizAdvX: 372,
    d: "M12 0zM271 0l-26 156h-122l-24 -156h-87l113 664h121l113 -664h-88zM135 233h98l-47 291h-4zM278 678l-94 108l-94 -108l-38 30l92 129h79l93 -129zM143 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAD",
    unicode: "\u1EAD",
    horizAdvX: 355,
    d: "M22 0zM242 264q-15 -11 -28 -15t-41 -12q-42 -13 -54 -29t-12 -44v-43q0 -51 57 -51q30 0 48.5 14t29.5 43v137zM248 0l-3 61h-4q-16 -28 -41.5 -47.5t-72.5 -19.5q-57 0 -81 29t-24 78v48q0 31 7 53.5t22 38t39.5 27t59.5 21.5q16 5 32.5 9.5t29.5 10t21 13.5t8 20v20 q0 49 -62 49q-68 0 -68 -54v-31h-81v41q0 60 40.5 89.5t113.5 29.5q143 0 143 -112v-374h-79zM270 505l-94 108l-94 -108l-38 30l92 129h79l93 -129zM133 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAE",
    unicode: "\u1EAE",
    horizAdvX: 372,
    d: "M12 0zM271 0l-26 156h-122l-24 -156h-87l113 664h121l113 -664h-88zM135 233h98l-47 291h-4zM187 674q-60 0 -97 35t-37 110h63q2 -50 19.5 -73t51.5 -23q35 0 52 23t19 73h64q0 -76 -37.5 -110.5t-97.5 -34.5zM166 776l-33 34l133 146l46 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAF",
    unicode: "\u1EAF",
    horizAdvX: 355,
    d: "M22 0zM242 264q-15 -11 -28 -15t-41 -12q-42 -13 -54 -29t-12 -44v-43q0 -51 57 -51q30 0 48.5 14t29.5 43v137zM248 0l-3 61h-4q-16 -28 -41.5 -47.5t-72.5 -19.5q-57 0 -81 29t-24 78v48q0 31 7 53.5t22 38t39.5 27t59.5 21.5q16 5 32.5 9.5t29.5 10t21 13.5t8 20v20 q0 49 -62 49q-68 0 -68 -54v-31h-81v41q0 60 40.5 89.5t113.5 29.5q143 0 143 -112v-374h-79zM180 501q-60 0 -97 35t-37 110h63q2 -50 19.5 -73t51.5 -23q35 0 52 23t19 73h64q0 -76 -37.5 -110.5t-97.5 -34.5zM159 603l-33 34l133 146l46 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB0",
    unicode: "\u1EB0",
    horizAdvX: 372,
    d: "M12 0zM271 0l-26 156h-122l-24 -156h-87l113 664h121l113 -664h-88zM135 233h98l-47 291h-4zM189 674q-60 0 -97.5 34.5t-37.5 110.5h64q2 -50 19 -73t52 -23q34 0 51.5 23t19.5 73h63q0 -75 -37 -110t-97 -35zM65 905l46 51l133 -146l-33 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB1",
    unicode: "\u1EB1",
    horizAdvX: 355,
    d: "M22 0zM242 264q-15 -11 -28 -15t-41 -12q-42 -13 -54 -29t-12 -44v-43q0 -51 57 -51q30 0 48.5 14t29.5 43v137zM248 0l-3 61h-4q-16 -28 -41.5 -47.5t-72.5 -19.5q-57 0 -81 29t-24 78v48q0 31 7 53.5t22 38t39.5 27t59.5 21.5q16 5 32.5 9.5t29.5 10t21 13.5t8 20v20 q0 49 -62 49q-68 0 -68 -54v-31h-81v41q0 60 40.5 89.5t113.5 29.5q143 0 143 -112v-374h-79zM178 501q-60 0 -97.5 34.5t-37.5 110.5h64q2 -50 19 -73t52 -23q34 0 51.5 23t19.5 73h63q0 -75 -37 -110t-97 -35zM54 732l46 51l133 -146l-33 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB2",
    unicode: "\u1EB2",
    horizAdvX: 372,
    d: "M12 0zM271 0l-26 156h-122l-24 -156h-87l113 664h121l113 -664h-88zM135 233h98l-47 291h-4zM185 674q-60 0 -97 35t-37 110h63q1 -50 18.5 -73t52.5 -23q34 0 51.5 23t19.5 73h64q0 -76 -37.5 -110.5t-97.5 -34.5zM152 789q0 20 9.5 31t20.5 19.5t20.5 16.5t9.5 22 q0 11 -7.5 19t-25.5 8q-28 0 -54 -20l-15 45q15 13 37.5 19.5t40.5 6.5q32 0 53 -19.5t21 -51.5q0 -23 -10.5 -35.5t-22.5 -21.5t-22.5 -17.5t-10.5 -21.5h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB3",
    unicode: "\u1EB3",
    horizAdvX: 355,
    d: "M22 0zM242 264q-15 -11 -28 -15t-41 -12q-42 -13 -54 -29t-12 -44v-43q0 -51 57 -51q30 0 48.5 14t29.5 43v137zM248 0l-3 61h-4q-16 -28 -41.5 -47.5t-72.5 -19.5q-57 0 -81 29t-24 78v48q0 31 7 53.5t22 38t39.5 27t59.5 21.5q16 5 32.5 9.5t29.5 10t21 13.5t8 20v20 q0 49 -62 49q-68 0 -68 -54v-31h-81v41q0 60 40.5 89.5t113.5 29.5q143 0 143 -112v-374h-79zM178 501q-60 0 -97 35t-37 110h63q1 -50 18.5 -73t52.5 -23q34 0 51.5 23t19.5 73h64q0 -76 -37.5 -110.5t-97.5 -34.5zM145 616q0 20 9.5 31t20.5 19.5t20.5 16.5t9.5 22 q0 11 -7.5 19t-25.5 8q-28 0 -54 -20l-15 45q15 13 37.5 19.5t40.5 6.5q32 0 53 -19.5t21 -51.5q0 -23 -10.5 -35.5t-22.5 -21.5t-22.5 -17.5t-10.5 -21.5h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB4",
    unicode: "\u1EB4",
    horizAdvX: 372,
    d: "M12 0zM271 0l-26 156h-122l-24 -156h-87l113 664h121l113 -664h-88zM135 233h98l-47 291h-4zM184 674q-60 0 -97 35t-37 110h63q1 -50 18.5 -73t52.5 -23q34 0 51.5 23t19.5 73h64q0 -76 -37.5 -110.5t-97.5 -34.5zM320 906q-9 -31 -28 -45t-45 -14q-17 0 -31.5 5 t-29 11.5t-28.5 11.5t-30 5q-14 0 -24 -6t-16 -23l-39 23q8 31 27.5 45t44.5 14q17 0 31.5 -5t29 -11.5t29 -11.5t30.5 -5q14 0 23.5 6t16.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB5",
    unicode: "\u1EB5",
    horizAdvX: 355,
    d: "M22 0zM242 264q-15 -11 -28 -15t-41 -12q-42 -13 -54 -29t-12 -44v-43q0 -51 57 -51q30 0 48.5 14t29.5 43v137zM248 0l-3 61h-4q-16 -28 -41.5 -47.5t-72.5 -19.5q-57 0 -81 29t-24 78v48q0 31 7 53.5t22 38t39.5 27t59.5 21.5q16 5 32.5 9.5t29.5 10t21 13.5t8 20v20 q0 49 -62 49q-68 0 -68 -54v-31h-81v41q0 60 40.5 89.5t113.5 29.5q143 0 143 -112v-374h-79zM174 501q-60 0 -97 35t-37 110h63q1 -50 18.5 -73t52.5 -23q34 0 51.5 23t19.5 73h64q0 -76 -37.5 -110.5t-97.5 -34.5zM310 733q-9 -31 -28 -45t-45 -14q-17 0 -31.5 5t-29 11.5 t-28.5 11.5t-30 5q-14 0 -24 -6t-16 -23l-39 23q8 31 27.5 45t44.5 14q17 0 31.5 -5t29 -11.5t29 -11.5t30.5 -5q14 0 23.5 6t16.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB6",
    unicode: "\u1EB6",
    horizAdvX: 372,
    d: "M12 0zM271 0l-26 156h-122l-24 -156h-87l113 664h121l113 -664h-88zM135 233h98l-47 291h-4zM185 677q-60 0 -97.5 39.5t-37.5 119.5h63q2 -53 19.5 -77.5t52.5 -24.5q34 0 52 24.5t19 77.5h65q0 -81 -38 -120t-98 -39zM141 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB7",
    unicode: "\u1EB7",
    horizAdvX: 355,
    d: "M22 0zM242 264q-15 -11 -28 -15t-41 -12q-42 -13 -54 -29t-12 -44v-43q0 -51 57 -51q30 0 48.5 14t29.5 43v137zM248 0l-3 61h-4q-16 -28 -41.5 -47.5t-72.5 -19.5q-57 0 -81 29t-24 78v48q0 31 7 53.5t22 38t39.5 27t59.5 21.5q16 5 32.5 9.5t29.5 10t21 13.5t8 20v20 q0 49 -62 49q-68 0 -68 -54v-31h-81v41q0 60 40.5 89.5t113.5 29.5q143 0 143 -112v-374h-79zM173 504q-60 0 -97.5 39.5t-37.5 119.5h63q2 -53 19.5 -77.5t52.5 -24.5q34 0 52 24.5t19 77.5h65q0 -81 -38 -120t-98 -39zM130 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB8",
    unicode: "\u1EB8",
    horizAdvX: 292,
    d: "M27 0zM27 0v664h240v-81h-152v-194h139v-82h-139v-226h160v-81h-248zM106 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB9",
    unicode: "\u1EB9",
    horizAdvX: 359,
    d: "M29 0zM330 144q0 -150 -152 -150q-76 0 -112.5 36.5t-36.5 113.5v192q0 76 36.5 113t113.5 37q151 0 151 -150v-119h-217v-75q0 -72 65 -72q67 0 67 72v24h85v-22zM245 338q0 72 -66 72t-66 -72v-57h132v57zM136 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBA",
    unicode: "\u1EBA",
    horizAdvX: 292,
    d: "M27 0zM27 0v664h240v-81h-152v-194h139v-82h-139v-226h160v-81h-248zM130 690q0 21 9.5 32.5t20.5 20t20.5 16.5t9.5 23q0 12 -8 20t-25 8q-16 0 -28.5 -5.5t-26.5 -15.5l-15 47q15 14 37.5 20.5t40.5 6.5q32 0 53.5 -20t21.5 -53q0 -24 -10.5 -37.5t-23 -22.5t-23 -17.5 t-10.5 -22.5h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBB",
    unicode: "\u1EBB",
    horizAdvX: 359,
    d: "M29 0zM330 144q0 -150 -152 -150q-76 0 -112.5 36.5t-36.5 113.5v192q0 76 36.5 113t113.5 37q151 0 151 -150v-119h-217v-75q0 -72 65 -72q67 0 67 72v24h85v-22zM245 338q0 72 -66 72t-66 -72v-57h132v57zM153 517q0 21 9.5 32.5t20.5 20t20.5 16.5t9.5 23q0 12 -8 20 t-25 8q-16 0 -28.5 -5.5t-26.5 -15.5l-15 47q15 14 37.5 20.5t40.5 6.5q32 0 53.5 -20t21.5 -53q0 -24 -10.5 -37.5t-23 -22.5t-23 -17.5t-10.5 -22.5h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBC",
    unicode: "\u1EBC",
    horizAdvX: 292,
    d: "M13 0zM27 0v664h240v-81h-152v-194h139v-82h-139v-226h160v-81h-248zM284 761q-8 -31 -27.5 -45t-45.5 -14q-17 0 -31.5 5t-28.5 11.5t-28.5 11.5t-30.5 5q-14 0 -23.5 -6t-16.5 -23l-39 23q9 31 28 45t45 14q16 0 31 -5t29 -11.5t28.5 -11.5t30.5 -5q14 0 24 6t16 23z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBD",
    unicode: "\u1EBD",
    horizAdvX: 359,
    d: "M29 0zM330 144q0 -150 -152 -150q-76 0 -112.5 36.5t-36.5 113.5v192q0 76 36.5 113t113.5 37q151 0 151 -150v-119h-217v-75q0 -72 65 -72q67 0 67 72v24h85v-22zM245 338q0 72 -66 72t-66 -72v-57h132v57zM314 588q-8 -31 -27.5 -45t-45.5 -14q-17 0 -31.5 5 t-28.5 11.5t-28.5 11.5t-30.5 5q-14 0 -23.5 -6t-16.5 -23l-39 23q9 31 28 45t45 14q16 0 31 -5t29 -11.5t28.5 -11.5t30.5 -5q14 0 24 6t16 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBE",
    unicode: "\u1EBE",
    horizAdvX: 292,
    d: "M20 0zM27 0v664h240v-81h-152v-194h139v-82h-139v-226h160v-81h-248zM246 677l-94 107l-94 -107l-38 30l92 128h79l93 -128zM264 787l-33 34l123 135l45 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBF",
    unicode: "\u1EBF",
    horizAdvX: 359,
    d: "M29 0zM330 144q0 -150 -152 -150q-76 0 -112.5 36.5t-36.5 113.5v192q0 76 36.5 113t113.5 37q151 0 151 -150v-119h-217v-75q0 -72 65 -72q67 0 67 72v24h85v-22zM245 338q0 72 -66 72t-66 -72v-57h132v57zM275 504l-94 107l-94 -107l-38 30l92 128h79l93 -128zM293 614 l-33 34l123 135l45 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC0",
    unicode: "\u1EC0",
    horizAdvX: 292,
    d: "M17 0zM27 0v664h240v-81h-152v-194h139v-82h-139v-226h160v-81h-248zM243 677l-94 107l-94 -107l-38 30l92 128h79l93 -128zM178 905l46 51l123 -135l-33 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC1",
    unicode: "\u1EC1",
    horizAdvX: 359,
    d: "M29 0zM330 144q0 -150 -152 -150q-76 0 -112.5 36.5t-36.5 113.5v192q0 76 36.5 113t113.5 37q151 0 151 -150v-119h-217v-75q0 -72 65 -72q67 0 67 72v24h85v-22zM245 338q0 72 -66 72t-66 -72v-57h132v57zM268 504l-94 107l-94 -107l-38 30l92 128h79l93 -128zM203 732 l46 51l123 -135l-33 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC2",
    unicode: "\u1EC2",
    horizAdvX: 292,
    d: "M18 0zM27 0v664h240v-81h-152v-194h139v-82h-139v-226h160v-81h-248zM244 677l-94 107l-94 -107l-38 30l92 128h79l93 -128zM264 783q0 21 9.5 32.5t20.5 20t20.5 16.5t9.5 23q0 12 -7.5 20t-25.5 8q-15 0 -28 -5.5t-26 -15.5l-15 47q15 14 37.5 20.5t39.5 6.5 q33 0 54 -20t21 -53q0 -24 -10.5 -37.5t-23 -22.5t-23 -17.5t-10.5 -22.5h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC3",
    unicode: "\u1EC3",
    horizAdvX: 359,
    d: "M29 0zM330 144q0 -150 -152 -150q-76 0 -112.5 36.5t-36.5 113.5v192q0 76 36.5 113t113.5 37q151 0 151 -150v-119h-217v-75q0 -72 65 -72q67 0 67 72v24h85v-22zM245 338q0 72 -66 72t-66 -72v-57h132v57zM268 504l-94 107l-94 -107l-38 30l92 128h79l93 -128zM288 610 q0 21 9.5 32.5t20.5 20t20.5 16.5t9.5 23q0 12 -7.5 20t-25.5 8q-15 0 -28 -5.5t-26 -15.5l-15 47q15 14 37.5 20.5t39.5 6.5q33 0 54 -20t21 -53q0 -24 -10.5 -37.5t-23 -22.5t-23 -17.5t-10.5 -22.5h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC4",
    unicode: "\u1EC4",
    horizAdvX: 292,
    d: "M20 0zM27 0v664h240v-81h-152v-194h139v-82h-139v-226h160v-81h-248zM247 677l-94 107l-94 -107l-38 30l92 128h79l93 -128zM291 921q-9 -32 -28 -46t-45 -14q-17 0 -31.5 5.5t-29 11.5t-28.5 11.5t-30 5.5q-14 0 -24 -6t-16 -24l-39 23q8 31 27.5 45.5t44.5 14.5 q17 0 31.5 -5.5t29 -11.5t29 -11.5t30.5 -5.5q14 0 23.5 6t16.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC5",
    unicode: "\u1EC5",
    horizAdvX: 359,
    d: "M29 0zM330 144q0 -150 -152 -150q-76 0 -112.5 36.5t-36.5 113.5v192q0 76 36.5 113t113.5 37q151 0 151 -150v-119h-217v-75q0 -72 65 -72q67 0 67 72v24h85v-22zM245 338q0 72 -66 72t-66 -72v-57h132v57zM273 504l-94 107l-94 -107l-38 30l92 128h79l93 -128zM317 748 q-9 -32 -28 -46t-45 -14q-17 0 -31.5 5.5t-29 11.5t-28.5 11.5t-30 5.5q-14 0 -24 -6t-16 -24l-39 23q8 31 27.5 45.5t44.5 14.5q17 0 31.5 -5.5t29 -11.5t29 -11.5t30.5 -5.5q14 0 23.5 6t16.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC6",
    unicode: "\u1EC6",
    horizAdvX: 292,
    d: "M23 0zM27 0v664h240v-81h-152v-194h139v-82h-139v-226h160v-81h-248zM249 678l-94 108l-94 -108l-38 30l92 129h79l93 -129zM112 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC7",
    unicode: "\u1EC7",
    horizAdvX: 359,
    d: "M29 0zM330 144q0 -150 -152 -150q-76 0 -112.5 36.5t-36.5 113.5v192q0 76 36.5 113t113.5 37q151 0 151 -150v-119h-217v-75q0 -72 65 -72q67 0 67 72v24h85v-22zM245 338q0 72 -66 72t-66 -72v-57h132v57zM272 505l-94 108l-94 -108l-38 30l92 129h79l93 -129z M135 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC8",
    unicode: "\u1EC8",
    horizAdvX: 158,
    d: "M5 0zM27 0v664h90v-664h-90zM48 690q0 21 9.5 32.5t20.5 20t20.5 16.5t9.5 23q0 12 -8 20t-25 8q-16 0 -28.5 -5.5t-26.5 -15.5l-15 47q15 14 37.5 20.5t40.5 6.5q32 0 53.5 -20t21.5 -53q0 -24 -10.5 -37.5t-23 -22.5t-23 -17.5t-10.5 -22.5h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC9",
    unicode: "\u1EC9",
    horizAdvX: 157,
    d: "M5 0zM29 0v480h86v-480h-86zM48 517q0 21 9.5 32.5t20.5 20t20.5 16.5t9.5 23q0 12 -8 20t-25 8q-16 0 -28.5 -5.5t-26.5 -15.5l-15 47q15 14 37.5 20.5t40.5 6.5q32 0 53.5 -20t21.5 -53q0 -24 -10.5 -37.5t-23 -22.5t-23 -17.5t-10.5 -22.5h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECA",
    unicode: "\u1ECA",
    horizAdvX: 144,
    d: "M27 0zM27 0v664h90v-664h-90zM30 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECB",
    unicode: "\u1ECB",
    horizAdvX: 145,
    d: "M28 0zM29 0v480h86v-480h-86zM29 539v108h86v-108h-86zM28 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECC",
    unicode: "\u1ECC",
    d: "M23 0zM338 160q0 -84 -40.5 -125t-115.5 -41q-78 0 -118.5 43.5t-40.5 124.5v337q0 81 41.5 126t116.5 45t116 -46t41 -127v-337zM250 505q0 39 -18 60t-52 21q-32 0 -50 -20.5t-18 -59.5v-350q0 -79 69 -79q33 0 51 19t18 59v350zM138 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECD",
    unicode: "\u1ECD",
    horizAdvX: 358,
    d: "M29 0zM329 144q0 -78 -36.5 -114t-113.5 -36t-113.5 36t-36.5 114v192q0 78 36.5 114t113.5 36t113.5 -36t36.5 -114v-192zM245 336q0 72 -66 72t-66 -72v-192q0 -72 66 -72t66 72v192zM137 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECE",
    unicode: "\u1ECE",
    d: "M23 0zM338 160q0 -84 -40.5 -125t-115.5 -41q-78 0 -118.5 43.5t-40.5 124.5v337q0 81 41.5 126t116.5 45t116 -46t41 -127v-337zM250 505q0 39 -18 60t-52 21q-32 0 -50 -20.5t-18 -59.5v-350q0 -79 69 -79q33 0 51 19t18 59v350zM155 690q0 21 9.5 32.5t20.5 20 t20.5 16.5t9.5 23q0 12 -8 20t-25 8q-16 0 -28.5 -5.5t-26.5 -15.5l-15 47q15 14 37.5 20.5t40.5 6.5q32 0 53.5 -20t21.5 -53q0 -24 -10.5 -37.5t-23 -22.5t-23 -17.5t-10.5 -22.5h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECF",
    unicode: "\u1ECF",
    horizAdvX: 358,
    d: "M29 0zM329 144q0 -78 -36.5 -114t-113.5 -36t-113.5 36t-36.5 114v192q0 78 36.5 114t113.5 36t113.5 -36t36.5 -114v-192zM245 336q0 72 -66 72t-66 -72v-192q0 -72 66 -72t66 72v192zM152 517q0 21 9.5 32.5t20.5 20t20.5 16.5t9.5 23q0 12 -8 20t-25 8 q-16 0 -28.5 -5.5t-26.5 -15.5l-15 47q15 14 37.5 20.5t40.5 6.5q32 0 53.5 -20t21.5 -53q0 -24 -10.5 -37.5t-23 -22.5t-23 -17.5t-10.5 -22.5h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED0",
    unicode: "\u1ED0",
    d: "M23 0zM338 160q0 -84 -40.5 -125t-115.5 -41q-78 0 -118.5 43.5t-40.5 124.5v337q0 81 41.5 126t116.5 45t116 -46t41 -127v-337zM250 505q0 39 -18 60t-52 21q-32 0 -50 -20.5t-18 -59.5v-350q0 -79 69 -79q33 0 51 19t18 59v350zM279 677l-94 107l-94 -107l-38 30 l92 128h79l93 -128zM297 787l-33 34l123 135l45 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED1",
    unicode: "\u1ED1",
    horizAdvX: 358,
    d: "M29 0zM329 144q0 -78 -36.5 -114t-113.5 -36t-113.5 36t-36.5 114v192q0 78 36.5 114t113.5 36t113.5 -36t36.5 -114v-192zM245 336q0 72 -66 72t-66 -72v-192q0 -72 66 -72t66 72v192zM272 504l-94 107l-94 -107l-38 30l92 128h79l93 -128zM290 614l-33 34l123 135 l45 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED2",
    unicode: "\u1ED2",
    d: "M23 0zM338 160q0 -84 -40.5 -125t-115.5 -41q-78 0 -118.5 43.5t-40.5 124.5v337q0 81 41.5 126t116.5 45t116 -46t41 -127v-337zM250 505q0 39 -18 60t-52 21q-32 0 -50 -20.5t-18 -59.5v-350q0 -79 69 -79q33 0 51 19t18 59v350zM277 677l-94 107l-94 -107l-38 30 l92 128h79l93 -128zM212 905l46 51l123 -135l-33 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED3",
    unicode: "\u1ED3",
    horizAdvX: 358,
    d: "M29 0zM329 144q0 -78 -36.5 -114t-113.5 -36t-113.5 36t-36.5 114v192q0 78 36.5 114t113.5 36t113.5 -36t36.5 -114v-192zM245 336q0 72 -66 72t-66 -72v-192q0 -72 66 -72t66 72v192zM270 504l-94 107l-94 -107l-38 30l92 128h79l93 -128zM205 732l46 51l123 -135 l-33 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED4",
    unicode: "\u1ED4",
    d: "M23 0zM338 160q0 -84 -40.5 -125t-115.5 -41q-78 0 -118.5 43.5t-40.5 124.5v337q0 81 41.5 126t116.5 45t116 -46t41 -127v-337zM250 505q0 39 -18 60t-52 21q-32 0 -50 -20.5t-18 -59.5v-350q0 -79 69 -79q33 0 51 19t18 59v350zM275 677l-94 107l-94 -107l-38 30 l92 128h79l93 -128zM295 783q0 21 9.5 32.5t20.5 20t20.5 16.5t9.5 23q0 12 -7.5 20t-25.5 8q-15 0 -28 -5.5t-26 -15.5l-15 47q15 14 37.5 20.5t39.5 6.5q33 0 54 -20t21 -53q0 -24 -10.5 -37.5t-23 -22.5t-23 -17.5t-10.5 -22.5h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED5",
    unicode: "\u1ED5",
    horizAdvX: 358,
    d: "M29 0zM329 144q0 -78 -36.5 -114t-113.5 -36t-113.5 36t-36.5 114v192q0 78 36.5 114t113.5 36t113.5 -36t36.5 -114v-192zM245 336q0 72 -66 72t-66 -72v-192q0 -72 66 -72t66 72v192zM272 504l-94 107l-94 -107l-38 30l92 128h79l93 -128zM292 610q0 21 9.5 32.5 t20.5 20t20.5 16.5t9.5 23q0 12 -7.5 20t-25.5 8q-15 0 -28 -5.5t-26 -15.5l-15 47q15 14 37.5 20.5t39.5 6.5q33 0 54 -20t21 -53q0 -24 -10.5 -37.5t-23 -22.5t-23 -17.5t-10.5 -22.5h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED6",
    unicode: "\u1ED6",
    d: "M23 0zM338 160q0 -84 -40.5 -125t-115.5 -41q-78 0 -118.5 43.5t-40.5 124.5v337q0 81 41.5 126t116.5 45t116 -46t41 -127v-337zM250 505q0 39 -18 60t-52 21q-32 0 -50 -20.5t-18 -59.5v-350q0 -79 69 -79q33 0 51 19t18 59v350zM276 677l-94 107l-94 -107l-38 30 l92 128h79l93 -128zM320 921q-9 -32 -28 -46t-45 -14q-17 0 -31.5 5.5t-29 11.5t-28.5 11.5t-30 5.5q-14 0 -24 -6t-16 -24l-39 23q8 31 27.5 45.5t44.5 14.5q17 0 31.5 -5.5t29 -11.5t29 -11.5t30.5 -5.5q14 0 23.5 6t16.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED7",
    unicode: "\u1ED7",
    horizAdvX: 358,
    d: "M29 0zM329 144q0 -78 -36.5 -114t-113.5 -36t-113.5 36t-36.5 114v192q0 78 36.5 114t113.5 36t113.5 -36t36.5 -114v-192zM245 336q0 72 -66 72t-66 -72v-192q0 -72 66 -72t66 72v192zM275 504l-94 107l-94 -107l-38 30l92 128h79l93 -128zM319 748q-9 -32 -28 -46 t-45 -14q-17 0 -31.5 5.5t-29 11.5t-28.5 11.5t-30 5.5q-14 0 -24 -6t-16 -24l-39 23q8 31 27.5 45.5t44.5 14.5q17 0 31.5 -5.5t29 -11.5t29 -11.5t30.5 -5.5q14 0 23.5 6t16.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED8",
    unicode: "\u1ED8",
    d: "M23 0zM338 160q0 -84 -40.5 -125t-115.5 -41q-78 0 -118.5 43.5t-40.5 124.5v337q0 81 41.5 126t116.5 45t116 -46t41 -127v-337zM250 505q0 39 -18 60t-52 21q-32 0 -50 -20.5t-18 -59.5v-350q0 -79 69 -79q33 0 51 19t18 59v350zM275 678l-94 108l-94 -108l-38 30 l92 129h79l93 -129zM139 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED9",
    unicode: "\u1ED9",
    horizAdvX: 358,
    d: "M29 0zM329 144q0 -78 -36.5 -114t-113.5 -36t-113.5 36t-36.5 114v192q0 78 36.5 114t113.5 36t113.5 -36t36.5 -114v-192zM245 336q0 72 -66 72t-66 -72v-192q0 -72 66 -72t66 72v192zM274 505l-94 108l-94 -108l-38 30l92 129h79l93 -129zM136 -166v107h86v-107h-86z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDA",
    unicode: "\u1EDA",
    horizAdvX: 420,
    d: "M23 0zM338 160q0 -85 -40.5 -125.5t-115.5 -40.5q-78 0 -118.5 43.5t-40.5 124.5v337q0 82 41 126.5t115 44.5q32 0 64 -5.5t64 -5.5q30 0 41.5 9.5t11.5 35.5q0 9 -1 24t-4 24h49q5 -8 6.5 -23t1.5 -32q0 -49 -15 -70t-50 -21q-7 0 -18.5 1t-24.5 3q34 -42 34 -113v-337 zM250 505q0 39 -18 60t-51 21t-51 -20.5t-18 -59.5v-350q0 -79 69 -79q33 0 51 19t18 59v350zM130 677l-34 35l149 163l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDB",
    unicode: "\u1EDB",
    horizAdvX: 404,
    d: "M29 0zM135 504l-34 35l149 163l46 -52zM329 144q0 -78 -36.5 -114t-113.5 -36t-113.5 36t-36.5 114v192q0 150 145 150q35 0 63 -5.5t57 -5.5t39.5 9.5t10.5 35.5q0 9 -1 24t-4 24h49q5 -8 7 -23t2 -32q0 -49 -15 -70t-49 -21h-13.5t-13.5 1q23 -34 23 -87v-192zM245 336 q0 72 -66 72t-66 -72v-192q0 -72 66 -72t66 72v192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDC",
    unicode: "\u1EDC",
    horizAdvX: 420,
    d: "M23 0zM338 160q0 -85 -40.5 -125.5t-115.5 -40.5q-78 0 -118.5 43.5t-40.5 124.5v337q0 82 41 126.5t115 44.5q32 0 64 -5.5t64 -5.5q30 0 41.5 9.5t11.5 35.5q0 9 -1 24t-4 24h49q5 -8 6.5 -23t1.5 -32q0 -49 -15 -70t-50 -21q-7 0 -18.5 1t-24.5 3q34 -42 34 -113v-337 zM250 505q0 39 -18 60t-51 21t-51 -20.5t-18 -59.5v-350q0 -79 69 -79q33 0 51 19t18 59v350zM66 823l46 52l149 -163l-34 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDD",
    unicode: "\u1EDD",
    horizAdvX: 404,
    d: "M29 0zM65 650l46 52l149 -163l-34 -35zM329 144q0 -78 -36.5 -114t-113.5 -36t-113.5 36t-36.5 114v192q0 150 145 150q35 0 63 -5.5t57 -5.5t39.5 9.5t10.5 35.5q0 9 -1 24t-4 24h49q5 -8 7 -23t2 -32q0 -49 -15 -70t-49 -21h-13.5t-13.5 1q23 -34 23 -87v-192zM245 336 q0 72 -66 72t-66 -72v-192q0 -72 66 -72t66 72v192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDE",
    unicode: "\u1EDE",
    horizAdvX: 420,
    d: "M23 0zM338 160q0 -85 -40.5 -125.5t-115.5 -40.5q-78 0 -118.5 43.5t-40.5 124.5v337q0 82 41 126.5t115 44.5q32 0 64 -5.5t64 -5.5q30 0 41.5 9.5t11.5 35.5q0 9 -1 24t-4 24h49q5 -8 6.5 -23t1.5 -32q0 -49 -15 -70t-50 -21q-7 0 -18.5 1t-24.5 3q34 -42 34 -113v-337 zM250 505q0 39 -18 60t-51 21t-51 -20.5t-18 -59.5v-350q0 -79 69 -79q33 0 51 19t18 59v350zM155 690q0 21 9.5 32.5t20.5 20t20.5 16.5t9.5 23q0 12 -8 20t-25 8q-16 0 -28.5 -5.5t-26.5 -15.5l-15 47q15 14 37.5 20.5t40.5 6.5q32 0 53.5 -20t21.5 -53q0 -24 -10.5 -37.5 t-23 -22.5t-23 -17.5t-10.5 -22.5h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDF",
    unicode: "\u1EDF",
    horizAdvX: 404,
    d: "M29 0zM329 144q0 -78 -36.5 -114t-113.5 -36t-113.5 36t-36.5 114v192q0 150 145 150q35 0 63 -5.5t57 -5.5t39.5 9.5t10.5 35.5q0 9 -1 24t-4 24h49q5 -8 7 -23t2 -32q0 -49 -15 -70t-49 -21h-13.5t-13.5 1q23 -34 23 -87v-192zM245 336q0 72 -66 72t-66 -72v-192 q0 -72 66 -72t66 72v192zM156 517q0 21 9.5 32.5t20.5 20t20.5 16.5t9.5 23q0 12 -8 20t-25 8q-16 0 -28.5 -5.5t-26.5 -15.5l-15 47q15 14 37.5 20.5t40.5 6.5q32 0 53.5 -20t21.5 -53q0 -24 -10.5 -37.5t-23 -22.5t-23 -17.5t-10.5 -22.5h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE0",
    unicode: "\u1EE0",
    horizAdvX: 420,
    d: "M23 0zM338 160q0 -85 -40.5 -125.5t-115.5 -40.5q-78 0 -118.5 43.5t-40.5 124.5v337q0 82 41 126.5t115 44.5q32 0 64 -5.5t64 -5.5q30 0 41.5 9.5t11.5 35.5q0 9 -1 24t-4 24h49q5 -8 6.5 -23t1.5 -32q0 -49 -15 -70t-50 -21q-7 0 -18.5 1t-24.5 3q34 -42 34 -113v-337 zM250 505q0 39 -18 60t-51 21t-51 -20.5t-18 -59.5v-350q0 -79 69 -79q33 0 51 19t18 59v350zM318 761q-8 -31 -27.5 -45t-45.5 -14q-17 0 -31.5 5t-28.5 11.5t-28.5 11.5t-30.5 5q-14 0 -23.5 -6t-16.5 -23l-39 23q9 31 28 45t45 14q16 0 31 -5t29 -11.5t28.5 -11.5 t30.5 -5q14 0 24 6t16 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE1",
    unicode: "\u1EE1",
    horizAdvX: 404,
    d: "M29 0zM329 144q0 -78 -36.5 -114t-113.5 -36t-113.5 36t-36.5 114v192q0 150 145 150q35 0 63 -5.5t57 -5.5t39.5 9.5t10.5 35.5q0 9 -1 24t-4 24h49q5 -8 7 -23t2 -32q0 -49 -15 -70t-49 -21h-13.5t-13.5 1q23 -34 23 -87v-192zM245 336q0 72 -66 72t-66 -72v-192 q0 -72 66 -72t66 72v192zM315 588q-8 -31 -27.5 -45t-45.5 -14q-17 0 -31.5 5t-28.5 11.5t-28.5 11.5t-30.5 5q-14 0 -23.5 -6t-16.5 -23l-39 23q9 31 28 45t45 14q16 0 31 -5t29 -11.5t28.5 -11.5t30.5 -5q14 0 24 6t16 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE2",
    unicode: "\u1EE2",
    horizAdvX: 420,
    d: "M23 0zM338 160q0 -85 -40.5 -125.5t-115.5 -40.5q-78 0 -118.5 43.5t-40.5 124.5v337q0 82 41 126.5t115 44.5q32 0 64 -5.5t64 -5.5q30 0 41.5 9.5t11.5 35.5q0 9 -1 24t-4 24h49q5 -8 6.5 -23t1.5 -32q0 -49 -15 -70t-50 -21q-7 0 -18.5 1t-24.5 3q34 -42 34 -113v-337 zM250 505q0 39 -18 60t-51 21t-51 -20.5t-18 -59.5v-350q0 -79 69 -79q33 0 51 19t18 59v350zM138 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE3",
    unicode: "\u1EE3",
    horizAdvX: 404,
    d: "M29 0zM329 144q0 -78 -36.5 -114t-113.5 -36t-113.5 36t-36.5 114v192q0 150 145 150q35 0 63 -5.5t57 -5.5t39.5 9.5t10.5 35.5q0 9 -1 24t-4 24h49q5 -8 7 -23t2 -32q0 -49 -15 -70t-49 -21h-13.5t-13.5 1q23 -34 23 -87v-192zM245 336q0 72 -66 72t-66 -72v-192 q0 -72 66 -72t66 72v192zM137 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE4",
    unicode: "\u1EE4",
    horizAdvX: 368,
    d: "M27 0zM252 664h88v-502q0 -81 -39 -124.5t-117 -43.5q-75 0 -116 41t-41 125v504h88v-509q0 -78 68 -78q69 0 69 79v508zM139 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE5",
    unicode: "\u1EE5",
    horizAdvX: 363,
    d: "M29 0zM116 480v-336q0 -41 15 -57.5t47 -16.5t46.5 17t23.5 61v332h86v-480h-81l-2 69h-4q-17 -41 -41.5 -58t-64.5 -17q-62 0 -87 38.5t-25 112.5v335h87zM139 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE6",
    unicode: "\u1EE6",
    horizAdvX: 368,
    d: "M27 0zM252 664h88v-502q0 -81 -39 -124.5t-117 -43.5q-75 0 -116 41t-41 125v504h88v-509q0 -78 68 -78q69 0 69 79v508zM155 690q0 21 9.5 32.5t20.5 20t20.5 16.5t9.5 23q0 12 -8 20t-25 8q-16 0 -28.5 -5.5t-26.5 -15.5l-15 47q15 14 37.5 20.5t40.5 6.5 q32 0 53.5 -20t21.5 -53q0 -24 -10.5 -37.5t-23 -22.5t-23 -17.5t-10.5 -22.5h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE7",
    unicode: "\u1EE7",
    horizAdvX: 363,
    d: "M29 0zM116 480v-336q0 -41 15 -57.5t47 -16.5t46.5 17t23.5 61v332h86v-480h-81l-2 69h-4q-17 -41 -41.5 -58t-64.5 -17q-62 0 -87 38.5t-25 112.5v335h87zM157 517q0 21 9.5 32.5t20.5 20t20.5 16.5t9.5 23q0 12 -8 20t-25 8q-16 0 -28.5 -5.5t-26.5 -15.5l-15 47 q15 14 37.5 20.5t40.5 6.5q32 0 53.5 -20t21.5 -53q0 -24 -10.5 -37.5t-23 -22.5t-23 -17.5t-10.5 -22.5h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE8",
    unicode: "\u1EE8",
    horizAdvX: 455,
    d: "M27 0zM252 664h102q22 0 31.5 9t9.5 33q0 8 -1 22t-4 24h49q5 -8 7 -23t2 -32q0 -49 -15 -68.5t-49 -19.5q-11 0 -21.5 1t-22.5 4v-452q0 -83 -39 -125.5t-117 -42.5q-76 0 -116.5 40.5t-40.5 125.5v504h88v-509q0 -78 68 -78q69 0 69 79v508zM136 677l-34 35l149 163 l46 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE9",
    unicode: "\u1EE9",
    horizAdvX: 444,
    d: "M29 0zM138 504l-34 35l149 163l46 -52zM116 480v-342q0 -36 16 -52t45 -16t44.5 16t26.5 54v340h98q20 0 29.5 8.5t9.5 33.5q0 8 -1.5 22t-3.5 24h49q5 -8 6.5 -23t1.5 -32q0 -48 -14.5 -68t-49.5 -20q-9 0 -19 1t-20 4v-430h-80l-3 69h-4q-15 -36 -40 -55.5t-63 -19.5 q-33 0 -55 11.5t-35.5 31.5t-19 48.5t-5.5 61.5v333h87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEA",
    unicode: "\u1EEA",
    horizAdvX: 455,
    d: "M27 0zM252 664h102q22 0 31.5 9t9.5 33q0 8 -1 22t-4 24h49q5 -8 7 -23t2 -32q0 -49 -15 -68.5t-49 -19.5q-11 0 -21.5 1t-22.5 4v-452q0 -83 -39 -125.5t-117 -42.5q-76 0 -116.5 40.5t-40.5 125.5v504h88v-509q0 -78 68 -78q69 0 69 79v508zM70 823l46 52l149 -163 l-34 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEB",
    unicode: "\u1EEB",
    horizAdvX: 444,
    d: "M29 0zM68 650l46 52l149 -163l-34 -35zM116 480v-342q0 -36 16 -52t45 -16t44.5 16t26.5 54v340h98q20 0 29.5 8.5t9.5 33.5q0 8 -1.5 22t-3.5 24h49q5 -8 6.5 -23t1.5 -32q0 -48 -14.5 -68t-49.5 -20q-9 0 -19 1t-20 4v-430h-80l-3 69h-4q-15 -36 -40 -55.5t-63 -19.5 q-33 0 -55 11.5t-35.5 31.5t-19 48.5t-5.5 61.5v333h87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEC",
    unicode: "\u1EEC",
    horizAdvX: 455,
    d: "M27 0zM252 664h102q22 0 31.5 9t9.5 33q0 8 -1 22t-4 24h49q5 -8 7 -23t2 -32q0 -49 -15 -68.5t-49 -19.5q-11 0 -21.5 1t-22.5 4v-452q0 -83 -39 -125.5t-117 -42.5q-76 0 -116.5 40.5t-40.5 125.5v504h88v-509q0 -78 68 -78q69 0 69 79v508zM159 690q0 21 9.5 32.5 t20.5 20t20.5 16.5t9.5 23q0 12 -8 20t-25 8q-16 0 -28.5 -5.5t-26.5 -15.5l-15 47q15 14 37.5 20.5t40.5 6.5q32 0 53.5 -20t21.5 -53q0 -24 -10.5 -37.5t-23 -22.5t-23 -17.5t-10.5 -22.5h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EED",
    unicode: "\u1EED",
    horizAdvX: 444,
    d: "M29 0zM116 480v-342q0 -36 16 -52t45 -16t44.5 16t26.5 54v340h98q20 0 29.5 8.5t9.5 33.5q0 8 -1.5 22t-3.5 24h49q5 -8 6.5 -23t1.5 -32q0 -48 -14.5 -68t-49.5 -20q-9 0 -19 1t-20 4v-430h-80l-3 69h-4q-15 -36 -40 -55.5t-63 -19.5q-33 0 -55 11.5t-35.5 31.5 t-19 48.5t-5.5 61.5v333h87zM157 517q0 21 9.5 32.5t20.5 20t20.5 16.5t9.5 23q0 12 -8 20t-25 8q-16 0 -28.5 -5.5t-26.5 -15.5l-15 47q15 14 37.5 20.5t40.5 6.5q32 0 53.5 -20t21.5 -53q0 -24 -10.5 -37.5t-23 -22.5t-23 -17.5t-10.5 -22.5h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEE",
    unicode: "\u1EEE",
    horizAdvX: 455,
    d: "M27 0zM252 664h102q22 0 31.5 9t9.5 33q0 8 -1 22t-4 24h49q5 -8 7 -23t2 -32q0 -49 -15 -68.5t-49 -19.5q-11 0 -21.5 1t-22.5 4v-452q0 -83 -39 -125.5t-117 -42.5q-76 0 -116.5 40.5t-40.5 125.5v504h88v-509q0 -78 68 -78q69 0 69 79v508zM317 749q-8 -31 -27.5 -45 t-45.5 -14q-17 0 -31.5 5t-28.5 11.5t-28.5 11.5t-30.5 5q-14 0 -23.5 -6t-16.5 -23l-39 23q9 31 28 45t45 14q16 0 31 -5t29 -11.5t28.5 -11.5t30.5 -5q14 0 24 6t16 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEF",
    unicode: "\u1EEF",
    horizAdvX: 444,
    d: "M29 0zM317 588q-8 -31 -27.5 -45t-45.5 -14q-17 0 -31.5 5t-28.5 11.5t-28.5 11.5t-30.5 5q-14 0 -23.5 -6t-16.5 -23l-39 23q9 31 28 45t45 14q16 0 31 -5t29 -11.5t28.5 -11.5t30.5 -5q14 0 24 6t16 23zM116 480v-342q0 -36 16 -52t45 -16t44.5 16t26.5 54v340h98 q20 0 29.5 8.5t9.5 33.5q0 8 -1.5 22t-3.5 24h49q5 -8 6.5 -23t1.5 -32q0 -48 -14.5 -68t-49.5 -20q-9 0 -19 1t-20 4v-430h-80l-3 69h-4q-15 -36 -40 -55.5t-63 -19.5q-33 0 -55 11.5t-35.5 31.5t-19 48.5t-5.5 61.5v333h87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF0",
    unicode: "\u1EF0",
    horizAdvX: 455,
    d: "M27 0zM252 664h102q22 0 31.5 9t9.5 33q0 8 -1 22t-4 24h49q5 -8 7 -23t2 -32q0 -49 -15 -68.5t-49 -19.5q-11 0 -21.5 1t-22.5 4v-452q0 -83 -39 -125.5t-117 -42.5q-76 0 -116.5 40.5t-40.5 125.5v504h88v-509q0 -78 68 -78q69 0 69 79v508zM139 -166v107h86v-107h-86z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF1",
    unicode: "\u1EF1",
    horizAdvX: 444,
    d: "M29 0zM116 480v-342q0 -36 16 -52t45 -16t44.5 16t26.5 54v340h98q20 0 29.5 8.5t9.5 33.5q0 8 -1.5 22t-3.5 24h49q5 -8 6.5 -23t1.5 -32q0 -48 -14.5 -68t-49.5 -20q-9 0 -19 1t-20 4v-430h-80l-3 69h-4q-15 -36 -40 -55.5t-63 -19.5q-33 0 -55 11.5t-35.5 31.5 t-19 48.5t-5.5 61.5v333h87zM140 -166v107h86v-107h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 369,
    d: "M10 0zM141 0v281l-131 383h87l88 -264h4l84 264h85l-127 -384v-280h-90zM69 823l46 52l149 -163l-34 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    d: "M29 0zM116 151q0 -38 16.5 -55t46.5 -17q29 0 45 17t26 59v325h83v-563q0 -150 -152 -150q-77 0 -113 37t-36 113v53h82v-53q0 -72 66 -72q67 0 67 72v149h-4q-16 -37 -41 -51.5t-61 -14.5q-63 0 -87.5 34.5t-24.5 91.5v354h87v-329zM68 650l46 52l149 -163l-34 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF6",
    unicode: "\u1EF6",
    horizAdvX: 369,
    d: "M10 0zM141 0v281l-131 383h87l88 -264h4l84 264h85l-127 -384v-280h-90zM163 690q0 21 9.5 32.5t20.5 20t20.5 16.5t9.5 23q0 12 -8 20t-25 8q-16 0 -28.5 -5.5t-26.5 -15.5l-15 47q15 14 37.5 20.5t40.5 6.5q32 0 53.5 -20t21.5 -53q0 -24 -10.5 -37.5t-23 -22.5 t-23 -17.5t-10.5 -22.5h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF7",
    unicode: "\u1EF7",
    d: "M29 0zM116 151q0 -38 16.5 -55t46.5 -17q29 0 45 17t26 59v325h83v-563q0 -150 -152 -150q-77 0 -113 37t-36 113v53h82v-53q0 -72 66 -72q67 0 67 72v149h-4q-16 -37 -41 -51.5t-61 -14.5q-63 0 -87.5 34.5t-24.5 91.5v354h87v-329zM157 517q0 21 9.5 32.5t20.5 20 t20.5 16.5t9.5 23q0 12 -8 20t-25 8q-16 0 -28.5 -5.5t-26.5 -15.5l-15 47q15 14 37.5 20.5t40.5 6.5q32 0 53.5 -20t21.5 -53q0 -24 -10.5 -37.5t-23 -22.5t-23 -17.5t-10.5 -22.5h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 252,
    d: "M22 265v75h208v-75h-208z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 358,
    d: "M22 265v75h314v-75h-314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 142,
    d: "M115 660q-20 -12 -29.5 -31.5t-9.5 -53.5v-28h39v-120h-88v138q0 63 22 99t66 48v-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 142,
    d: "M27 439q20 12 29.5 31.5t9.5 52.5v29h-39v120h88v-138q0 -65 -22 -100t-66 -47v52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 142,
    d: "M27 0zM27 -113q20 12 29.5 31.5t9.5 52.5v29h-39v120h88v-138q0 -65 -22 -100t-66 -47v52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 277,
    d: "M27 427zM115 660q-20 -12 -29.5 -31.5t-9.5 -53.5v-28h39v-120h-88v138q0 63 22 99t66 48v-52zM250 660q-20 -12 -29.5 -31.5t-9.5 -53.5v-28h39v-120h-88v138q0 63 22 99t66 48v-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 276,
    d: "M27 387zM27 439q20 12 29.5 31.5t9.5 52.5v29h-39v120h88v-138q0 -65 -22 -100t-66 -47v52zM161 439q20 12 29.5 31.5t9.5 52.5v29h-39v120h88v-138q0 -65 -22 -100t-66 -47v52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 276,
    d: "M27 0zM27 -113q20 12 29.5 31.5t9.5 52.5v29h-39v120h88v-138q0 -65 -22 -100t-66 -47v52zM161 -113q20 12 29.5 31.5t9.5 52.5v29h-39v120h88v-138q0 -65 -22 -100t-66 -47v52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 305,
    d: "M128 0v477h-101v51h101v136h54v-136h96v-51h-96v-477h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 303,
    d: "M127 0v135h-100v52h100v290h-100v51h100v136h55v-136h96v-51h-96v-290h96v-52h-96v-135h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 221,
    d: "M111 243q-35 0 -59.5 25.5t-24.5 63.5q0 40 24.5 65.5t59.5 25.5q34 0 58.5 -25.5t24.5 -65.5q0 -19 -6.5 -35.5t-18 -28.5t-26.5 -18.5t-32 -6.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 429,
    d: "M171 0v120h87v-120h-87zM315 0v120h87v-120h-87zM27 0v120h88v-120h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 545,
    d: "M7 0zM45 -19l225 702h55l-225 -702h-55zM367 102q0 -54 -20 -79.5t-58 -25.5q-80 0 -80 107v121q0 106 80 106q38 0 58 -26t20 -80v-123zM319 226q0 60 -31 60q-30 0 -30 -60v-124q0 -60 31 -60q30 0 30 60v124zM538 102q0 -54 -20 -79.5t-58 -25.5q-80 0 -80 107v121 q0 106 80 106q38 0 58 -26t20 -80v-123zM490 226q0 60 -31 60q-30 0 -30 -60v-124q0 -60 31 -60q30 0 30 60v124zM165 438q0 -54 -20 -79.5t-58 -25.5q-80 0 -80 107v121q0 106 80 106q38 0 58 -26t20 -80v-123zM117 562q0 60 -31 60q-30 0 -30 -60v-124q0 -60 31 -60 q30 0 30 60v124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 172,
    d: "M13 318l112 134l34 -37l-84 -97l84 -97l-34 -37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 172,
    d: "M13 221l84 98l-84 96l34 37l112 -133l-112 -135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 81,
    d: "M-98 -19l225 702h55l-225 -702h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zerosuperior",
    unicode: "\u2070",
    horizAdvX: 211,
    d: "M26 333zM184 438q0 -54 -20 -79.5t-58 -25.5q-80 0 -80 107v121q0 106 80 106q38 0 58 -26t20 -80v-123zM136 562q0 60 -31 60q-30 0 -30 -60v-124q0 -60 31 -60q30 0 30 60v124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "foursuperior",
    unicode: "\u2074",
    horizAdvX: 208,
    d: "M22 336zM115 594h-2l-56 -148h58v148zM115 336v68h-93v41l82 219h58v-218h24v-42h-24v-68h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fivesuperior",
    unicode: "\u2075",
    horizAdvX: 207,
    d: "M26 333zM181 416q0 -83 -78 -83q-14 0 -28 3.5t-25 12.5t-17.5 25t-6.5 40v6h47v-8q0 -19 8 -26.5t22 -7.5q30 0 30 35v59q0 18 -8 24t-19 6q-12 0 -19 -4.5t-12 -11.5h-48l8 178h136v-45h-94l-5 -93q8 8 19.5 13.5t28.5 5.5q26 0 43.5 -14.5t17.5 -53.5v-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixsuperior",
    unicode: "\u2076",
    horizAdvX: 207,
    d: "M26 333zM181 415q0 -82 -76 -82q-79 0 -79 83v166q0 85 79 85q36 0 56 -19.5t20 -56.5v-10h-46v8q0 32 -30 32t-30 -35v-69h2q16 29 51 29q24 0 38.5 -15t14.5 -43v-73zM135 476q0 15 -7.5 22t-18.5 7q-26 0 -34 -28v-65q0 -34 30 -34t30 34v64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sevensuperior",
    unicode: "\u2077",
    horizAdvX: 177,
    d: "M22 336zM47 336q1 31 8 70t16.5 78.5t20.5 75.5t21 60h-91v44h132v-40q-10 -27 -20.5 -63.5t-19 -75.5t-14 -78t-5.5 -71h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightsuperior",
    unicode: "\u2078",
    horizAdvX: 204,
    d: "M24 333zM103 621q-17 0 -23 -7.5t-6 -22.5v-32q0 -15 5.5 -23t23.5 -8q17 0 22 8.5t5 22.5v32q0 15 -5.5 22.5t-21.5 7.5zM102 333q-39 0 -58.5 21t-19.5 60v23q0 35 9 50t28 20v4q-32 8 -32 56v24q0 32 18 54t56 22t55.5 -22t17.5 -54v-24q0 -48 -32 -56v-4 q19 -5 28 -20t9 -50v-23q0 -39 -20.5 -60t-58.5 -21zM102 378q31 0 31 31v44q0 17 -6.5 25.5t-23.5 8.5q-31 0 -31 -34v-44q0 -17 6.5 -24t23.5 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ninesuperior",
    unicode: "\u2079",
    horizAdvX: 207,
    d: "M26 333zM26 577q0 45 17 67.5t60 22.5q46 0 62 -25.5t16 -73.5v-138q0 -46 -16.5 -71.5t-61.5 -25.5q-38 0 -57 21t-19 60v10h46v-12q0 -33 30 -33q18 0 24 12t6 35v64h-4q-16 -29 -50 -29q-23 0 -38 15t-15 43v58zM73 531q0 -29 25 -29q28 0 35 31v50q0 17 -7 28t-24 11 q-29 0 -29 -34v-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeroinferior",
    unicode: "\u2080",
    horizAdvX: 211,
    d: "M184 102q0 -54 -20 -79.5t-58 -25.5q-80 0 -80 107v121q0 106 80 106q38 0 58 -26t20 -80v-123zM136 226q0 60 -31 60q-30 0 -30 -60v-124q0 -60 31 -60q30 0 30 60v124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneinferior",
    unicode: "\u2081",
    horizAdvX: 139,
    d: "M65 0v250h-43v39q29 0 37.5 8.5t10.5 30.5h42v-328h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twoinferior",
    unicode: "\u2082",
    horizAdvX: 204,
    d: "M26 0v53q0 23 5.5 41t21.5 35q15 17 35 31.5t32 29.5q7 9 10.5 18.5t3.5 26.5v18q0 18 -6 25.5t-23 7.5q-18 0 -24 -8.5t-6 -28.5v-24h-47v21q0 21 2.5 37t11 26.5t23.5 16t40 5.5q46 0 60.5 -18.5t14.5 -58.5v-20q0 -21 -4.5 -37.5t-18.5 -30.5q-11 -13 -31.5 -29 t-33.5 -30q-11 -11 -14 -20.5t-3 -24.5v-19h105v-43h-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeinferior",
    unicode: "\u2083",
    horizAdvX: 204,
    d: "M181 78q0 -81 -77 -81q-78 0 -78 88v12h47v-14q0 -23 6.5 -32t23.5 -9q16 0 23 7.5t7 25.5v39q0 18 -7.5 27.5t-26.5 9.5h-21v41h23q19 0 24.5 9t5.5 26v24q0 18 -6 26t-22 8q-17 0 -23.5 -8.5t-6.5 -28.5v-14h-47v11q0 42 19.5 64t57.5 22t55.5 -22t17.5 -54v-24 q0 -48 -34 -57v-2q15 -4 27 -17t12 -44v-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fourinferior",
    unicode: "\u2084",
    horizAdvX: 208,
    d: "M115 258h-2l-56 -148h58v148zM115 0v68h-93v41l82 219h58v-218h24v-42h-24v-68h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveinferior",
    unicode: "\u2085",
    horizAdvX: 207,
    d: "M181 80q0 -83 -78 -83q-14 0 -28 3.5t-25 12.5t-17.5 25t-6.5 40v6h47v-8q0 -19 8 -26.5t22 -7.5q30 0 30 35v59q0 18 -8 24t-19 6q-12 0 -19 -4.5t-12 -11.5h-48l8 178h136v-45h-94l-5 -93q8 8 19.5 13.5t28.5 5.5q26 0 43.5 -14.5t17.5 -53.5v-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixinferior",
    unicode: "\u2086",
    horizAdvX: 207,
    d: "M181 79q0 -82 -76 -82q-79 0 -79 83v166q0 85 79 85q36 0 56 -19.5t20 -56.5v-10h-46v8q0 32 -30 32t-30 -35v-69h2q16 29 51 29q24 0 38.5 -15t14.5 -43v-73zM135 140q0 15 -7.5 22t-18.5 7q-26 0 -34 -28v-65q0 -34 30 -34t30 34v64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveninferior",
    unicode: "\u2087",
    horizAdvX: 177,
    d: "M47 0q1 31 8 70t16.5 78.5t20.5 75.5t21 60h-91v44h132v-40q-10 -27 -20.5 -63.5t-19 -75.5t-14 -78t-5.5 -71h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightinferior",
    unicode: "\u2088",
    horizAdvX: 204,
    d: "M103 285q-17 0 -23 -7.5t-6 -22.5v-32q0 -15 5.5 -23t23.5 -8q17 0 22 8.5t5 22.5v32q0 15 -5.5 22.5t-21.5 7.5zM102 -3q-39 0 -58.5 21t-19.5 60v23q0 35 9 50t28 20v4q-32 8 -32 56v24q0 32 18 54t56 22t55.5 -22t17.5 -54v-24q0 -48 -32 -56v-4q19 -5 28 -20t9 -50 v-23q0 -39 -20.5 -60t-58.5 -21zM102 42q31 0 31 31v44q0 17 -6.5 25.5t-23.5 8.5q-31 0 -31 -34v-44q0 -17 6.5 -24t23.5 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nineinferior",
    unicode: "\u2089",
    horizAdvX: 207,
    d: "M26 241q0 45 17 67.5t60 22.5q46 0 62 -25.5t16 -73.5v-138q0 -46 -16.5 -71.5t-61.5 -25.5q-38 0 -57 21t-19 60v10h46v-12q0 -33 30 -33q18 0 24 12t6 35v64h-4q-16 -29 -50 -29q-23 0 -38 15t-15 43v58zM73 195q0 -29 25 -29q28 0 35 31v50q0 17 -7 28t-24 11 q-29 0 -29 -34v-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A9",
    unicode: "\u20A9",
    horizAdvX: 542,
    d: "M103 0l-32 274h-62v44h57l-9 78h-48v44h43l-25 224h76l22 -224h74l26 224h93l25 -224h75l23 224h75l-26 -224h44v-44h-49l-9 -78h58v-44h-63l-31 -274h-100l-33 274h-73l-32 -274h-99zM357 318h49l8 78h-66zM137 318h48l9 78h-64zM239 318h63l-9 78h-45zM385 111l16 163 h-39l19 -163h4zM162 111l18 163h-38l16 -163h4zM253 440h35l-15 128h-4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20AA",
    unicode: "\u20AA",
    horizAdvX: 425,
    d: "M235 123v405q0 26 -10.5 37.5t-31.5 11.5h-107v-577h-59v664h188q40 0 59.5 -21.5t19.5 -79.5v-440h-59zM190 541v-405q0 -50 42 -50h107v578h58v-664h-187q-40 0 -59.5 21.5t-19.5 79.5v440h59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dong",
    unicode: "\u20AB",
    horizAdvX: 306,
    d: "M207 126l-2 44h-4q-11 -22 -32.5 -35t-54.5 -13q-36 0 -60.5 20t-24.5 65v196q0 45 24.5 64.5t59.5 19.5q32 0 53.5 -12t29.5 -29h4v127h-140v48h140v51h63v-51h28v-48h-28v-447h-56zM94 226q0 -25 13.5 -36.5t36.5 -11.5q22 0 35.5 10.5t21.5 35.5v161q-13 46 -58 46 q-22 0 -35.5 -10.5t-13.5 -32.5v-162zM21 0v49h242v-49h-242z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 345,
    d: "M331 81q-25 -45 -58 -66t-79 -21q-66 0 -102.5 43.5t-36.5 124.5v78h-33l8 56h25v84h-33l8 56h25v63q0 82 39.5 126.5t118.5 44.5q54 0 83 -24l-14 -86q-27 26 -64 26q-74 0 -74 -80v-70h120l-9 -56h-111v-84h97l-9 -56h-88v-84q0 -79 61 -79q26 0 44 15.5t30 42.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20AD",
    unicode: "\u20AD",
    horizAdvX: 413,
    d: "M242 328l141 -328h-93l-138 328h-7v-328h-91v328h-44v61h44v275h91v-275h6l141 275h92l-147 -275h154v-61h-149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20AE",
    unicode: "\u20AE",
    horizAdvX: 350,
    d: "M219 364v-108l95 53v-63l-95 -53v-193h-89v144l-94 -52v64l94 51v108l-94 -52v64l94 51v205h-111v81h313v-81h-113v-156l95 53v-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B1",
    unicode: "\u20B1",
    horizAdvX: 395,
    d: "M354 392q-2 -61 -30 -94.5t-96 -33.5h-95v-264h-89v392h-44v31h44v83h-44v32h44v126h184q67 0 95.5 -33t30.5 -93h41v-32h-41v-83h41v-31h-41zM133 423h137v83h-137v-83zM211 342q50 0 58 50h-136v-50h78zM133 538h136q-8 45 -58 45h-78v-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B2",
    unicode: "\u20B2",
    horizAdvX: 363,
    d: "M39 -19l20 63q-32 43 -32 118v337q0 81 39.5 126t114.5 45q42 0 74 -15l9 28h56l-20 -63q36 -45 36 -123v-38h-88l-33 -104h121v-355h-59l-4 51h-4q-13 -24 -35 -40.5t-65 -16.5q-35 0 -66 13l-8 -26h-56zM116 221h4l110 350q-17 15 -46 15q-35 0 -51.5 -21t-16.5 -59 v-285zM189 275l-57 -178q17 -20 49 -20q58 0 70 67v131h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B4",
    unicode: "\u20B4",
    horizAdvX: 375,
    d: "M141 249q-13 -14 -17.5 -28.5t-4.5 -37.5v-30q0 -40 19 -58t54 -18q41 0 59 21t18 62v39h84v-38q0 -82 -38 -124.5t-125 -42.5q-88 0 -126.5 41.5t-38.5 119.5v41q0 15 1 28.5t4 24.5h-23v44h44l131 98h-175v44h233q13 13 17.5 26t4.5 30v26q0 29 -17.5 49t-53.5 20 q-37 0 -53.5 -21.5t-16.5 -58.5v-38h-84v29q0 37 7.5 69t25.5 55t48 36t75 13q82 0 119.5 -41.5t37.5 -107.5v-29q0 -32 -9 -57h27v-44h-50l-122 -98h172v-44h-227z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B8",
    unicode: "\u20B8",
    horizAdvX: 315,
    d: "M124 0v437h-103v77h275v-77h-101v-437h-71zM21 589v75h275v-75h-275z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B9",
    unicode: "\u20B9",
    horizAdvX: 308,
    d: "M148 0l-80 280v52h35q65 0 65 69v36h-146v61h146v36q0 67 -65 67h-81v63h265v-63h-65v-4q25 -19 25 -63v-36h40v-61h-40v-36q0 -103 -92 -121l83 -280h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BA",
    unicode: "\u20BA",
    horizAdvX: 384,
    d: "M146 263v-182h67q68 0 68 77v70h84v-66q0 -83 -38.5 -122.5t-113.5 -39.5h-155v214l-39 -21v63l39 21v108l-39 -21v63l39 21v216h88v-167l151 84v-64l-151 -83v-108l151 84v-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BC",
    unicode: "\u20BC",
    horizAdvX: 518,
    d: "M302 664v-148h66q69 0 97.5 -35t28.5 -98v-383h-80v370q0 33 -13.5 50.5t-45.5 17.5h-53v-438h-86v438h-53q-32 0 -45.5 -17.5t-13.5 -50.5v-370h-80v383q0 63 28.5 98t97.5 35h66v148h86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BD",
    unicode: "\u20BD",
    horizAdvX: 395,
    d: "M154 115v-115h-89v115h-49v56h49v82h-49v56h49v355h184q69 0 97.5 -35t28.5 -98v-144q0 -64 -28.5 -99t-97.5 -35h-95v-82h172v-56h-172zM291 521q0 62 -59 62h-78v-274h78q31 0 45 18t14 51v143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BE",
    unicode: "\u20BE",
    horizAdvX: 419,
    d: "M168 397v184q-30 -7 -43 -23.5t-13 -44.5v-247q0 -65 26.5 -111t84.5 -77v-78h-206v78h113v4q-48 21 -75.5 65t-27.5 118v258q0 64 32 100.5t109 44.5v68h27v-67h48v67h26v-70q67 -11 97 -46.5t30 -96.5v-77h-71v67q0 52 -56 67v-183h-26v188h-48v-188h-27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "litre",
    unicode: "\u2113",
    horizAdvX: 293,
    d: "M201 1q-17 -7 -41 -7q-96 0 -109 111l-37 -10v69l36 7v375q0 124 108 124q112 0 112 -124v-127q0 -209 -160 -290q3 -73 60 -73q18 0 31 5v-60zM110 195q51 31 77 87.5t26 140.5v124q0 57 -53 57q-50 0 -50 -57v-352z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2116",
    unicode: "\u2116",
    horizAdvX: 629,
    d: "M263 0l-152 514h-4q3 -74 3 -140v-374h-79v664h118l139 -477h4q-3 94 -3 161v316h79v-664h-105zM604 422q0 -64 -22.5 -94.5t-73.5 -30.5q-52 0 -76 32t-24 95v118q0 63 24 95.5t76 32.5q51 0 73.5 -31t22.5 -96v-121zM543 544q0 34 -10 48t-27 14t-27 -14t-10 -48v-121 q0 -35 10 -49t27 -14t27 13.5t10 48.5v122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2117",
    unicode: "\u2117",
    horizAdvX: 353,
    d: "M342 160q0 -85 -40.5 -125.5t-115.5 -40.5q-78 0 -118.5 43.5t-40.5 124.5v337q0 81 41 126t116 45q76 0 117 -46t41 -127v-337zM304 497q0 65 -31 100t-88 35t-88.5 -35t-31.5 -98v-337q0 -63 30.5 -96.5t90.5 -33.5q57 0 87.5 31t30.5 97v337zM113 176v310h86 q59 0 59 -63v-56q0 -71 -59 -71h-47v-120h-39zM219 419q0 31 -29 31h-38v-121h38q29 0 29 34v56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 379,
    d: "M63 405v222h-42v37h125v-37h-43v-222h-40zM315 405v194h-4l-33 -194h-41l-32 194h-4v-194h-36v259h64l27 -184h4l29 184h63v-259h-37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onethird",
    unicode: "\u2153",
    horizAdvX: 398,
    d: "M22 0zM43 -19l225 702h55l-225 -702h-55zM65 336v250h-43v39q29 0 37.5 8.5t10.5 30.5h42v-328h-47zM381 78q0 -81 -77 -81q-78 0 -78 88v12h47v-14q0 -23 6.5 -32t23.5 -9q16 0 23 7.5t7 25.5v39q0 18 -7.5 27.5t-26.5 9.5h-21v41h23q19 0 24.5 9t5.5 26v24q0 18 -6 26 t-22 8q-17 0 -23.5 -8.5t-6.5 -28.5v-14h-47v11q0 42 19.5 64t57.5 22t55.5 -22t17.5 -54v-24q0 -48 -34 -57v-2q15 -4 27 -17t12 -44v-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twothirds",
    unicode: "\u2154",
    horizAdvX: 398,
    d: "M8 0zM67 -19l225 702h55l-225 -702h-55zM8 336v53q0 23 5.5 41t21.5 35q15 17 35 31.5t32 29.5q7 9 10.5 18.5t3.5 26.5v18q0 18 -6 25.5t-23 7.5q-18 0 -24 -8.5t-6 -28.5v-24h-47v21q0 21 2.5 37t11 26.5t23.5 16t40 5.5q46 0 60.5 -18.5t14.5 -58.5v-20 q0 -21 -4.5 -37.5t-18.5 -30.5q-11 -13 -31.5 -29t-33.5 -30q-11 -11 -14 -20.5t-3 -24.5v-19h105v-43h-154zM389 78q0 -81 -77 -81q-78 0 -78 88v12h47v-14q0 -23 6.5 -32t23.5 -9q16 0 23 7.5t7 25.5v39q0 18 -7.5 27.5t-26.5 9.5h-21v41h23q19 0 24.5 9t5.5 26v24 q0 18 -6 26t-22 8q-17 0 -23.5 -8.5t-6.5 -28.5v-14h-47v11q0 42 19.5 64t57.5 22t55.5 -22t17.5 -54v-24q0 -48 -34 -57v-2q15 -4 27 -17t12 -44v-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneeighth",
    unicode: "\u215B",
    horizAdvX: 398,
    d: "M30 0zM37 -19l225 702h55l-225 -702h-55zM73 336v250h-43v39q29 0 37.5 8.5t10.5 30.5h42v-328h-47zM292 285q-17 0 -23 -7.5t-6 -22.5v-32q0 -15 5.5 -23t23.5 -8q17 0 22 8.5t5 22.5v32q0 15 -5.5 22.5t-21.5 7.5zM291 -3q-39 0 -58.5 21t-19.5 60v23q0 35 9 50t28 20 v4q-32 8 -32 56v24q0 32 18 54t56 22t55.5 -22t17.5 -54v-24q0 -48 -32 -56v-4q19 -5 28 -20t9 -50v-23q0 -39 -20.5 -60t-58.5 -21zM291 42q31 0 31 31v44q0 17 -6.5 25.5t-23.5 8.5q-31 0 -31 -34v-44q0 -17 6.5 -24t23.5 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeeighths",
    unicode: "\u215C",
    horizAdvX: 398,
    d: "M11 0zM61 -19l225 702h55l-225 -702h-55zM308 285q-17 0 -23 -7.5t-6 -22.5v-32q0 -15 5.5 -23t23.5 -8q17 0 22 8.5t5 22.5v32q0 15 -5.5 22.5t-21.5 7.5zM307 -3q-39 0 -58.5 21t-19.5 60v23q0 35 9 50t28 20v4q-32 8 -32 56v24q0 32 18 54t56 22t55.5 -22t17.5 -54 v-24q0 -48 -32 -56v-4q19 -5 28 -20t9 -50v-23q0 -39 -20.5 -60t-58.5 -21zM307 42q31 0 31 31v44q0 17 -6.5 25.5t-23.5 8.5q-31 0 -31 -34v-44q0 -17 6.5 -24t23.5 -7zM166 414q0 -81 -77 -81q-78 0 -78 88v12h47v-14q0 -23 6.5 -32t23.5 -9q16 0 23 7.5t7 25.5v39 q0 18 -7.5 27.5t-26.5 9.5h-21v41h23q19 0 24.5 9t5.5 26v24q0 18 -6 26t-22 8q-17 0 -23.5 -8.5t-6.5 -28.5v-14h-47v11q0 42 19.5 64t57.5 22t55.5 -22t17.5 -54v-24q0 -48 -34 -57v-2q15 -4 27 -17t12 -44v-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveeighths",
    unicode: "\u215D",
    horizAdvX: 398,
    d: "M14 0zM61 -19l225 702h55l-225 -702h-55zM169 416q0 -83 -78 -83q-14 0 -28 3.5t-25 12.5t-17.5 25t-6.5 40v6h47v-8q0 -19 8 -26.5t22 -7.5q30 0 30 35v59q0 18 -8 24t-19 6q-12 0 -19 -4.5t-12 -11.5h-48l8 178h136v-45h-94l-5 -93q8 8 19.5 13.5t28.5 5.5 q26 0 43.5 -14.5t17.5 -53.5v-61zM306 285q-17 0 -23 -7.5t-6 -22.5v-32q0 -15 5.5 -23t23.5 -8q17 0 22 8.5t5 22.5v32q0 15 -5.5 22.5t-21.5 7.5zM305 -3q-39 0 -58.5 21t-19.5 60v23q0 35 9 50t28 20v4q-32 8 -32 56v24q0 32 18 54t56 22t55.5 -22t17.5 -54v-24 q0 -48 -32 -56v-4q19 -5 28 -20t9 -50v-23q0 -39 -20.5 -60t-58.5 -21zM305 42q31 0 31 31v44q0 17 -6.5 25.5t-23.5 8.5q-31 0 -31 -34v-44q0 -17 6.5 -24t23.5 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveneighths",
    unicode: "\u215E",
    horizAdvX: 398,
    d: "M31 0zM39 -19l225 702h55l-225 -702h-55zM289 285q-17 0 -23 -7.5t-6 -22.5v-32q0 -15 5.5 -23t23.5 -8q17 0 22 8.5t5 22.5v32q0 15 -5.5 22.5t-21.5 7.5zM288 -3q-39 0 -58.5 21t-19.5 60v23q0 35 9 50t28 20v4q-32 8 -32 56v24q0 32 18 54t56 22t55.5 -22t17.5 -54 v-24q0 -48 -32 -56v-4q19 -5 28 -20t9 -50v-23q0 -39 -20.5 -60t-58.5 -21zM288 42q31 0 31 31v44q0 17 -6.5 25.5t-23.5 8.5q-31 0 -31 -34v-44q0 -17 6.5 -24t23.5 -7zM56 336q1 31 8 70t16.5 78.5t20.5 75.5t21 60h-91v44h132v-40q-10 -27 -20.5 -63.5t-19 -75.5t-14 -78 t-5.5 -71h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 310,
    d: "M214 305q-11 36 -27.5 50.5t-39.5 14.5q-27 0 -39.5 -16.5t-12.5 -46.5v-182q0 -63 59 -63q60 0 60 67v176zM27 306q0 65 24.5 98.5t74.5 33.5q29 0 48 -11t35 -37h4v36q0 94 -21 135t-66 41q-14 0 -32.5 -6t-34.5 -20l-18 61q14 16 40 24.5t54 8.5q76 0 112 -62.5 t36 -195.5v-279q0 -66 -32.5 -102.5t-99.5 -36.5q-63 0 -93.5 32.5t-30.5 94.5v185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 303,
    d: "M208 -182v778h-113v-778h-68v846h249v-846h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 289,
    d: "M30 -182v63l100 360l-100 360v63h228v-68h-155l96 -355l-96 -355h155v-68h-228z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 344,
    d: "M27 299v68h289v-68h-289z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 318,
    d: "M103 0l-44 313h-46v68h95l36 -282h4l96 565h64l-120 -664h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 500,
    d: "M224 333q-31 65 -80 65q-59 0 -59 -63q0 -65 59 -65q49 0 80 63zM250 283q-43 -74 -116 -74q-53 0 -80 30.5t-27 95.5q0 127 107 127q73 0 116 -75q23 38 50.5 56.5t65.5 18.5q107 0 107 -127q0 -65 -27 -95.5t-80 -30.5q-38 0 -65.5 18t-50.5 56zM276 333q32 -63 80 -63 q60 0 60 65q0 63 -60 63q-48 0 -80 -65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 256,
    d: "M27 -233v68h30q37 0 37 46v684q0 99 98 99h39v-68h-29q-40 0 -40 -46v-684q0 -99 -96 -99h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 344,
    d: "M27 195zM236 204q-19 0 -35.5 4.5t-32 9.5t-31 9.5t-32.5 4.5q-42 0 -78 -37v73q13 13 31.5 22.5t47.5 9.5q19 0 36 -4.5t33 -9.5t31 -9.5t32 -4.5q21 0 41 8.5t37 27.5v-73q-33 -31 -80 -31zM236 367q-19 0 -35.5 4.5t-32 9.5t-31 9.5t-32.5 4.5q-42 0 -78 -37v73 q13 13 31.5 22.5t47.5 9.5q19 0 36 -4.5t33 -9.5t31 -9.5t32 -4.5q21 0 41 8.5t37 27.5v-73q-33 -31 -80 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 344,
    d: "M23 -20l76 224h-72v68h96l42 122h-138v68h161l76 222h56l-76 -222h72v-68h-95l-42 -122h137v-68h-161l-76 -224h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    horizAdvX: 344,
    d: "M27 25zM27 296v73l289 144v-77l-214 -102v-4l214 -101v-75zM27 25v68h289v-68h-289z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    horizAdvX: 344,
    d: "M27 25zM27 25v68h289v-68h-289zM27 154v75l215 101v4l-215 102v77l289 -144v-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotmath",
    unicode: "\u22C5",
    horizAdvX: 141,
    d: "M27 273zM27 273v120h88v-120h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 339,
    d: "M136 0l-109 332l109 332h71l104 -332l-105 -332h-70zM175 551h-8l-70 -219l69 -215h10l68 215z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE000",
    unicode: "\uE000",
    horizAdvX: 363,
    d: "M551 -83q0 -76 -36 -113t-113 -37q-151 0 -151 150v134h-4q-12 -25 -33 -41t-62 -16q-55 0 -90 34.5t-35 115.5v355q0 81 39.5 126t114.5 45q76 0 115.5 -46t39.5 -127v-38h-85v46q0 39 -17 60t-51 21q-67 0 -67 -80v-350q0 -79 65 -79q58 0 70 67v131h-75v80h160v-438 q0 -72 67 -72q66 0 66 72v56h82v-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE001",
    unicode: "\uE001",
    d: "M248 -233v293h-4q-14 -35 -39 -50.5t-63 -15.5q-62 0 -87.5 41t-25.5 114v209q0 63 30.5 95.5t84.5 32.5q39 0 64 -18t41 -57h4l3 69h77v-713h-85zM116 142q0 -38 16 -55t47 -17q29 0 44.5 16.5t26.5 55.5v196q-11 39 -26.5 55.5t-44.5 16.5q-31 0 -47 -17t-16 -55v-196z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE002",
    unicode: "\uE002",
    horizAdvX: 332,
    d: "M132 298l86 -87l-44 -45l-167 164l167 166l44 -44l-86 -86h181v-68h-181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE003",
    unicode: "\uE003",
    horizAdvX: 332,
    d: "M191 365l-86 87l43 45l167 -164l-167 -166l-43 44l86 86h-182v68h182z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE004",
    unicode: "\uE004",
    horizAdvX: 628,
    d: "M511 -105q0 -65 -34 -96.5t-98 -31.5q-128 0 -128 128v156h-4q-12 -25 -33 -41t-62 -16q-55 0 -90 34.5t-35 115.5v355q0 81 39.5 126t114.5 45q76 0 115.5 -46t39.5 -127v-38h-85v46q0 39 -17 60t-51 21q-67 0 -67 -80v-350q0 -39 17 -59t48 -20q29 0 49.5 18t20.5 49 v131h-75v80h160v-461q0 -49 43 -49t43 49v79h89v-78zM422 0v583h-84v81h279v-81h-106v-583h-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE005",
    unicode: "\uE005",
    horizAdvX: 369,
    d: "M27 0v82h28q30 0 41.5 9t19.5 36l33 107l-139 430h87l90 -301h4l82 301h85l-163 -553q-9 -31 -19 -52t-25.5 -34t-38.5 -19t-57 -6h-28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE006",
    unicode: "\uE006",
    horizAdvX: 286,
    d: "M269 403h-114v-271q0 -55 53 -55h51v-77h-51q-139 0 -139 132v271h-52v77h52v130h86v-130h114v-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "psi",
    horizAdvX: 507,
    d: "M213 -233v233h-85q-45 0 -72 30.5t-27 82.5v367h80v-350q0 -28 12.5 -43t34.5 -15h57v600h81v-600h56q23 0 35.5 15t12.5 43v350h80v-367q0 -52 -27 -82.5t-72 -30.5h-85v-233h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflexhook",
    horizAdvX: 0,
    d: "M-91 504l-94 107l-94 -107l-38 30l92 128h79l93 -128zM-71 610q0 21 9.5 32.5t20.5 20t20.5 16.5t9.5 23q0 12 -7.5 20t-25.5 8q-15 0 -28 -5.5t-26 -15.5l-15 47q15 14 37.5 20.5t39.5 6.5q33 0 54 -20t21 -53q0 -24 -10.5 -37.5t-23 -22.5t-23 -17.5t-10.5 -22.5h-43z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breveacute",
    horizAdvX: 0,
    d: "M-183 501q-60 0 -97 35t-37 110h63q2 -50 19.5 -73t51.5 -23q35 0 52 23t19 73h64q0 -76 -37.5 -110.5t-97.5 -34.5zM-204 603l-33 34l133 146l46 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brevetilde",
    horizAdvX: 0,
    d: "M-182 501q-60 0 -97 35t-37 110h63q1 -50 18.5 -73t52.5 -23q34 0 51.5 23t19.5 73h64q0 -76 -37.5 -110.5t-97.5 -34.5zM-46 733q-9 -31 -28 -45t-45 -14q-17 0 -31.5 5t-29 11.5t-28.5 11.5t-30 5q-14 0 -24 -6t-16 -23l-39 23q8 31 27.5 45t44.5 14q17 0 31.5 -5 t29 -11.5t29 -11.5t30.5 -5q14 0 23.5 6t16.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brevehook",
    horizAdvX: 0,
    d: "M-182 501q-60 0 -97 35t-37 110h63q1 -50 18.5 -73t52.5 -23q34 0 51.5 23t19.5 73h64q0 -76 -37.5 -110.5t-97.5 -34.5zM-215 616q0 20 9.5 31t20.5 19.5t20.5 16.5t9.5 22q0 11 -7.5 19t-25.5 8q-28 0 -54 -20l-15 45q15 13 37.5 19.5t40.5 6.5q32 0 53 -19.5t21 -51.5 q0 -23 -10.5 -35.5t-22.5 -21.5t-22.5 -17.5t-10.5 -21.5h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflexacute",
    horizAdvX: 0,
    d: "M-87 504l-94 107l-94 -107l-38 30l92 128h79l93 -128zM-69 614l-33 34l123 135l45 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gravecircumflex",
    horizAdvX: 0,
    d: "M-87 504l-94 107l-94 -107l-38 30l92 128h79l93 -128zM-152 732l46 51l123 -135l-33 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brevegrave",
    horizAdvX: 0,
    d: "M-181 501q-60 0 -97.5 34.5t-37.5 110.5h64q2 -50 19 -73t52 -23q34 0 51.5 23t19.5 73h63q0 -75 -37 -110t-97 -35zM-305 732l46 51l133 -146l-33 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "carontilde",
    horizAdvX: 0,
    d: "M-87 504l-94 107l-94 -107l-38 30l92 128h79l93 -128zM-43 748q-9 -32 -28 -46t-45 -14q-17 0 -31.5 5.5t-29 11.5t-28.5 11.5t-30 5.5q-14 0 -24 -6t-16 -24l-39 23q8 31 27.5 45.5t44.5 14.5q17 0 31.5 -5.5t29 -11.5t29 -11.5t30.5 -5.5q14 0 23.5 6t16.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".ttfautohint",
    horizAdvX: 0,
    d: "M0 0z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "J",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "4",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EF6",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EF2",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EB6",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EB4",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EB2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EB0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EAE",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EAC",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EAA",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EA8",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EA6",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EA4",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EA2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EA0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E92",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E85",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E84",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E83",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E82",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E81",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E80",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E6C",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u04B2",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u04A0",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0496",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u042A",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0416",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u040B",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0402",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u03B3",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u039B",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0394",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u017D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u017B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0179",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0178",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0176",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0175",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0174",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0164",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0162",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0104",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0102",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0100",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xDD",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xC6",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xC5",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xC4",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xC2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xC1",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "w",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "Z",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "Y",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "X",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "W",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "T",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "A",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "V",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "J",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "4",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0237",
    k: -176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "j",
    k: -176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u012F",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0427",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u03C0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "f",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "V",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "J",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "9",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "8",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\uE005",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u042F",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0427",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "f",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "J",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "7",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "4",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "3",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "1",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "/",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "&",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0427",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u03C0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "f",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "V",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "J",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "9",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "8",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "psi",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\uE004",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\uE001",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\uE000",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u2014",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u2013",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EF7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EF3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EF1",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EEF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EED",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EEB",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE9",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE5",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE3",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE1",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDF",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDE",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDD",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDB",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDA",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED9",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED7",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED5",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED4",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED3",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED1",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ECF",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ECE",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ECD",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ECC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EC7",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EC5",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EC3",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EC1",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EBF",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EBD",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EBB",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB9",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB7",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB6",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB5",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB4",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB3",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB2",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB1",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB0",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAF",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAE",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAD",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAC",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAB",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAA",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA9",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA8",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA7",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA6",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA5",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA4",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA3",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA2",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA1",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA0",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E93",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E85",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E83",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E81",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E63",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E62",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E5B",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E4B",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E45",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E13",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E0D",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0512",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04EF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04E9",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04E8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04C8",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04C4",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04B3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04AB",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04AA",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04A3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04A1",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u049B",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0498",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0497",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0491",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u045F",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u045E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u045D",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u045C",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u045A",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0454",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0453",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044E",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044C",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044B",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044A",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0449",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0448",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0446",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0442",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u043F",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u043D",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u043C",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0439",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0438",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0436",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0433",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0432",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u042D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u041B",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0414",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0409",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0404",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03CD",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03CC",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C6",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C5",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C4",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C3",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C2",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03BA",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03B7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03B5",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03B3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03B1",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03AE",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03AD",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03AC",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u039B",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0398",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0394",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0272",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01F9",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01F5",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01F4",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01E7",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01E6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01DD",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01B0",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01A1",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01A0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u018F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u017E",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u017C",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u017A",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0177",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0175",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0173",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0171",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u016F",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u016D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u016B",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0169",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0161",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0160",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u015F",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u015E",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u015B",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u015A",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0159",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0157",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0155",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0153",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0152",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0151",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0150",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u014F",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u014E",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u014D",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u014C",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u014B",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0148",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0146",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0144",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0123",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0122",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0121",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0120",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u011F",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u011E",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u011B",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0119",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0117",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0115",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0113",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0111",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010F",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010D",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010C",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010B",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010A",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0107",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0106",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0105",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0104",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0103",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0102",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0101",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0100",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xFD",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xFC",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xFB",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xFA",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF9",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF8",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF6",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF5",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF4",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF3",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF2",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF0",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xEB",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xEA",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE9",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE8",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE7",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE6",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE5",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE4",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE3",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE2",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE1",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE0",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD5",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD4",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC7",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC6",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC5",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC4",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC2",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC1",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "z",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "y",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "w",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "v",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "u",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "s",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "r",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "q",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "p",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "o",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "n",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "m",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "g",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "e",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "d",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "c",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "a",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "S",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "Q",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "O",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "G",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "C",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "A",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "-",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u042F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "f",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "J",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "&",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\u2026",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\u201E",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\u201A",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: ".",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: ",",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\u2014",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\u2013",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "-",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "7",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "4",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u2026",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u201E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u201A",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EB6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EB4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EB2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EB0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EAE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EAC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EAA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EA8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EA6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EA4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EA2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EA0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1E6C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0513",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u04B2",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u04A0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0496",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0459",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u043B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0434",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u042A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0416",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u040B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u039B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0394",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0164",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0162",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0104",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0102",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0100",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xC6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xC5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xC4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xC2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xC1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "X",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "T",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: ".",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: ",",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "7",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2026",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u201E",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u201D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u201C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u201A",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2019",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2018",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2014",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2013",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: ".",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "-",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: ",",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "'",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\"",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "9",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "5",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u2026",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u201E",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u201D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u201C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u201A",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u2018",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: ".",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: ",",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "'",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\"",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "5",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\u2026",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\u201E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\u201A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: ".",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: ",",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "7",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2026",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u201E",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u201A",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2014",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2013",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ".",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "-",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ",",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "1",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u2026",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u201E",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u201A",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: ".",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: ",",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "3",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\u2026",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\u201E",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\u201A",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: ".",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: ",",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u0237",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "j",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0427",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u03C7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u03C0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u03A8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u03A6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "f",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "?",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "&",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0427",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u03BB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u03A6",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "/",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "psi",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\uE001",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2026",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u201E",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u201A",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2014",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2013",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EF7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EF3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EF1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EEF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EED",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EEB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EDF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EDD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EDB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ECF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ECD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EC7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EC5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EC3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EC1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EBF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EBD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EBB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB7",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB6",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB4",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB2",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB0",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAF",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAE",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAD",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAC",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAA",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA8",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA7",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA6",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA4",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA2",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA0",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E93",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E85",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E83",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E81",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E63",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E5B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E4B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E45",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E13",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E0D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04EF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04E9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04C8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04C4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04B3",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04AB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04A3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u049B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0497",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0491",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u045F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u045E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u045D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u045C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u045A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0454",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0453",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u044E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u044C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u044B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0449",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0448",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0446",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u043F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u043D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u043C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0439",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0438",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0436",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0433",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0432",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03CD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03CC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03C6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03C5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03C3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03C2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03BA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03B7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03B5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03B3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03B1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03AE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03AD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03AC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u039B",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0394",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0272",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01F9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01F5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01E7",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01DD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01B0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01A1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u017E",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u017C",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u017A",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0177",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0175",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0173",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0171",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u016F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u016D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u016B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0169",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0161",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u015F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u015B",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0159",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0157",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0155",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0153",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0151",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0148",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0146",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0144",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0123",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0121",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u011F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u011B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0119",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0117",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0115",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0113",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0111",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0107",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0105",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0104",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0103",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0102",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0101",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0100",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE4",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC6",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC5",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC4",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC2",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC1",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "z",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "x",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "w",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "v",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "u",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "s",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "r",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "p",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "o",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "n",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "m",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "g",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "e",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "d",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "c",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "a",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "A",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "-",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "f",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "J",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "/",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "&",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u03A6",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "f",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "J",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "&",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "V",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "J",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "?",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "&",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\uE001",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2026",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u201E",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u201A",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2014",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2013",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EF6",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EF2",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EE3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EE1",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EDF",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EDD",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EDB",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1ED9",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1ED7",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1ED5",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1ED3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1ED1",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1ECF",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1ECD",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EC7",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EC5",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EC3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EC1",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EBF",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EBD",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EBB",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB9",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB6",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB5",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB4",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB3",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB2",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB0",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAF",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAE",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAD",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAC",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAA",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA9",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA8",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA6",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA5",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA4",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA3",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA2",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA0",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E92",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E84",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E82",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E80",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E6C",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E63",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E62",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E5B",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E4B",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E45",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E13",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E0D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0513",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0512",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u04E9",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u04C8",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u04C4",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u04B2",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u04AB",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u04A3",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u04A0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u049B",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0496",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0491",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u045F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u045D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u045C",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u045A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0459",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0454",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0453",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u044E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u044C",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u044B",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0449",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0448",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0446",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u043F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u043D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u043C",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u043B",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0439",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0438",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0434",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0433",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0432",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u042A",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u041B",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0416",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0414",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u040B",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0409",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0402",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03CE",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03CC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03C9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03C6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03C3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03C2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03BA",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03B7",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03B5",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03B1",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03AE",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03AD",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03AC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u039B",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0394",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0272",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0237",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01F9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01F5",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01E7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01DD",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01A1",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u017D",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u017B",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0179",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0178",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0176",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0174",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0164",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0162",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0161",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0160",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u015F",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u015E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u015B",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u015A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0159",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0157",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0155",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0153",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0151",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u014F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u014D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u014B",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0148",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0146",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0144",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0123",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0121",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u011F",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u011B",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0119",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0117",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0115",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0113",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0111",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u010F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u010D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u010B",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0107",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0105",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0104",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0103",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0102",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0101",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0100",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF5",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF4",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xEB",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xEA",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE9",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE7",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE6",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE5",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE4",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE3",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE2",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xDD",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC6",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC5",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC4",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC2",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC1",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "s",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "r",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "q",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "p",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "o",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "n",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "m",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "j",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "g",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "e",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "d",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "c",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "a",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "Z",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "Y",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "W",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "T",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "S",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "A",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ".",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "-",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ",",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\uE005",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03C1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03BB",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03B6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "J",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "/",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "&",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "V",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\uE005",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u0427",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "f",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "V",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "?",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "/",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u042F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u03C7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u03C1",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u03BB",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u03B8",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u03B6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u03A9",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u03A6",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "f",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "J",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "?",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "/",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "psi",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\uE004",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\uE003",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\uE002",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\uE001",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\uE000",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u203A",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2039",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2026",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201E",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201A",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2014",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2013",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EF7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EF3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EF1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EEF",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EED",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EEB",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE9",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE5",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE3",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE1",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDF",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDE",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDD",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDA",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED9",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED7",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED5",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED4",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED3",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED1",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ECF",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ECE",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ECD",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ECC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EC7",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EC5",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EC3",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EC1",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EBF",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EBD",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EBB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB9",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB7",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB6",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB5",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB4",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB3",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB2",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB1",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB0",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAE",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAD",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAC",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAB",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAA",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA9",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA8",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA7",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA6",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA5",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA4",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA3",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA2",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA1",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA0",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E93",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E85",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E83",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E81",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E63",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E62",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E5B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E4B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E45",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E13",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E0D",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04EF",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04E9",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04E8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04C8",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04C4",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04B3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04AB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04AA",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04A3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u049B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0497",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0491",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u045F",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u045E",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u045D",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u045C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u045A",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0454",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0453",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u044E",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u044C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u044B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0449",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0448",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0446",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u043F",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u043D",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u043C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0439",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0438",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0436",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0433",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0432",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0404",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03CD",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03CC",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03C6",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03C5",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03C3",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03C2",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03BA",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03B7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03B5",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03B3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03B1",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03AE",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03AD",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03AC",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u039B",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0398",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0394",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0272",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01F9",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01F5",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01F4",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01E7",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01E6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01DD",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01B0",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01A1",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01A0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u018F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u017E",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u017C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u017A",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0177",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0175",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0173",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0171",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016F",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016D",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0169",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0161",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0160",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015F",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015E",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015B",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015A",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0159",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0157",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0155",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0153",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0152",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0151",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0150",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014F",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014E",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014D",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014C",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0148",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0146",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0144",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0123",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0122",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0121",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0120",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011F",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011E",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011B",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0119",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0117",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0115",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0113",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0111",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010F",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010D",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010C",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010B",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010A",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0107",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0106",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0105",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0104",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0103",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0102",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0101",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0100",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFD",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFB",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFA",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF9",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF8",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF6",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF5",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF4",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF3",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF2",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF0",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEA",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE9",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE8",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE7",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE5",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE4",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE3",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE1",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE0",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD5",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD4",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC7",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC6",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC5",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC4",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC2",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC1",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xBB",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xAB",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "z",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "y",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "u",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "s",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "r",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "q",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "p",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "o",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "n",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "m",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "g",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "e",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "d",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "c",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "a",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "S",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "Q",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "O",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "G",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "C",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "A",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ".",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "-",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ",",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "J",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "?",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "/",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "&",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "f",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "J",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "?",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "/",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "&",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0427",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u03C7",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u03B8",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u03B6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u03A8",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u03A6",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "3",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "&",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u042F",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03C7",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03C1",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03BB",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03B8",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03B6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03A9",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "J",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "?",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "/",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "&",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u03C7",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "?",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "&",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0237",
    k: -176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "j",
    k: -176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u012F",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u03C7",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "?",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "f",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "\u0237",
    k: -151
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "j",
    k: -151
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "\u012F",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "?",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\u0237",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "j",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u012F",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "l",
    u2: "\u0237",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "l",
    u2: "j",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0237",
    k: -209
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "j",
    k: -209
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "/",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "f",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "?",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "/",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "&",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\u03BB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "f",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "/",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u03C1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u03BB",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "/",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u03C1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u03BB",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "/",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "&",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u0237",
    k: -154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "j",
    k: -154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u012F",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u0237",
    k: -176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "j",
    k: -176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u012F",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "V",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u042F",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0427",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "f",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "J",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0427",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u03C7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u03C0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u03A8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u03A6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "f",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "?",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "&",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0427",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u03C7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u03C0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u03A8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u03A6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "f",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "?",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "&",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0427",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u03C7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u03C0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u03A8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u03A6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "f",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "?",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "&",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0427",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u03C7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u03C0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u03A8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u03A6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "f",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "?",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "&",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u042F",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03C7",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03C1",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03BB",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03B8",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03B6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03A9",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "J",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "?",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "/",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "&",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "\u03C7",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "?",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u0427",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u03C7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u03C0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u03A8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u03A6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "f",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "?",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "&",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0101",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0101",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u0427",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u03C7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u03C0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u03A8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u03A6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "f",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "?",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "&",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0103",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0103",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0427",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u03C7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u03C0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u03A8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u03A6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "f",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "?",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "&",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "\u0237",
    k: -148
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "j",
    k: -148
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0107",
    u2: "\u03C7",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0107",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0107",
    u2: "?",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010B",
    u2: "\u03C7",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010B",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010B",
    u2: "?",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010D",
    u2: "\u03C7",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010D",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010D",
    u2: "?",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0127",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0127",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012F",
    u2: "\u0237",
    k: -142
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012F",
    u2: "j",
    k: -142
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "\u012F",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\u03A6",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "f",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "J",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "&",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "V",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "J",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "?",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "&",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "V",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "J",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "?",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "&",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013C",
    u2: "\u0237",
    k: -168
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013C",
    u2: "j",
    k: -168
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "\u0142",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0146",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0146",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0148",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0148",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014B",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014B",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "V",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "/",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "V",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: "/",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "V",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "/",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "\uE005",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "\u0427",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "f",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "V",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "?",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "/",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "f",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "?",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "/",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "&",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "\uE005",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "\u0427",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "f",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "V",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "?",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "/",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "f",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "?",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "/",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "&",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "\uE005",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "\u0427",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "f",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "V",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "?",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "/",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "f",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "?",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "/",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "&",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u042F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u03C7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u03C1",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u03BB",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u03B8",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u03B6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u03A9",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u03A6",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "f",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "J",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "?",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "/",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "\u03BB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "f",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "/",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u042F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u03C7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u03C1",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u03BB",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u03B8",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u03B6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u03A9",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u03A6",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "f",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "J",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "?",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "/",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0167",
    u2: "\u03BB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0167",
    u2: "f",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0167",
    u2: "/",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0173",
    u2: "\u0237",
    k: -147
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0173",
    u2: "j",
    k: -147
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "f",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "J",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "?",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "/",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "&",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: "\u03C1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: "\u03BB",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: "/",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u042F",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03C7",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03C1",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03BB",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03B8",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03B6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03A9",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "J",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "?",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "/",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "&",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u042F",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03C7",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03C1",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03BB",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03B8",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03B6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03A9",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "J",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "?",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "/",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "&",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\u03C7",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "?",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "&",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\u03C7",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "?",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "&",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\u03C7",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "?",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "&",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01E6",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F4",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F9",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F9",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0237",
    u2: "\u012F",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u024C",
    u2: "V",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0272",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0272",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\u0427",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\u03C7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\u03C0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\u03A8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\u03A6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "f",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "?",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "&",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038C",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038C",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038C",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038C",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u042F",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03C7",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03C1",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03BB",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03B8",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03B6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03A9",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "J",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "?",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "/",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "&",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EB6",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EB4",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EB2",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EB0",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EAE",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EAC",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EAA",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EA8",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EA6",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EA4",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EA2",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EA0",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0513",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0512",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0459",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u043B",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0434",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u041B",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0414",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0409",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u03CA",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u03B9",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u03AF",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u039B",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0394",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0104",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0102",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0100",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\xC6",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\xC5",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\xC4",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\xC2",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\xC1",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "A",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u03A6",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u0427",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u03C7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u03C0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u03A8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u03A6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "f",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "?",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "&",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0398",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0398",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0398",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0398",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\u0427",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\u03C7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\u03C0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\u03A8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\u03A6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "f",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "?",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "&",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EB6",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EB4",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EB2",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EB0",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EAE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EAC",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EAA",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EA8",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EA6",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EA4",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EA2",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EA0",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1E6C",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0513",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0512",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u04B2",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u04A0",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0496",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0459",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u043B",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0434",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u042A",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u041B",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0416",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0414",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u040B",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0409",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0402",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u039B",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0394",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0164",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0162",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0104",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0102",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0100",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\xC6",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\xC5",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\xC4",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\xC2",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\xC1",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "X",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "T",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "A",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "3",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\uE001",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EE3",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EE1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EDF",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EDD",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EDB",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1ED9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1ED7",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1ED5",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1ED3",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1ED1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1ECF",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1ECD",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EC7",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EC5",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EC3",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EC1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EBF",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EBD",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EBB",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EB9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EB6",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EB4",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EB2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EB0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EAE",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EAC",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EAA",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EA8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EA6",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EA4",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EA2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EA0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1E13",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1E0D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u04E9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u04B2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u04AB",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0496",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0454",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0416",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03CE",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03CC",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03C9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03C6",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03C3",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03C2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03B5",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03B1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03AD",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03AC",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u039B",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0394",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u01DD",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u01A1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0153",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0151",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u014F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u014D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u011B",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0119",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0117",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0115",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0113",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0111",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u010F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u010D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u010B",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0107",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0104",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0102",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0100",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xF8",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xF6",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xF5",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xF4",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xF3",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xF2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xF0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xEB",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xEA",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xE9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xE8",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xE7",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xC6",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xC5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xC4",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xC2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xC1",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "q",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "o",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "e",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "d",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "c",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "A",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03C1",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03BB",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AC",
    u2: "\u03C7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AD",
    u2: "\u03C7",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AD",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AD",
    u2: "?",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AF",
    u2: "\u03C7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B1",
    u2: "\u03C7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B3",
    u2: "\u03C1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B3",
    u2: "\u03BB",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B3",
    u2: "/",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B5",
    u2: "\u03C7",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B5",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B5",
    u2: "?",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    g2: "psi",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\uE001",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EF1",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EEF",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EED",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EEB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EE9",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EE7",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EE5",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EE3",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EE1",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EDF",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EDD",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EDB",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ED9",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ED7",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ED5",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ED3",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ED1",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ECF",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ECD",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EC7",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EC5",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EC3",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EC1",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EBF",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EBD",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EBB",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EB9",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E5B",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E4B",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E45",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E13",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E0D",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u04E9",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u04C8",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u04C4",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u04AB",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u04A3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u04A1",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u049B",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0491",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u045F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u045D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u045C",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u045A",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0454",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0453",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u044E",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u044C",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u044B",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u044A",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0449",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0448",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0446",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0442",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u043F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u043D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u043C",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0439",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0438",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0433",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0432",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03CE",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03CD",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03CC",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03CA",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C9",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C6",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C5",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C4",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C3",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C2",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03BA",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03B9",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03B7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03B5",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03B1",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03AF",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03AE",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03AD",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03AC",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0272",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u01F9",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u01DD",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u01B0",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u01A1",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0173",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0171",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u016F",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u016D",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u016B",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0169",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0159",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0157",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0155",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0153",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0151",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u014F",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u014D",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u014B",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0148",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0146",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0144",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u011B",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0119",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0117",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0115",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0113",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0111",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u010F",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u010D",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u010B",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0107",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xFC",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xFB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xFA",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF9",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF8",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF6",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF5",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF4",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF3",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF2",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF1",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF0",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xEB",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xEA",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xE9",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xE8",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xE7",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "u",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "r",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "q",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "p",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "o",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "n",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "m",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "e",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "d",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "c",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03B8",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B7",
    u2: "\u1E6C",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B7",
    u2: "\u04A0",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B7",
    u2: "\u042A",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B7",
    u2: "\u040B",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B7",
    u2: "\u0402",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B7",
    u2: "\u0164",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B7",
    u2: "\u0162",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B7",
    u2: "T",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B9",
    u2: "\u03C7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    g2: "psi",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\uE001",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u201D",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u201C",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u2019",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u2018",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EF1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EEF",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EED",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EEB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EE9",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EE7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EE5",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EE3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EE1",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EDD",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EDB",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ED9",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ED7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ED5",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ED3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ED1",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ECF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ECD",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EC7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EC5",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EC3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EC1",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EBF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EBD",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EBB",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EB9",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1E85",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1E83",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1E81",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1E13",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1E0D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u04E9",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u04AB",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u04A1",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0454",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u044A",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0442",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03CE",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03CD",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03CC",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C9",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C5",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C4",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C2",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03B5",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03B3",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03B1",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03AD",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03AC",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u01DD",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u01B0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u01A1",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0175",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0173",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0171",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u016F",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u016D",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u016B",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0169",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0153",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0151",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u014F",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u014D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u011B",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0119",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0117",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0115",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0113",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0111",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u010F",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u010D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u010B",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0107",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xFC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xFB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xFA",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF9",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF8",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF5",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF4",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF2",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF0",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xEB",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xEA",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xE9",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xE8",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xE7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "w",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "v",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "u",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "q",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "o",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "e",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "d",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "c",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "'",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\"",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C7",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\uE001",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EE3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EE1",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EDF",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EDD",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EDB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1ED9",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1ED7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1ED5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1ED3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1ED1",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1ECF",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1ECD",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EC7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EC5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EC3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EC1",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EBF",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EBD",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EBB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EB9",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1E13",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1E0D",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u04E9",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u04AB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u0454",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u03CC",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u03C6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u03C3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u03C2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u03B5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u03B1",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u03AD",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u03AC",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u01DD",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u01A1",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u0153",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u0151",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u014F",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u014D",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u011B",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u0119",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u0117",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u0115",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u0113",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u0111",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u010F",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u010D",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u010B",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u0107",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xF8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xF6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xF5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xF4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xF3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xF2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xF0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xEB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xEA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xE9",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xE8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xE7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "o",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "e",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "d",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "c",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    g2: "psi",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\uE001",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u2026",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u201E",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u201A",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EF1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EEF",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EED",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EEB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EE9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EE7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EE5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EE3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EE1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EDF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EDD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EDB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1ED9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1ED7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1ED5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1ED3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1ED1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1ECF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1ECD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EC7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EC5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EC3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EC1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EBF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EBD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EBB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EB9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1E85",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1E83",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1E81",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1E13",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1E0D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u04E9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u04AB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u04A1",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0454",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u044A",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0442",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03CE",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03CD",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03CC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03CA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03C9",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03C6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03C5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03C4",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03C3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03C2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03B5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03B3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03B1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03AD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03AC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u01DD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u01B0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u01A1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0175",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0173",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0171",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u016F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u016D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u016B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0169",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0153",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0151",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u014F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u014D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u011B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0119",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0117",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0115",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0113",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0111",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u010F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u010D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u010B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0107",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xFC",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xFB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xFA",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xF9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xF8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xF6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xF5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xF4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xF3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xF2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xF0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xEB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xEA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xE9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xE8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xE7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "u",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "o",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "e",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "d",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: ".",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: ",",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03B6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\uE001",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EE3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EE1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EDF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EDD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EDB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ED9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ED7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ED5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ED3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ED1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ECF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ECD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EC7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EC5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EC3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EC1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EBF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EBD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EBB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EB9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1E13",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1E0D",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u04E9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u04AB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0454",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03CC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03C6",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03C3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03C2",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03B5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03B1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03AD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03AC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u01DD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u01A1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0153",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0151",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u014F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u014D",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u011B",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0119",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0117",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0115",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0113",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0111",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u010F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u010D",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u010B",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0107",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF8",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF6",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF4",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF2",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xEB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xEA",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xE9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xE8",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xE7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "q",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "o",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "e",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "d",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "c",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\uE001",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EE3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EE1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EDF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EDD",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EDB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ED9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ED7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ED5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ED3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ED1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ECF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ECD",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EC7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EC5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EC3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EC1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EBF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EBD",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EBB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EB9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1E13",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1E0D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u04E9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0454",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03CC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03C6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03C3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03C2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03B5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03B1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03AD",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03AC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u01DD",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u01A1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0153",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0151",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u014F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u014D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u011B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0119",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0117",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0115",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0113",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0111",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u010F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u010D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u010B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0107",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xEB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xEA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xE9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xE8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xE7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "q",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "o",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "e",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "d",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "c",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\uE001",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EE3",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EE1",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EDF",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EDD",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EDB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ED9",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ED7",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ED5",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ED3",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ED1",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ECF",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ECD",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EC7",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EC5",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EC3",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EC1",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EBF",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EBD",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EBB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EB9",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1E13",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1E0D",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u04E9",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u04AB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0499",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0454",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u044D",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0437",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03CE",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03CC",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03CA",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03C9",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03C6",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03C3",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03C2",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03B9",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03B5",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03B1",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03AF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03AD",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03AC",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u01DD",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u01A1",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0153",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0151",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u014F",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u014D",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u011B",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0119",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0117",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0115",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0113",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0111",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u010F",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u010D",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u010B",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0107",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF8",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF6",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF5",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF4",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF3",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF2",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF0",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xEB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xEA",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xE9",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xE8",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xE7",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "q",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "o",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "e",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "d",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "c",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03BB",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C9",
    u2: "\u03C7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C9",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CA",
    u2: "\u03C7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CE",
    u2: "\u03C7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CE",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\uE005",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u042F",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0427",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "?",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\uE005",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u042F",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0427",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "?",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u03A6",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "f",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "J",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "&",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EB6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EB4",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EB2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EB0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EAE",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EAC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EAA",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EA8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EA6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EA4",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EA2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EA0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1E6C",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0513",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04B2",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04A0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0496",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0459",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u043B",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0434",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042A",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0416",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0402",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u039B",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0394",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0164",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0162",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0104",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0102",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0100",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\xC6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\xC5",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\xC4",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\xC2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\xC1",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "X",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "T",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "A",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0427",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0427",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u03A6",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "J",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "?",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0427",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u03C7",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u03B8",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u03B6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u03A8",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u03A6",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "3",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "&",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0427",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u03A6",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "J",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "?",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0427",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u03A6",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "J",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "?",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\uE005",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u042F",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0427",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "?",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\uE005",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u042F",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0427",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "?",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0513",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0459",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u043B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0434",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u2026",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u201E",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u201D",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u201C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u201A",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u2019",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u2018",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u1E85",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u1E83",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u1E81",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0513",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04B3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04A1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0497",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0459",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u044A",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0442",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u043B",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0436",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0434",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u03C4",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u03B3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0175",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "x",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "w",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "v",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: ".",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: ",",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "'",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\"",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0447",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "?",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "/",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u03C1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u03BB",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "/",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0447",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0431",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "&",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u03C1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u03BB",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "/",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0447",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0431",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0447",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0431",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u03C1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u03BB",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "/",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u03C7",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "?",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u03C1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u03BB",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "/",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0427",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u03A6",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "J",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "?",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0447",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0431",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0427",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u03A6",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "J",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "?",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0447",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0431",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "\u03A6",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "f",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "J",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "&",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A2",
    u2: "\u0427",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A2",
    u2: "\u03A6",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A2",
    u2: "J",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A2",
    u2: "?",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A2",
    u2: "3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u0447",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u0431",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u03C7",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "?",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0427",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u03A6",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "J",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "?",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0447",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0431",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B6",
    u2: "\u0427",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B6",
    u2: "\u03A6",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B6",
    u2: "J",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B6",
    u2: "?",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B6",
    u2: "3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u0447",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u0431",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E12",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E12",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E12",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E12",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E25",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E25",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E3C",
    u2: "V",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E3C",
    u2: "J",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E3C",
    u2: "?",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E3C",
    u2: "&",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E45",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E45",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E4B",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E4B",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "V",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5B",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5B",
    u2: "/",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "\uE005",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "\u0427",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "f",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "V",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "?",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "/",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E63",
    u2: "f",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E63",
    u2: "?",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E63",
    u2: "/",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E63",
    u2: "&",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u042F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u03C7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u03C1",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u03BB",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u03B8",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u03B6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u03A9",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u03A6",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "f",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "J",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "?",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "/",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "\u03BB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "f",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "/",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "f",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "J",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "?",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "/",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "&",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: "\u03C1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: "\u03BB",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: "/",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "f",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "J",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "?",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "/",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "&",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: "\u03C1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: "\u03BB",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: "/",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "f",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "J",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "?",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "/",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "&",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E85",
    u2: "\u03C1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E85",
    u2: "\u03BB",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E85",
    u2: "/",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E92",
    u2: "\u03C7",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E92",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E92",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E92",
    u2: "?",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E92",
    u2: "&",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u201D",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u201C",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u2019",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u2018",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EF6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EF2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EB6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EB4",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EB2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EB0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EAE",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EAC",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EAA",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EA8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EA6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EA4",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EA2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EA0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1E84",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1E82",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1E80",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1E6C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u04B2",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u04A0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0496",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u042A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0416",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u040B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0402",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u039B",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0394",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0178",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0176",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0174",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0164",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0162",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0104",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0102",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0100",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xDD",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xC6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xC5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xC4",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xC2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xC1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "Y",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "X",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "W",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "T",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "A",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "'",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\"",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "V",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\u0427",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\u03C7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\u03C0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\u03A8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\u03A6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "f",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "?",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "&",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA1",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA1",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\u0427",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\u03C7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\u03C0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\u03A8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\u03A6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "f",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "?",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "&",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA3",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA3",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\u0427",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\u03C7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\u03C0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\u03A8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\u03A6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "f",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "?",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "&",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA5",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA5",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\u0427",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\u03C7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\u03C0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\u03A8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\u03A6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "f",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "?",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "&",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA7",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA7",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\u0427",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\u03C7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\u03C0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\u03A8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\u03A6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "f",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "?",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "&",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA9",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA9",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\u0427",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\u03C7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\u03C0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\u03A8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\u03A6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "f",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "?",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "&",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAB",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAB",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\u0427",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\u03C7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\u03C0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\u03A8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\u03A6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "f",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "?",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "&",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAD",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAD",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\u0427",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\u03C7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\u03C0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\u03A8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\u03A6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "f",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "?",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "&",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAF",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAF",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\u0427",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\u03C7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\u03C0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\u03A8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\u03A6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "f",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "?",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "&",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB1",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB1",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\u0427",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\u03C7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\u03C0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\u03A8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\u03A6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "f",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "?",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "&",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB3",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB3",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\u0427",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\u03C7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\u03C0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\u03A8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\u03A6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "f",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "?",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "&",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB5",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB5",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\u0427",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\u03C7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\u03C0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\u03A8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\u03A6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "f",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "?",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "&",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB7",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB7",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "\uE005",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "\u03C7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "\u03BB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE6",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u042F",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03C7",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03C1",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03BB",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03B8",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03B6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03A9",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "J",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "?",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "/",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "&",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u042F",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03C7",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03C1",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03BB",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03B8",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03B6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03A9",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "J",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "?",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "/",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "&",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\uE005",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u042F",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0427",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "f",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "J",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "7",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "4",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "3",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "1",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "/",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "&",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\uE005",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u042F",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0427",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "f",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "J",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "7",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "4",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "3",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "1",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "/",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "&",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "J",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "4",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "J",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "4",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0427",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u03C0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "f",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "V",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "J",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "9",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "8",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "J",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "4",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "J",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "4",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0427",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u03C0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "f",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "V",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "J",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "9",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "8",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\u0427",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\u03C0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "f",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "V",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "J",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "9",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "8",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "V",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u042F",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0427",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "f",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "J",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE002",
    u2: "V",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE003",
    u2: "\u042F",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE003",
    u2: "\u0427",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE003",
    u2: "f",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE003",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE003",
    u2: "J",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u042F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u03C7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u03C1",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u03BB",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u03B8",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u03B6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u03A9",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u03A6",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "f",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "J",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "?",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "/",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    g2: "psi",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\uE004",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\uE001",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\uE000",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u2026",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u201E",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u201A",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u2014",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u2013",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EF7",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EF3",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EF1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EEF",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EED",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EEB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE5",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE3",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE1",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDF",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDD",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDC",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDB",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDA",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED9",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED7",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED5",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED3",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED1",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ECF",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ECE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ECD",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ECC",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EC7",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EC5",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EC3",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EC1",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EBF",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EBD",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EBB",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB9",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB6",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB4",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB2",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB0",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EAE",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EAC",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EAA",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA8",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA6",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA4",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA2",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA0",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E93",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E85",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E83",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E81",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E63",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E62",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E5B",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E4B",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E45",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E13",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E0D",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0512",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04EF",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04E9",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04E8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04C8",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04C4",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04B3",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04AB",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04AA",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04A3",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04A1",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u049B",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0498",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0497",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0491",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u045F",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u045E",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u045D",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u045C",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u045A",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0454",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0453",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u044E",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u044C",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u044B",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u044A",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0449",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0448",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0446",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0442",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u043F",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u043D",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u043C",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0439",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0438",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0436",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0433",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0432",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u042D",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u041B",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0414",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0409",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0404",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03CD",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03CC",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03C6",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03C5",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03C4",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03C3",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03C2",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03BA",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03B7",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03B5",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03B3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03B1",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03AE",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03AD",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03AC",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u039B",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0398",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0394",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0272",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01F9",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01F5",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01F4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01E7",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01E6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01DD",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01B0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01A1",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01A0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u018F",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u017E",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u017C",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u017A",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0177",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0175",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0173",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0171",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u016F",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u016D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u016B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0169",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0161",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0160",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u015F",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u015E",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u015B",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u015A",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0159",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0157",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0155",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0153",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0152",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0151",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0150",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u014F",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u014E",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u014D",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u014C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u014B",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0148",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0146",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0144",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0123",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0122",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0121",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0120",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u011F",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u011E",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u011B",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0119",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0117",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0115",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0113",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0111",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u010F",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u010D",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u010C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u010B",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u010A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0107",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0106",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0104",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0102",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0100",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xFD",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xFC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xFB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xFA",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF8",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF6",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF5",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF4",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF3",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF2",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF1",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF0",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xEB",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xEA",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE9",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE8",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE7",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC6",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC5",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC4",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC2",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC1",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "z",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "y",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "x",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "w",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "v",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "u",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "s",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "r",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "q",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "p",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "o",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "n",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "m",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "g",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "e",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "d",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "c",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "S",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "Q",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "O",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "G",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "A",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: ".",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "-",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: ",",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u042F",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "J",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "hyphen,endash,emdash",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "uni042D,uni0498",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "iotatonos,iota,iotadieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "omega,omegatonos",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "Alphatonos,Epsilontonos,Etatonos,Iotatonos,Omicrontonos,Upsilontonos,Omegatonos",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent,uni01E6,uni01F4",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent,uni01E6,uni01F4",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent,uni01E6,uni01F4",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent,uni01E6,uni01F4",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "hyphen,endash,emdash",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "uni042D,uni0498",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "iotatonos,iota,iotadieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "hyphen,endash,emdash",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "hyphen,endash,emdash",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "j,dotlessj",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "hyphen,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "hyphen,endash,emdash",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "uni042D,uni0498",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "iotatonos,iota,iotadieresis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "omega,omegatonos",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "j,dotlessj",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,uni01F9,uni0272,etatonos,eta,uni043A,uni0432,uni0433,uni0438,uni0439,uni043C,uni043D,uni043F,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni04A3,uni04C4,uni04C8,uni1E45,uni1E4B,uni1E5B",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "hyphen,endash,emdash",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "j,dotlessj",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,uni01F9,uni0272,etatonos,eta,uni043A,uni0432,uni0433,uni0438,uni0439,uni043C,uni043D,uni043F,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni04A3,uni04C4,uni04C8,uni1E45,uni1E4B,uni1E5B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "hyphen,endash,emdash",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "uni042D,uni0498",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "iotatonos,iota,iotadieresis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "omega,omegatonos",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "hyphen,endash,emdash",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "uni042D,uni0498",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "iotatonos,iota,iotadieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "omega,omegatonos",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,uni01F9,uni0272,etatonos,eta,uni043A,uni0432,uni0433,uni0438,uni0439,uni043C,uni043D,uni043F,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni04A3,uni04C4,uni04C8,uni1E45,uni1E4B,uni1E5B",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "uni0437,uni044D,uni0499",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "hyphen,endash,emdash",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "iotatonos,iota,iotadieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "omega,omegatonos",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "uni0437,uni044D,uni0499",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "hyphen,endash,emdash",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "j,dotlessj",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: -2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j,ij,dotlessj",
    g2: "j,dotlessj",
    k: -158
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "hyphen,endash,emdash",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "j,dotlessj",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "uni0437,uni044D,uni0499",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hbar,nacute,ncommaaccent,ncaron,eng,uni01F9,uni0272,uni0452,uni1E25,uni1E45,uni1E4B,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hbar,nacute,ncommaaccent,ncaron,eng,uni01F9,uni0272,uni0452,uni1E25,uni1E45,uni1E4B,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hbar,nacute,ncommaaccent,ncaron,eng,uni01F9,uni0272,uni0452,uni1E25,uni1E45,uni1E4B,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hbar,nacute,ncommaaccent,ncaron,eng,uni01F9,uni0272,uni0452,uni1E25,uni1E45,uni1E4B,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    g2: "j,dotlessj",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "hyphen,endash,emdash",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tbar,uni1E6D",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tbar,uni1E6D",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tbar,uni1E6D",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tbar,uni1E6D",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "hyphen,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "omega,omegatonos",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "hyphen,endash,emdash",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "omega,omegatonos",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "uni0437,uni044D,uni0499",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni1E93",
    g2: "hyphen,endash,emdash",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni1E93",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni1E93",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "hyphen,endash,emdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "uni042D,uni0498",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "j,dotlessj",
    k: -167
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449,uni0497,uni049B,uni04A3,uni04B3,uni04B7",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449,uni0497,uni049B,uni04A3,uni04B3,uni04B7",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449,uni0497,uni049B,uni04A3,uni04B3,uni04B7",
    g2: "uni0437,uni044D,uni0499",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "hyphen,endash,emdash",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437,uni0499",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437,uni0499",
    g2: "uni0437,uni044D,uni0499",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "omega,omegatonos",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "omega,omegatonos",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "omega,omegatonos",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Omegatonos,Omega",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Omegatonos,Omega",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "hyphen,endash,emdash",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "omega,omegatonos",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "alphatonos,iotatonos,alpha,iota,iotadieresis",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "alphatonos,iotatonos,alpha,iota,iotadieresis",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "alphatonos,iotatonos,alpha,iota,iotadieresis",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "alphatonos,iotatonos,alpha,iota,iotadieresis",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "alphatonos,iotatonos,alpha,iota,iotadieresis",
    g2: "iotatonos,iota,iotadieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "j,dotlessj",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni042D,uni0498",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "j,dotlessj",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "hyphen,endash,emdash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "uni042D,uni0498",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "j,dotlessj",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "j,dotlessj",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "uni042D,uni0498",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 45
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoolveticaCondensedRgRegular);
export default __webpack_public_path__ + "static/media/CoolveticaCondensedRg-Regular.9441ac5ef568c9cbe75bd334ee9aee92.svg";
export { ForwardRef as ReactComponent };